/*!
 * Bootstrap v3.3.6 (http://getbootstrap.com)
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under the MIT license
 */
if ("undefined" == typeof jQuery) throw new Error("Bootstrap's JavaScript requires jQuery"); + function(a) {
	"use strict";
	var b = a.fn.jquery.split(" ")[0].split(".");
	if (b[0] < 2 && b[1] < 9 || 1 == b[0] && 9 == b[1] && b[2] < 1 || b[0] > 2) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 3")
}(jQuery), + function(a) {
	"use strict";

	function b() {
		var a = document.createElement("bootstrap"),
			b = {
				WebkitTransition: "webkitTransitionEnd",
				MozTransition: "transitionend",
				OTransition: "oTransitionEnd otransitionend",
				transition: "transitionend"
			};
		for (var c in b)
			if (void 0 !== a.style[c]) return {
				end: b[c]
			};
		return !1
	}
	a.fn.emulateTransitionEnd = function(b) {
		var c = !1,
			d = this;
		a(this).one("bsTransitionEnd", function() {
			c = !0
		});
		var e = function() {
			c || a(d).trigger(a.support.transition.end)
		};
		return setTimeout(e, b), this
	}, a(function() {
		a.support.transition = b(), a.support.transition && (a.event.special.bsTransitionEnd = {
			bindType: a.support.transition.end,
			delegateType: a.support.transition.end,
			handle: function(b) {
				return a(b.target).is(this) ? b.handleObj.handler.apply(this, arguments) : void 0
			}
		})
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var c = a(this),
				e = c.data("bs.alert");
			e || c.data("bs.alert", e = new d(this)), "string" == typeof b && e[b].call(c)
		})
	}
	var c = '[data-dismiss="alert"]',
		d = function(b) {
			a(b).on("click", c, this.close)
		};
	d.VERSION = "3.3.6", d.TRANSITION_DURATION = 150, d.prototype.close = function(b) {
		function c() {
			g.detach().trigger("closed.bs.alert").remove()
		}
		var e = a(this),
			f = e.attr("data-target");
		f || (f = e.attr("href"), f = f && f.replace(/.*(?=#[^\s]*$)/, ""));
		var g = a(f);
		b && b.preventDefault(), g.length || (g = e.closest(".alert")), g.trigger(b = a.Event("close.bs.alert")), b.isDefaultPrevented() || (g.removeClass("in"), a.support.transition && g.hasClass("fade") ? g.one("bsTransitionEnd", c).emulateTransitionEnd(d.TRANSITION_DURATION) : c())
	};
	var e = a.fn.alert;
	a.fn.alert = b, a.fn.alert.Constructor = d, a.fn.alert.noConflict = function() {
		return a.fn.alert = e, this
	}, a(document).on("click.bs.alert.data-api", c, d.prototype.close)
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.button"),
				f = "object" == typeof b && b;
			e || d.data("bs.button", e = new c(this, f)), "toggle" == b ? e.toggle() : b && e.setState(b)
		})
	}
	var c = function(b, d) {
		this.$element = a(b), this.options = a.extend({}, c.DEFAULTS, d), this.isLoading = !1
	};
	c.VERSION = "3.3.6", c.DEFAULTS = {
		loadingText: "loading..."
	}, c.prototype.setState = function(b) {
		var c = "disabled",
			d = this.$element,
			e = d.is("input") ? "val" : "html",
			f = d.data();
		b += "Text", null == f.resetText && d.data("resetText", d[e]()), setTimeout(a.proxy(function() {
			d[e](null == f[b] ? this.options[b] : f[b]), "loadingText" == b ? (this.isLoading = !0, d.addClass(c).attr(c, c)) : this.isLoading && (this.isLoading = !1, d.removeClass(c).removeAttr(c))
		}, this), 0)
	}, c.prototype.toggle = function() {
		var a = !0,
			b = this.$element.closest('[data-toggle="buttons"]');
		if (b.length) {
			var c = this.$element.find("input");
			"radio" == c.prop("type") ? (c.prop("checked") && (a = !1), b.find(".active").removeClass("active"), this.$element.addClass("active")) : "checkbox" == c.prop("type") && (c.prop("checked") !== this.$element.hasClass("active") && (a = !1), this.$element.toggleClass("active")), c.prop("checked", this.$element.hasClass("active")), a && c.trigger("change")
		} else this.$element.attr("aria-pressed", !this.$element.hasClass("active")), this.$element.toggleClass("active")
	};
	var d = a.fn.button;
	a.fn.button = b, a.fn.button.Constructor = c, a.fn.button.noConflict = function() {
		return a.fn.button = d, this
	}, a(document).on("click.bs.button.data-api", '[data-toggle^="button"]', function(c) {
		var d = a(c.target);
		d.hasClass("btn") || (d = d.closest(".btn")), b.call(d, "toggle"), a(c.target).is('input[type="radio"]') || a(c.target).is('input[type="checkbox"]') || c.preventDefault()
	}).on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', function(b) {
		a(b.target).closest(".btn").toggleClass("focus", /^focus(in)?$/.test(b.type))
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.carousel"),
				f = a.extend({}, c.DEFAULTS, d.data(), "object" == typeof b && b),
				g = "string" == typeof b ? b : f.slide;
			e || d.data("bs.carousel", e = new c(this, f)), "number" == typeof b ? e.to(b) : g ? e[g]() : f.interval && e.pause().cycle()
		})
	}
	var c = function(b, c) {
		this.$element = a(b), this.$indicators = this.$element.find(".carousel-indicators"), this.options = c, this.paused = null, this.sliding = null, this.interval = null, this.$active = null, this.$items = null, this.options.keyboard && this.$element.on("keydown.bs.carousel", a.proxy(this.keydown, this)), "hover" == this.options.pause && !("ontouchstart" in document.documentElement) && this.$element.on("mouseenter.bs.carousel", a.proxy(this.pause, this)).on("mouseleave.bs.carousel", a.proxy(this.cycle, this))
	};
	c.VERSION = "3.3.6", c.TRANSITION_DURATION = 600, c.DEFAULTS = {
		interval: 5e3,
		pause: "hover",
		wrap: !0,
		keyboard: !0
	}, c.prototype.keydown = function(a) {
		if (!/input|textarea/i.test(a.target.tagName)) {
			switch (a.which) {
				case 37:
					this.prev();
					break;
				case 39:
					this.next();
					break;
				default:
					return
			}
			a.preventDefault()
		}
	}, c.prototype.cycle = function(b) {
		return b || (this.paused = !1), this.interval && clearInterval(this.interval), this.options.interval && !this.paused && (this.interval = setInterval(a.proxy(this.next, this), this.options.interval)), this
	}, c.prototype.getItemIndex = function(a) {
		return this.$items = a.parent().children(".item"), this.$items.index(a || this.$active)
	}, c.prototype.getItemForDirection = function(a, b) {
		var c = this.getItemIndex(b),
			d = "prev" == a && 0 === c || "next" == a && c == this.$items.length - 1;
		if (d && !this.options.wrap) return b;
		var e = "prev" == a ? -1 : 1,
			f = (c + e) % this.$items.length;
		return this.$items.eq(f)
	}, c.prototype.to = function(a) {
		var b = this,
			c = this.getItemIndex(this.$active = this.$element.find(".item.active"));
		return a > this.$items.length - 1 || 0 > a ? void 0 : this.sliding ? this.$element.one("slid.bs.carousel", function() {
			b.to(a)
		}) : c == a ? this.pause().cycle() : this.slide(a > c ? "next" : "prev", this.$items.eq(a))
	}, c.prototype.pause = function(b) {
		return b || (this.paused = !0), this.$element.find(".next, .prev").length && a.support.transition && (this.$element.trigger(a.support.transition.end), this.cycle(!0)), this.interval = clearInterval(this.interval), this
	}, c.prototype.next = function() {
		return this.sliding ? void 0 : this.slide("next")
	}, c.prototype.prev = function() {
		return this.sliding ? void 0 : this.slide("prev")
	}, c.prototype.slide = function(b, d) {
		var e = this.$element.find(".item.active"),
			f = d || this.getItemForDirection(b, e),
			g = this.interval,
			h = "next" == b ? "left" : "right",
			i = this;
		if (f.hasClass("active")) return this.sliding = !1;
		var j = f[0],
			k = a.Event("slide.bs.carousel", {
				relatedTarget: j,
				direction: h
			});
		if (this.$element.trigger(k), !k.isDefaultPrevented()) {
			if (this.sliding = !0, g && this.pause(), this.$indicators.length) {
				this.$indicators.find(".active").removeClass("active");
				var l = a(this.$indicators.children()[this.getItemIndex(f)]);
				l && l.addClass("active")
			}
			var m = a.Event("slid.bs.carousel", {
				relatedTarget: j,
				direction: h
			});
			return a.support.transition && this.$element.hasClass("slide") ? (f.addClass(b), f[0].offsetWidth, e.addClass(h), f.addClass(h), e.one("bsTransitionEnd", function() {
				f.removeClass([b, h].join(" ")).addClass("active"), e.removeClass(["active", h].join(" ")), i.sliding = !1, setTimeout(function() {
					i.$element.trigger(m)
				}, 0)
			}).emulateTransitionEnd(c.TRANSITION_DURATION)) : (e.removeClass("active"), f.addClass("active"), this.sliding = !1, this.$element.trigger(m)), g && this.cycle(), this
		}
	};
	var d = a.fn.carousel;
	a.fn.carousel = b, a.fn.carousel.Constructor = c, a.fn.carousel.noConflict = function() {
		return a.fn.carousel = d, this
	};
	var e = function(c) {
		var d, e = a(this),
			f = a(e.attr("data-target") || (d = e.attr("href")) && d.replace(/.*(?=#[^\s]+$)/, ""));
		if (f.hasClass("carousel")) {
			var g = a.extend({}, f.data(), e.data()),
				h = e.attr("data-slide-to");
			h && (g.interval = !1), b.call(f, g), h && f.data("bs.carousel").to(h), c.preventDefault()
		}
	};
	a(document).on("click.bs.carousel.data-api", "[data-slide]", e).on("click.bs.carousel.data-api", "[data-slide-to]", e), a(window).on("load", function() {
		a('[data-ride="carousel"]').each(function() {
			var c = a(this);
			b.call(c, c.data())
		})
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		var c, d = b.attr("data-target") || (c = b.attr("href")) && c.replace(/.*(?=#[^\s]+$)/, "");
		return a(d)
	}

	function c(b) {
		return this.each(function() {
			var c = a(this),
				e = c.data("bs.collapse"),
				f = a.extend({}, d.DEFAULTS, c.data(), "object" == typeof b && b);
			!e && f.toggle && /show|hide/.test(b) && (f.toggle = !1), e || c.data("bs.collapse", e = new d(this, f)), "string" == typeof b && e[b]()
		})
	}
	var d = function(b, c) {
		this.$element = a(b), this.options = a.extend({}, d.DEFAULTS, c), this.$trigger = a('[data-toggle="collapse"][href="#' + b.id + '"],[data-toggle="collapse"][data-target="#' + b.id + '"]'), this.transitioning = null, this.options.parent ? this.$parent = this.getParent() : this.addAriaAndCollapsedClass(this.$element, this.$trigger), this.options.toggle && this.toggle()
	};
	d.VERSION = "3.3.6", d.TRANSITION_DURATION = 350, d.DEFAULTS = {
		toggle: !0
	}, d.prototype.dimension = function() {
		var a = this.$element.hasClass("width");
		return a ? "width" : "height"
	}, d.prototype.show = function() {
		if (!this.transitioning && !this.$element.hasClass("in")) {
			var b, e = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");
			if (!(e && e.length && (b = e.data("bs.collapse"), b && b.transitioning))) {
				var f = a.Event("show.bs.collapse");
				if (this.$element.trigger(f), !f.isDefaultPrevented()) {
					e && e.length && (c.call(e, "hide"), b || e.data("bs.collapse", null));
					var g = this.dimension();
					this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded", !0), this.$trigger.removeClass("collapsed").attr("aria-expanded", !0), this.transitioning = 1;
					var h = function() {
						this.$element.removeClass("collapsing").addClass("collapse in")[g](""), this.transitioning = 0, this.$element.trigger("shown.bs.collapse")
					};
					if (!a.support.transition) return h.call(this);
					var i = a.camelCase(["scroll", g].join("-"));
					this.$element.one("bsTransitionEnd", a.proxy(h, this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])
				}
			}
		}
	}, d.prototype.hide = function() {
		if (!this.transitioning && this.$element.hasClass("in")) {
			var b = a.Event("hide.bs.collapse");
			if (this.$element.trigger(b), !b.isDefaultPrevented()) {
				var c = this.dimension();
				this.$element[c](this.$element[c]())[0].offsetHeight, this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", !1), this.$trigger.addClass("collapsed").attr("aria-expanded", !1), this.transitioning = 1;
				var e = function() {
					this.transitioning = 0, this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")
				};
				return a.support.transition ? void this.$element[c](0).one("bsTransitionEnd", a.proxy(e, this)).emulateTransitionEnd(d.TRANSITION_DURATION) : e.call(this)
			}
		}
	}, d.prototype.toggle = function() {
		this[this.$element.hasClass("in") ? "hide" : "show"]()
	}, d.prototype.getParent = function() {
		return a(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each(a.proxy(function(c, d) {
			var e = a(d);
			this.addAriaAndCollapsedClass(b(e), e)
		}, this)).end()
	}, d.prototype.addAriaAndCollapsedClass = function(a, b) {
		var c = a.hasClass("in");
		a.attr("aria-expanded", c), b.toggleClass("collapsed", !c).attr("aria-expanded", c)
	};
	var e = a.fn.collapse;
	a.fn.collapse = c, a.fn.collapse.Constructor = d, a.fn.collapse.noConflict = function() {
		return a.fn.collapse = e, this
	}, a(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function(d) {
		var e = a(this);
		e.attr("data-target") || d.preventDefault();
		var f = b(e),
			g = f.data("bs.collapse"),
			h = g ? "toggle" : e.data();
		c.call(f, h)
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		var c = b.attr("data-target");
		c || (c = b.attr("href"), c = c && /#[A-Za-z]/.test(c) && c.replace(/.*(?=#[^\s]*$)/, ""));
		var d = c && a(c);
		return d && d.length ? d : b.parent()
	}

	function c(c) {
		c && 3 === c.which || (a(e).remove(), a(f).each(function() {
			var d = a(this),
				e = b(d),
				f = {
					relatedTarget: this
				};
			e.hasClass("open") && (c && "click" == c.type && /input|textarea/i.test(c.target.tagName) && a.contains(e[0], c.target) || (e.trigger(c = a.Event("hide.bs.dropdown", f)), c.isDefaultPrevented() || (d.attr("aria-expanded", "false"), e.removeClass("open").trigger(a.Event("hidden.bs.dropdown", f)))))
		}))
	}

	function d(b) {
		return this.each(function() {
			var c = a(this),
				d = c.data("bs.dropdown");
			d || c.data("bs.dropdown", d = new g(this)), "string" == typeof b && d[b].call(c)
		})
	}
	var e = ".dropdown-backdrop",
		f = '[data-toggle="dropdown"]',
		g = function(b) {
			a(b).on("click.bs.dropdown", this.toggle)
		};
	g.VERSION = "3.3.6", g.prototype.toggle = function(d) {
		var e = a(this);
		if (!e.is(".disabled, :disabled")) {
			var f = b(e),
				g = f.hasClass("open");
			if (c(), !g) {
				"ontouchstart" in document.documentElement && !f.closest(".navbar-nav").length && a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click", c);
				var h = {
					relatedTarget: this
				};
				if (f.trigger(d = a.Event("show.bs.dropdown", h)), d.isDefaultPrevented()) return;
				e.trigger("focus").attr("aria-expanded", "true"), f.toggleClass("open").trigger(a.Event("shown.bs.dropdown", h))
			}
			return !1
		}
	}, g.prototype.keydown = function(c) {
		if (/(38|40|27|32)/.test(c.which) && !/input|textarea/i.test(c.target.tagName)) {
			var d = a(this);
			if (c.preventDefault(), c.stopPropagation(), !d.is(".disabled, :disabled")) {
				var e = b(d),
					g = e.hasClass("open");
				if (!g && 27 != c.which || g && 27 == c.which) return 27 == c.which && e.find(f).trigger("focus"), d.trigger("click");
				var h = " li:not(.disabled):visible a",
					i = e.find(".dropdown-menu" + h);
				if (i.length) {
					var j = i.index(c.target);
					38 == c.which && j > 0 && j--, 40 == c.which && j < i.length - 1 && j++, ~j || (j = 0), i.eq(j).trigger("focus")
				}
			}
		}
	};
	var h = a.fn.dropdown;
	a.fn.dropdown = d, a.fn.dropdown.Constructor = g, a.fn.dropdown.noConflict = function() {
		return a.fn.dropdown = h, this
	}, a(document).on("click.bs.dropdown.data-api", c).on("click.bs.dropdown.data-api", ".dropdown form", function(a) {
		a.stopPropagation()
	}).on("click.bs.dropdown.data-api", f, g.prototype.toggle).on("keydown.bs.dropdown.data-api", f, g.prototype.keydown).on("keydown.bs.dropdown.data-api", ".dropdown-menu", g.prototype.keydown)
}(jQuery), + function(a) {
	"use strict";

	function b(b, d) {
		return this.each(function() {
			var e = a(this),
				f = e.data("bs.modal"),
				g = a.extend({}, c.DEFAULTS, e.data(), "object" == typeof b && b);
			f || e.data("bs.modal", f = new c(this, g)), "string" == typeof b ? f[b](d) : g.show && f.show(d)
		})
	}
	var c = function(b, c) {
		this.options = c, this.$body = a(document.body), this.$element = a(b), this.$dialog = this.$element.find(".modal-dialog"), this.$backdrop = null, this.isShown = null, this.originalBodyPad = null, this.scrollbarWidth = 0, this.ignoreBackdropClick = !1, this.options.remote && this.$element.find(".modal-content").load(this.options.remote, a.proxy(function() {
			this.$element.trigger("loaded.bs.modal")
		}, this))
	};
	c.VERSION = "3.3.6", c.TRANSITION_DURATION = 300, c.BACKDROP_TRANSITION_DURATION = 150, c.DEFAULTS = {
		backdrop: !0,
		keyboard: !0,
		show: !0
	}, c.prototype.toggle = function(a) {
		return this.isShown ? this.hide() : this.show(a)
	}, c.prototype.show = function(b) {
		var d = this,
			e = a.Event("show.bs.modal", {
				relatedTarget: b
			});
		this.$element.trigger(e), this.isShown || e.isDefaultPrevented() || (this.isShown = !0, this.checkScrollbar(), this.setScrollbar(), this.$body.addClass("modal-open"), this.escape(), this.resize(), this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', a.proxy(this.hide, this)), this.$dialog.on("mousedown.dismiss.bs.modal", function() {
			d.$element.one("mouseup.dismiss.bs.modal", function(b) {
				a(b.target).is(d.$element) && (d.ignoreBackdropClick = !0)
			})
		}), this.backdrop(function() {
			var e = a.support.transition && d.$element.hasClass("fade");
			d.$element.parent().length || d.$element.appendTo(d.$body), d.$element.show().scrollTop(0), d.adjustDialog(), e && d.$element[0].offsetWidth, d.$element.addClass("in"), d.enforceFocus();
			var f = a.Event("shown.bs.modal", {
				relatedTarget: b
			});
			e ? d.$dialog.one("bsTransitionEnd", function() {
				d.$element.trigger("focus").trigger(f)
			}).emulateTransitionEnd(c.TRANSITION_DURATION) : d.$element.trigger("focus").trigger(f)
		}))
	}, c.prototype.hide = function(b) {
		b && b.preventDefault(), b = a.Event("hide.bs.modal"), this.$element.trigger(b), this.isShown && !b.isDefaultPrevented() && (this.isShown = !1, this.escape(), this.resize(), a(document).off("focusin.bs.modal"), this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"), this.$dialog.off("mousedown.dismiss.bs.modal"), a.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", a.proxy(this.hideModal, this)).emulateTransitionEnd(c.TRANSITION_DURATION) : this.hideModal())
	}, c.prototype.enforceFocus = function() {
		a(document).off("focusin.bs.modal").on("focusin.bs.modal", a.proxy(function(a) {
			this.$element[0] === a.target || this.$element.has(a.target).length || this.$element.trigger("focus")
		}, this))
	}, c.prototype.escape = function() {
		this.isShown && this.options.keyboard ? this.$element.on("keydown.dismiss.bs.modal", a.proxy(function(a) {
			27 == a.which && this.hide()
		}, this)) : this.isShown || this.$element.off("keydown.dismiss.bs.modal")
	}, c.prototype.resize = function() {
		this.isShown ? a(window).on("resize.bs.modal", a.proxy(this.handleUpdate, this)) : a(window).off("resize.bs.modal")
	}, c.prototype.hideModal = function() {
		var a = this;
		this.$element.hide(), this.backdrop(function() {
			a.$body.removeClass("modal-open"), a.resetAdjustments(), a.resetScrollbar(), a.$element.trigger("hidden.bs.modal")
		})
	}, c.prototype.removeBackdrop = function() {
		this.$backdrop && this.$backdrop.remove(), this.$backdrop = null
	}, c.prototype.backdrop = function(b) {
		var d = this,
			e = this.$element.hasClass("fade") ? "fade" : "";
		if (this.isShown && this.options.backdrop) {
			var f = a.support.transition && e;
			if (this.$backdrop = a(document.createElement("div")).addClass("modal-backdrop " + e).appendTo(this.$body), this.$element.on("click.dismiss.bs.modal", a.proxy(function(a) {
					return this.ignoreBackdropClick ? void(this.ignoreBackdropClick = !1) : void(a.target === a.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus() : this.hide()))
				}, this)), f && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"), !b) return;
			f ? this.$backdrop.one("bsTransitionEnd", b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : b()
		} else if (!this.isShown && this.$backdrop) {
			this.$backdrop.removeClass("in");
			var g = function() {
				d.removeBackdrop(), b && b()
			};
			a.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : g()
		} else b && b()
	}, c.prototype.handleUpdate = function() {
		this.adjustDialog()
	}, c.prototype.adjustDialog = function() {
		var a = this.$element[0].scrollHeight > document.documentElement.clientHeight;
		this.$element.css({
			paddingLeft: !this.bodyIsOverflowing && a ? this.scrollbarWidth : "",
			paddingRight: this.bodyIsOverflowing && !a ? this.scrollbarWidth : ""
		})
	}, c.prototype.resetAdjustments = function() {
		this.$element.css({
			paddingLeft: "",
			paddingRight: ""
		})
	}, c.prototype.checkScrollbar = function() {
		var a = window.innerWidth;
		if (!a) {
			var b = document.documentElement.getBoundingClientRect();
			a = b.right - Math.abs(b.left)
		}
		this.bodyIsOverflowing = document.body.clientWidth < a, this.scrollbarWidth = this.measureScrollbar()
	}, c.prototype.setScrollbar = function() {
		var a = parseInt(this.$body.css("padding-right") || 0, 10);
		this.originalBodyPad = document.body.style.paddingRight || "", this.bodyIsOverflowing && this.$body.css("padding-right", a + this.scrollbarWidth)
	}, c.prototype.resetScrollbar = function() {
		this.$body.css("padding-right", this.originalBodyPad)
	}, c.prototype.measureScrollbar = function() {
		var a = document.createElement("div");
		a.className = "modal-scrollbar-measure", this.$body.append(a);
		var b = a.offsetWidth - a.clientWidth;
		return this.$body[0].removeChild(a), b
	};
	var d = a.fn.modal;
	a.fn.modal = b, a.fn.modal.Constructor = c, a.fn.modal.noConflict = function() {
		return a.fn.modal = d, this
	}, a(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function(c) {
		var d = a(this),
			e = d.attr("href"),
			f = a(d.attr("data-target") || e && e.replace(/.*(?=#[^\s]+$)/, "")),
			g = f.data("bs.modal") ? "toggle" : a.extend({
				remote: !/#/.test(e) && e
			}, f.data(), d.data());
		d.is("a") && c.preventDefault(), f.one("show.bs.modal", function(a) {
			a.isDefaultPrevented() || f.one("hidden.bs.modal", function() {
				d.is(":visible") && d.trigger("focus")
			})
		}), b.call(f, g, this)
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.tooltip"),
				f = "object" == typeof b && b;
			(e || !/destroy|hide/.test(b)) && (e || d.data("bs.tooltip", e = new c(this, f)), "string" == typeof b && e[b]())
		})
	}
	var c = function(a, b) {
		this.type = null, this.options = null, this.enabled = null, this.timeout = null, this.hoverState = null, this.$element = null, this.inState = null, this.init("tooltip", a, b)
	};
	c.VERSION = "3.3.6", c.TRANSITION_DURATION = 150, c.DEFAULTS = {
		animation: !0,
		placement: "top",
		selector: !1,
		template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
		trigger: "hover focus",
		title: "",
		delay: 0,
		html: !1,
		container: !1,
		viewport: {
			selector: "body",
			padding: 0
		}
	}, c.prototype.init = function(b, c, d) {
		if (this.enabled = !0, this.type = b, this.$element = a(c), this.options = this.getOptions(d), this.$viewport = this.options.viewport && a(a.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport), this.inState = {
				click: !1,
				hover: !1,
				focus: !1
			}, this.$element[0] instanceof document.constructor && !this.options.selector) throw new Error("`selector` option must be specified when initializing " + this.type + " on the window.document object!");
		for (var e = this.options.trigger.split(" "), f = e.length; f--;) {
			var g = e[f];
			if ("click" == g) this.$element.on("click." + this.type, this.options.selector, a.proxy(this.toggle, this));
			else if ("manual" != g) {
				var h = "hover" == g ? "mouseenter" : "focusin",
					i = "hover" == g ? "mouseleave" : "focusout";
				this.$element.on(h + "." + this.type, this.options.selector, a.proxy(this.enter, this)), this.$element.on(i + "." + this.type, this.options.selector, a.proxy(this.leave, this))
			}
		}
		this.options.selector ? this._options = a.extend({}, this.options, {
			trigger: "manual",
			selector: ""
		}) : this.fixTitle()
	}, c.prototype.getDefaults = function() {
		return c.DEFAULTS
	}, c.prototype.getOptions = function(b) {
		return b = a.extend({}, this.getDefaults(), this.$element.data(), b), b.delay && "number" == typeof b.delay && (b.delay = {
			show: b.delay,
			hide: b.delay
		}), b
	}, c.prototype.getDelegateOptions = function() {
		var b = {},
			c = this.getDefaults();
		return this._options && a.each(this._options, function(a, d) {
			c[a] != d && (b[a] = d)
		}), b
	}, c.prototype.enter = function(b) {
		var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);
		return c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c)), b instanceof a.Event && (c.inState["focusin" == b.type ? "focus" : "hover"] = !0), c.tip().hasClass("in") || "in" == c.hoverState ? void(c.hoverState = "in") : (clearTimeout(c.timeout), c.hoverState = "in", c.options.delay && c.options.delay.show ? void(c.timeout = setTimeout(function() {
			"in" == c.hoverState && c.show()
		}, c.options.delay.show)) : c.show())
	}, c.prototype.isInStateTrue = function() {
		for (var a in this.inState)
			if (this.inState[a]) return !0;
		return !1
	}, c.prototype.leave = function(b) {
		var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);
		return c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c)), b instanceof a.Event && (c.inState["focusout" == b.type ? "focus" : "hover"] = !1), c.isInStateTrue() ? void 0 : (clearTimeout(c.timeout), c.hoverState = "out", c.options.delay && c.options.delay.hide ? void(c.timeout = setTimeout(function() {
			"out" == c.hoverState && c.hide()
		}, c.options.delay.hide)) : c.hide())
	}, c.prototype.show = function() {
		var b = a.Event("show.bs." + this.type);
		if (this.hasContent() && this.enabled) {
			this.$element.trigger(b);
			var d = a.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
			if (b.isDefaultPrevented() || !d) return;
			var e = this,
				f = this.tip(),
				g = this.getUID(this.type);
			this.setContent(), f.attr("id", g), this.$element.attr("aria-describedby", g), this.options.animation && f.addClass("fade");
			var h = "function" == typeof this.options.placement ? this.options.placement.call(this, f[0], this.$element[0]) : this.options.placement,
				i = /\s?auto?\s?/i,
				j = i.test(h);
			j && (h = h.replace(i, "") || "top"), f.detach().css({
				top: 0,
				left: 0,
				display: "block"
			}).addClass(h).data("bs." + this.type, this), this.options.container ? f.appendTo(this.options.container) : f.insertAfter(this.$element), this.$element.trigger("inserted.bs." + this.type);
			var k = this.getPosition(),
				l = f[0].offsetWidth,
				m = f[0].offsetHeight;
			if (j) {
				var n = h,
					o = this.getPosition(this.$viewport);
				h = "bottom" == h && k.bottom + m > o.bottom ? "top" : "top" == h && k.top - m < o.top ? "bottom" : "right" == h && k.right + l > o.width ? "left" : "left" == h && k.left - l < o.left ? "right" : h, f.removeClass(n).addClass(h)
			}
			var p = this.getCalculatedOffset(h, k, l, m);
			this.applyPlacement(p, h);
			var q = function() {
				var a = e.hoverState;
				e.$element.trigger("shown.bs." + e.type), e.hoverState = null, "out" == a && e.leave(e)
			};
			a.support.transition && this.$tip.hasClass("fade") ? f.one("bsTransitionEnd", q).emulateTransitionEnd(c.TRANSITION_DURATION) : q()
		}
	}, c.prototype.applyPlacement = function(b, c) {
		var d = this.tip(),
			e = d[0].offsetWidth,
			f = d[0].offsetHeight,
			g = parseInt(d.css("margin-top"), 10),
			h = parseInt(d.css("margin-left"), 10);
		isNaN(g) && (g = 0), isNaN(h) && (h = 0), b.top += g, b.left += h, a.offset.setOffset(d[0], a.extend({
			using: function(a) {
				d.css({
					top: Math.round(a.top),
					left: Math.round(a.left)
				})
			}
		}, b), 0), d.addClass("in");
		var i = d[0].offsetWidth,
			j = d[0].offsetHeight;
		"top" == c && j != f && (b.top = b.top + f - j);
		var k = this.getViewportAdjustedDelta(c, b, i, j);
		k.left ? b.left += k.left : b.top += k.top;
		var l = /top|bottom/.test(c),
			m = l ? 2 * k.left - e + i : 2 * k.top - f + j,
			n = l ? "offsetWidth" : "offsetHeight";
		d.offset(b), this.replaceArrow(m, d[0][n], l)
	}, c.prototype.replaceArrow = function(a, b, c) {
		this.arrow().css(c ? "left" : "top", 50 * (1 - a / b) + "%").css(c ? "top" : "left", "")
	}, c.prototype.setContent = function() {
		var a = this.tip(),
			b = this.getTitle();
		a.find(".tooltip-inner")[this.options.html ? "html" : "text"](b), a.removeClass("fade in top bottom left right")
	}, c.prototype.hide = function(b) {
		function d() {
			"in" != e.hoverState && f.detach(), e.$element.removeAttr("aria-describedby").trigger("hidden.bs." + e.type), b && b()
		}
		var e = this,
			f = a(this.$tip),
			g = a.Event("hide.bs." + this.type);
		return this.$element.trigger(g), g.isDefaultPrevented() ? void 0 : (f.removeClass("in"), a.support.transition && f.hasClass("fade") ? f.one("bsTransitionEnd", d).emulateTransitionEnd(c.TRANSITION_DURATION) : d(), this.hoverState = null, this)
	}, c.prototype.fixTitle = function() {
		var a = this.$element;
		(a.attr("title") || "string" != typeof a.attr("data-original-title")) && a.attr("data-original-title", a.attr("title") || "").attr("title", "")
	}, c.prototype.hasContent = function() {
		return this.getTitle()
	}, c.prototype.getPosition = function(b) {
		b = b || this.$element;
		var c = b[0],
			d = "BODY" == c.tagName,
			e = c.getBoundingClientRect();
		null == e.width && (e = a.extend({}, e, {
			width: e.right - e.left,
			height: e.bottom - e.top
		}));
		var f = d ? {
				top: 0,
				left: 0
			} : b.offset(),
			g = {
				scroll: d ? document.documentElement.scrollTop || document.body.scrollTop : b.scrollTop()
			},
			h = d ? {
				width: a(window).width(),
				height: a(window).height()
			} : null;
		return a.extend({}, e, g, h, f)
	}, c.prototype.getCalculatedOffset = function(a, b, c, d) {
		return "bottom" == a ? {
			top: b.top + b.height,
			left: b.left + b.width / 2 - c / 2
		} : "top" == a ? {
			top: b.top - d,
			left: b.left + b.width / 2 - c / 2
		} : "left" == a ? {
			top: b.top + b.height / 2 - d / 2,
			left: b.left - c
		} : {
			top: b.top + b.height / 2 - d / 2,
			left: b.left + b.width
		}
	}, c.prototype.getViewportAdjustedDelta = function(a, b, c, d) {
		var e = {
			top: 0,
			left: 0
		};
		if (!this.$viewport) return e;
		var f = this.options.viewport && this.options.viewport.padding || 0,
			g = this.getPosition(this.$viewport);
		if (/right|left/.test(a)) {
			var h = b.top - f - g.scroll,
				i = b.top + f - g.scroll + d;
			h < g.top ? e.top = g.top - h : i > g.top + g.height && (e.top = g.top + g.height - i)
		} else {
			var j = b.left - f,
				k = b.left + f + c;
			j < g.left ? e.left = g.left - j : k > g.right && (e.left = g.left + g.width - k)
		}
		return e
	}, c.prototype.getTitle = function() {
		var a, b = this.$element,
			c = this.options;
		return a = b.attr("data-original-title") || ("function" == typeof c.title ? c.title.call(b[0]) : c.title)
	}, c.prototype.getUID = function(a) {
		do a += ~~(1e6 * Math.random()); while (document.getElementById(a));
		return a
	}, c.prototype.tip = function() {
		if (!this.$tip && (this.$tip = a(this.options.template), 1 != this.$tip.length)) throw new Error(this.type + " `template` option must consist of exactly 1 top-level element!");
		return this.$tip
	}, c.prototype.arrow = function() {
		return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow")
	}, c.prototype.enable = function() {
		this.enabled = !0
	}, c.prototype.disable = function() {
		this.enabled = !1
	}, c.prototype.toggleEnabled = function() {
		this.enabled = !this.enabled
	}, c.prototype.toggle = function(b) {
		var c = this;
		b && (c = a(b.currentTarget).data("bs." + this.type), c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c))), b ? (c.inState.click = !c.inState.click, c.isInStateTrue() ? c.enter(c) : c.leave(c)) : c.tip().hasClass("in") ? c.leave(c) : c.enter(c)
	}, c.prototype.destroy = function() {
		var a = this;
		clearTimeout(this.timeout), this.hide(function() {
			a.$element.off("." + a.type).removeData("bs." + a.type), a.$tip && a.$tip.detach(), a.$tip = null, a.$arrow = null, a.$viewport = null
		})
	};
	var d = a.fn.tooltip;
	a.fn.tooltip = b, a.fn.tooltip.Constructor = c, a.fn.tooltip.noConflict = function() {
		return a.fn.tooltip = d, this
	}
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.popover"),
				f = "object" == typeof b && b;
			(e || !/destroy|hide/.test(b)) && (e || d.data("bs.popover", e = new c(this, f)), "string" == typeof b && e[b]())
		})
	}
	var c = function(a, b) {
		this.init("popover", a, b)
	};
	if (!a.fn.tooltip) throw new Error("Popover requires tooltip.js");
	c.VERSION = "3.3.6", c.DEFAULTS = a.extend({}, a.fn.tooltip.Constructor.DEFAULTS, {
		placement: "right",
		trigger: "click",
		content: "",
		template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	}), c.prototype = a.extend({}, a.fn.tooltip.Constructor.prototype), c.prototype.constructor = c, c.prototype.getDefaults = function() {
		return c.DEFAULTS
	}, c.prototype.setContent = function() {
		var a = this.tip(),
			b = this.getTitle(),
			c = this.getContent();
		a.find(".popover-title")[this.options.html ? "html" : "text"](b), a.find(".popover-content").children().detach().end()[this.options.html ? "string" == typeof c ? "html" : "append" : "text"](c), a.removeClass("fade top bottom left right in"), a.find(".popover-title").html() || a.find(".popover-title").hide()
	}, c.prototype.hasContent = function() {
		return this.getTitle() || this.getContent()
	}, c.prototype.getContent = function() {
		var a = this.$element,
			b = this.options;
		return a.attr("data-content") || ("function" == typeof b.content ? b.content.call(a[0]) : b.content)
	}, c.prototype.arrow = function() {
		return this.$arrow = this.$arrow || this.tip().find(".arrow")
	};
	var d = a.fn.popover;
	a.fn.popover = b, a.fn.popover.Constructor = c, a.fn.popover.noConflict = function() {
		return a.fn.popover = d, this
	}
}(jQuery), + function(a) {
	"use strict";

	function b(c, d) {
		this.$body = a(document.body), this.$scrollElement = a(a(c).is(document.body) ? window : c), this.options = a.extend({}, b.DEFAULTS, d), this.selector = (this.options.target || "") + " .nav li > a", this.offsets = [], this.targets = [], this.activeTarget = null, this.scrollHeight = 0, this.$scrollElement.on("scroll.bs.scrollspy", a.proxy(this.process, this)), this.refresh(), this.process()
	}

	function c(c) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.scrollspy"),
				f = "object" == typeof c && c;
			e || d.data("bs.scrollspy", e = new b(this, f)), "string" == typeof c && e[c]()
		})
	}
	b.VERSION = "3.3.6", b.DEFAULTS = {
		offset: 10
	}, b.prototype.getScrollHeight = function() {
		return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	}, b.prototype.refresh = function() {
		var b = this,
			c = "offset",
			d = 0;
		this.offsets = [], this.targets = [], this.scrollHeight = this.getScrollHeight(), a.isWindow(this.$scrollElement[0]) || (c = "position", d = this.$scrollElement.scrollTop()), this.$body.find(this.selector).map(function() {
			var b = a(this),
				e = b.data("target") || b.attr("href"),
				f = /^#./.test(e) && a(e);
			return f && f.length && f.is(":visible") && [
				[f[c]().top + d, e]
			] || null
		}).sort(function(a, b) {
			return a[0] - b[0]
		}).each(function() {
			b.offsets.push(this[0]), b.targets.push(this[1])
		})
	}, b.prototype.process = function() {
		var a, b = this.$scrollElement.scrollTop() + this.options.offset,
			c = this.getScrollHeight(),
			d = this.options.offset + c - this.$scrollElement.height(),
			e = this.offsets,
			f = this.targets,
			g = this.activeTarget;
		if (this.scrollHeight != c && this.refresh(), b >= d) return g != (a = f[f.length - 1]) && this.activate(a);
		if (g && b < e[0]) return this.activeTarget = null, this.clear();
		for (a = e.length; a--;) g != f[a] && b >= e[a] && (void 0 === e[a + 1] || b < e[a + 1]) && this.activate(f[a])
	}, b.prototype.activate = function(b) {
		this.activeTarget = b, this.clear();
		var c = this.selector + '[data-target="' + b + '"],' + this.selector + '[href="' + b + '"]',
			d = a(c).parents("li").addClass("active");
		d.parent(".dropdown-menu").length && (d = d.closest("li.dropdown").addClass("active")), d.trigger("activate.bs.scrollspy")
	}, b.prototype.clear = function() {
		a(this.selector).parentsUntil(this.options.target, ".active").removeClass("active")
	};
	var d = a.fn.scrollspy;
	a.fn.scrollspy = c, a.fn.scrollspy.Constructor = b, a.fn.scrollspy.noConflict = function() {
		return a.fn.scrollspy = d, this
	}, a(window).on("load.bs.scrollspy.data-api", function() {
		a('[data-spy="scroll"]').each(function() {
			var b = a(this);
			c.call(b, b.data())
		})
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.tab");
			e || d.data("bs.tab", e = new c(this)), "string" == typeof b && e[b]()
		})
	}
	var c = function(b) {
		this.element = a(b)
	};
	c.VERSION = "3.3.6", c.TRANSITION_DURATION = 150, c.prototype.show = function() {
		var b = this.element,
			c = b.closest("ul:not(.dropdown-menu)"),
			d = b.data("target");
		if (d || (d = b.attr("href"), d = d && d.replace(/.*(?=#[^\s]*$)/, "")), !b.parent("li").hasClass("active")) {
			var e = c.find(".active:last a"),
				f = a.Event("hide.bs.tab", {
					relatedTarget: b[0]
				}),
				g = a.Event("show.bs.tab", {
					relatedTarget: e[0]
				});
			if (e.trigger(f), b.trigger(g), !g.isDefaultPrevented() && !f.isDefaultPrevented()) {
				var h = a(d);
				this.activate(b.closest("li"), c), this.activate(h, h.parent(), function() {
					e.trigger({
						type: "hidden.bs.tab",
						relatedTarget: b[0]
					}), b.trigger({
						type: "shown.bs.tab",
						relatedTarget: e[0]
					})
				})
			}
		}
	}, c.prototype.activate = function(b, d, e) {
		function f() {
			g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !1), b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", !0), h ? (b[0].offsetWidth, b.addClass("in")) : b.removeClass("fade"), b.parent(".dropdown-menu").length && b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !0), e && e()
		}
		var g = d.find("> .active"),
			h = e && a.support.transition && (g.length && g.hasClass("fade") || !!d.find("> .fade").length);
		g.length && h ? g.one("bsTransitionEnd", f).emulateTransitionEnd(c.TRANSITION_DURATION) : f(), g.removeClass("in")
	};
	var d = a.fn.tab;
	a.fn.tab = b, a.fn.tab.Constructor = c, a.fn.tab.noConflict = function() {
		return a.fn.tab = d, this
	};
	var e = function(c) {
		c.preventDefault(), b.call(a(this), "show")
	};
	a(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', e).on("click.bs.tab.data-api", '[data-toggle="pill"]', e)
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.affix"),
				f = "object" == typeof b && b;
			e || d.data("bs.affix", e = new c(this, f)), "string" == typeof b && e[b]()
		})
	}
	var c = function(b, d) {
		this.options = a.extend({}, c.DEFAULTS, d), this.$target = a(this.options.target).on("scroll.bs.affix.data-api", a.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", a.proxy(this.checkPositionWithEventLoop, this)), this.$element = a(b), this.affixed = null, this.unpin = null, this.pinnedOffset = null, this.checkPosition()
	};
	c.VERSION = "3.3.6", c.RESET = "affix affix-top affix-bottom", c.DEFAULTS = {
		offset: 0,
		target: window
	}, c.prototype.getState = function(a, b, c, d) {
		var e = this.$target.scrollTop(),
			f = this.$element.offset(),
			g = this.$target.height();
		if (null != c && "top" == this.affixed) return c > e ? "top" : !1;
		if ("bottom" == this.affixed) return null != c ? e + this.unpin <= f.top ? !1 : "bottom" : a - d >= e + g ? !1 : "bottom";
		var h = null == this.affixed,
			i = h ? e : f.top,
			j = h ? g : b;
		return null != c && c >= e ? "top" : null != d && i + j >= a - d ? "bottom" : !1
	}, c.prototype.getPinnedOffset = function() {
		if (this.pinnedOffset) return this.pinnedOffset;
		this.$element.removeClass(c.RESET).addClass("affix");
		var a = this.$target.scrollTop(),
			b = this.$element.offset();
		return this.pinnedOffset = b.top - a
	}, c.prototype.checkPositionWithEventLoop = function() {
		setTimeout(a.proxy(this.checkPosition, this), 1)
	}, c.prototype.checkPosition = function() {
		if (this.$element.is(":visible")) {
			var b = this.$element.height(),
				d = this.options.offset,
				e = d.top,
				f = d.bottom,
				g = Math.max(a(document).height(), a(document.body).height());
			"object" != typeof d && (f = e = d), "function" == typeof e && (e = d.top(this.$element)), "function" == typeof f && (f = d.bottom(this.$element));
			var h = this.getState(g, b, e, f);
			if (this.affixed != h) {
				null != this.unpin && this.$element.css("top", "");
				var i = "affix" + (h ? "-" + h : ""),
					j = a.Event(i + ".bs.affix");
				if (this.$element.trigger(j), j.isDefaultPrevented()) return;
				this.affixed = h, this.unpin = "bottom" == h ? this.getPinnedOffset() : null, this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix", "affixed") + ".bs.affix")
			}
			"bottom" == h && this.$element.offset({
				top: g - b - f
			})
		}
	};
	var d = a.fn.affix;
	a.fn.affix = b, a.fn.affix.Constructor = c, a.fn.affix.noConflict = function() {
		return a.fn.affix = d, this
	}, a(window).on("load", function() {
		a('[data-spy="affix"]').each(function() {
			var c = a(this),
				d = c.data();
			d.offset = d.offset || {}, null != d.offsetBottom && (d.offset.bottom = d.offsetBottom), null != d.offsetTop && (d.offset.top = d.offsetTop), b.call(c, d)
		})
	})
}(jQuery);
/*
 * jQuery Easing v1.3.2 - http://gsgd.co.uk/sandbox/jquery/easing/
 * Open source under the BSD License.
 * Copyright © 2008 George McGinley Smith
 * All rights reserved.
 * https://raw.github.com/gdsmith/jquery-easing/master/LICENSE
 */
(function(h) {
	h.easing.jswing = h.easing.swing;
	h.extend(h.easing, {
		def: "easeOutQuad",
		swing: function(e, a, c, b, d) {
			return h.easing[h.easing.def](e, a, c, b, d)
		},
		easeInQuad: function(e, a, c, b, d) {
			return b * (a /= d) * a + c
		},
		easeOutQuad: function(e, a, c, b, d) {
			return -b * (a /= d) * (a - 2) + c
		},
		easeInOutQuad: function(e, a, c, b, d) {
			return 1 > (a /= d / 2) ? b / 2 * a * a + c : -b / 2 * (--a * (a - 2) - 1) + c
		},
		easeInCubic: function(e, a, c, b, d) {
			return b * (a /= d) * a * a + c
		},
		easeOutCubic: function(e, a, c, b, d) {
			return b * ((a = a / d - 1) * a * a + 1) + c
		},
		easeInOutCubic: function(e, a, c, b, d) {
			return 1 > (a /= d / 2) ? b / 2 * a * a * a + c : b / 2 * ((a -= 2) * a * a + 2) + c
		},
		easeInQuart: function(e, a, c, b, d) {
			return b * (a /= d) * a * a * a + c
		},
		easeOutQuart: function(e, a, c, b, d) {
			return -b * ((a = a / d - 1) * a * a * a - 1) + c
		},
		easeInOutQuart: function(e, a, c, b, d) {
			return 1 > (a /= d / 2) ? b / 2 * a * a * a * a + c : -b / 2 * ((a -= 2) * a * a * a - 2) + c
		},
		easeInQuint: function(e, a, c, b, d) {
			return b * (a /= d) * a * a * a * a + c
		},
		easeOutQuint: function(e, a, c, b, d) {
			return b * ((a = a / d - 1) * a * a * a * a + 1) + c
		},
		easeInOutQuint: function(e, a, c, b, d) {
			return 1 > (a /= d / 2) ? b / 2 * a * a * a * a * a + c : b / 2 * ((a -= 2) * a * a * a * a + 2) + c
		},
		easeInSine: function(e, a, c, b, d) {
			return -b * Math.cos(a / d * (Math.PI / 2)) + b + c
		},
		easeOutSine: function(e, a, c, b, d) {
			return b * Math.sin(a / d * (Math.PI / 2)) + c
		},
		easeInOutSine: function(e, a, c, b, d) {
			return -b / 2 * (Math.cos(Math.PI * a / d) - 1) + c
		},
		easeInExpo: function(e, a, c, b, d) {
			return 0 == a ? c : b * Math.pow(2, 10 * (a / d - 1)) + c
		},
		easeOutExpo: function(e, a, c, b, d) {
			return a == d ? c + b : b * (-Math.pow(2, -10 * a / d) + 1) + c
		},
		easeInOutExpo: function(e, a, c, b, d) {
			return 0 == a ? c : a == d ? c + b : 1 > (a /= d / 2) ? b / 2 * Math.pow(2, 10 * (a - 1)) + c : b / 2 * (-Math.pow(2, -10 * --a) + 2) + c
		},
		easeInCirc: function(e, a, c, b, d) {
			return -b * (Math.sqrt(1 - (a /= d) * a) - 1) + c
		},
		easeOutCirc: function(e, a, c, b, d) {
			return b * Math.sqrt(1 - (a = a / d - 1) * a) + c
		},
		easeInOutCirc: function(e, a, c, b, d) {
			return 1 > (a /= d / 2) ? -b / 2 * (Math.sqrt(1 - a * a) - 1) + c : b / 2 * (Math.sqrt(1 - (a -= 2) * a) + 1) + c
		},
		easeInElastic: function(e, a, c, b, d) {
			e = 1.70158;
			var f = 0,
				g = b;
			if (0 == a) return c;
			if (1 == (a /= d)) return c + b;
			f || (f = .3 * d);
			g < Math.abs(b) ? (g = b, e = f / 4) : e = f / (2 * Math.PI) * Math.asin(b / g);
			return -(g * Math.pow(2, 10 * --a) * Math.sin(2 * (a * d - e) * Math.PI / f)) + c
		},
		easeOutElastic: function(e, a, c, b, d) {
			e = 1.70158;
			var f = 0,
				g = b;
			if (0 == a) return c;
			if (1 == (a /= d)) return c + b;
			f || (f = .3 * d);
			g < Math.abs(b) ? (g = b, e = f / 4) : e = f / (2 * Math.PI) * Math.asin(b / g);
			return g * Math.pow(2, -10 * a) * Math.sin(2 * (a * d - e) * Math.PI / f) + b + c
		},
		easeInOutElastic: function(e, a, c, b, d) {
			e = 1.70158;
			var f = 0,
				g = b;
			if (0 == a) return c;
			if (2 == (a /= d / 2)) return c + b;
			f || (f = .3 * d * 1.5);
			g < Math.abs(b) ? (g = b, e = f / 4) : e = f / (2 * Math.PI) * Math.asin(b / g);
			return 1 > a ? -.5 * g * Math.pow(2, 10 * --a) * Math.sin(2 * (a * d - e) * Math.PI / f) + c : g * Math.pow(2, -10 * --a) * Math.sin(2 * (a * d - e) * Math.PI / f) * .5 + b + c
		},
		easeInBack: function(e, a, c, b, d, f) {
			void 0 == f && (f = 1.70158);
			return b * (a /= d) * a * ((f + 1) * a - f) + c
		},
		easeOutBack: function(e, a, c, b, d, f) {
			void 0 == f && (f = 1.70158);
			return b * ((a = a / d - 1) * a * ((f + 1) * a + f) + 1) + c
		},
		easeInOutBack: function(e, a, c, b, d, f) {
			void 0 == f && (f = 1.70158);
			return 1 > (a /= d / 2) ? b / 2 * a * a * (((f *= 1.525) + 1) * a - f) + c : b / 2 * ((a -= 2) * a * (((f *= 1.525) + 1) * a + f) + 2) + c
		},
		easeInBounce: function(e, a, c, b, d) {
			return b - h.easing.easeOutBounce(e, d - a, 0, b, d) + c
		},
		easeOutBounce: function(e, a, c, b, d) {
			return (a /= d) < 1 / 2.75 ? 7.5625 * b * a * a + c : a < 2 / 2.75 ? b * (7.5625 * (a -= 1.5 / 2.75) * a + .75) + c : a < 2.5 / 2.75 ? b * (7.5625 * (a -= 2.25 / 2.75) * a + .9375) + c : b * (7.5625 * (a -= 2.625 / 2.75) * a + .984375) + c
		},
		easeInOutBounce: function(e, a, c, b, d) {
			return a < d / 2 ? .5 * h.easing.easeInBounce(e, 2 * a, 0, b, d) + c : .5 * h.easing.easeOutBounce(e, 2 * a - d, 0, b, d) + .5 * b + c
		}
	})
})(jQuery);
/**
 * Owl carousel
 * @version 2.0.0
 * @author Bartosz Wojciechowski 
 */
! function(a, b, c, d) {
	function e(b, c) {
		this.settings = null, this.options = a.extend({}, e.Defaults, c), this.$element = a(b), this.drag = a.extend({}, m), this.state = a.extend({}, n), this.e = a.extend({}, o), this._plugins = {}, this._supress = {}, this._current = null, this._speed = null, this._coordinates = [], this._breakpoint = null, this._width = null, this._items = [], this._clones = [], this._mergers = [], this._invalidated = {}, this._pipe = [], a.each(e.Plugins, a.proxy(function(a, b) {
			this._plugins[a[0].toLowerCase() + a.slice(1)] = new b(this)
		}, this)), a.each(e.Pipe, a.proxy(function(b, c) {
			this._pipe.push({
				filter: c.filter,
				run: a.proxy(c.run, this)
			})
		}, this)), this.setup(), this.initialize()
	}

	function f(a) {
		if (a.touches !== d) return {
			x: a.touches[0].pageX,
			y: a.touches[0].pageY
		};
		if (a.touches === d) {
			if (a.pageX !== d) return {
				x: a.pageX,
				y: a.pageY
			};
			if (a.pageX === d) return {
				x: a.clientX,
				y: a.clientY
			}
		}
	}

	function g(a) {
		var b, d, e = c.createElement("div"),
			f = a;
		for (b in f)
			if (d = f[b], "undefined" != typeof e.style[d]) return e = null, [d, b];
		return [!1]
	}

	function h() {
		return g(["transition", "WebkitTransition", "MozTransition", "OTransition"])[1]
	}

	function i() {
		return g(["transform", "WebkitTransform", "MozTransform", "OTransform", "msTransform"])[0]
	}

	function j() {
		return g(["perspective", "webkitPerspective", "MozPerspective", "OPerspective", "MsPerspective"])[0]
	}

	function k() {
		return "ontouchstart" in b || !!navigator.msMaxTouchPoints
	}

	function l() {
		return b.navigator.msPointerEnabled
	}
	var m, n, o;
	m = {
		start: 0,
		startX: 0,
		startY: 0,
		current: 0,
		currentX: 0,
		currentY: 0,
		offsetX: 0,
		offsetY: 0,
		distance: null,
		startTime: 0,
		endTime: 0,
		updatedX: 0,
		targetEl: null
	}, n = {
		isTouch: !1,
		isScrolling: !1,
		isSwiping: !1,
		direction: !1,
		inMotion: !1
	}, o = {
		_onDragStart: null,
		_onDragMove: null,
		_onDragEnd: null,
		_transitionEnd: null,
		_resizer: null,
		_responsiveCall: null,
		_goToLoop: null,
		_checkVisibile: null
	}, e.Defaults = {
		items: 3,
		loop: !1,
		center: !1,
		mouseDrag: !0,
		touchDrag: !0,
		pullDrag: !0,
		freeDrag: !1,
		margin: 0,
		stagePadding: 0,
		merge: !1,
		mergeFit: !0,
		autoWidth: !1,
		startPosition: 0,
		rtl: !1,
		smartSpeed: 250,
		fluidSpeed: !1,
		dragEndSpeed: !1,
		responsive: {},
		responsiveRefreshRate: 200,
		responsiveBaseElement: b,
		responsiveClass: !1,
		fallbackEasing: "swing",
		info: !1,
		nestedItemSelector: !1,
		itemElement: "div",
		stageElement: "div",
		themeClass: "owl-theme",
		baseClass: "owl-carousel",
		itemClass: "owl-item",
		centerClass: "center",
		activeClass: "active"
	}, e.Width = {
		Default: "default",
		Inner: "inner",
		Outer: "outer"
	}, e.Plugins = {}, e.Pipe = [{
		filter: ["width", "items", "settings"],
		run: function(a) {
			a.current = this._items && this._items[this.relative(this._current)]
		}
	}, {
		filter: ["items", "settings"],
		run: function() {
			var a = this._clones,
				b = this.$stage.children(".cloned");
			(b.length !== a.length || !this.settings.loop && a.length > 0) && (this.$stage.children(".cloned").remove(), this._clones = [])
		}
	}, {
		filter: ["items", "settings"],
		run: function() {
			var a, b, c = this._clones,
				d = this._items,
				e = this.settings.loop ? c.length - Math.max(2 * this.settings.items, 4) : 0;
			for (a = 0, b = Math.abs(e / 2); b > a; a++) e > 0 ? (this.$stage.children().eq(d.length + c.length - 1).remove(), c.pop(), this.$stage.children().eq(0).remove(), c.pop()) : (c.push(c.length / 2), this.$stage.append(d[c[c.length - 1]].clone().addClass("cloned")), c.push(d.length - 1 - (c.length - 1) / 2), this.$stage.prepend(d[c[c.length - 1]].clone().addClass("cloned")))
		}
	}, {
		filter: ["width", "items", "settings"],
		run: function() {
			var a, b, c, d = this.settings.rtl ? 1 : -1,
				e = (this.width() / this.settings.items).toFixed(3),
				f = 0;
			for (this._coordinates = [], b = 0, c = this._clones.length + this._items.length; c > b; b++) a = this._mergers[this.relative(b)], a = this.settings.mergeFit && Math.min(a, this.settings.items) || a, f += (this.settings.autoWidth ? this._items[this.relative(b)].width() + this.settings.margin : e * a) * d, this._coordinates.push(f)
		}
	}, {
		filter: ["width", "items", "settings"],
		run: function() {
			var b, c, d = (this.width() / this.settings.items).toFixed(3),
				e = {
					width: Math.abs(this._coordinates[this._coordinates.length - 1]) + 2 * this.settings.stagePadding,
					"padding-left": this.settings.stagePadding || "",
					"padding-right": this.settings.stagePadding || ""
				};
			if (this.$stage.css(e), e = {
					width: this.settings.autoWidth ? "auto" : d - this.settings.margin
				}, e[this.settings.rtl ? "margin-left" : "margin-right"] = this.settings.margin, !this.settings.autoWidth && a.grep(this._mergers, function(a) {
					return a > 1
				}).length > 0)
				for (b = 0, c = this._coordinates.length; c > b; b++) e.width = Math.abs(this._coordinates[b]) - Math.abs(this._coordinates[b - 1] || 0) - this.settings.margin, this.$stage.children().eq(b).css(e);
			else this.$stage.children().css(e)
		}
	}, {
		filter: ["width", "items", "settings"],
		run: function(a) {
			a.current && this.reset(this.$stage.children().index(a.current))
		}
	}, {
		filter: ["position"],
		run: function() {
			this.animate(this.coordinates(this._current))
		}
	}, {
		filter: ["width", "position", "items", "settings"],
		run: function() {
			var a, b, c, d, e = this.settings.rtl ? 1 : -1,
				f = 2 * this.settings.stagePadding,
				g = this.coordinates(this.current()) + f,
				h = g + this.width() * e,
				i = [];
			for (c = 0, d = this._coordinates.length; d > c; c++) a = this._coordinates[c - 1] || 0, b = Math.abs(this._coordinates[c]) + f * e, (this.op(a, "<=", g) && this.op(a, ">", h) || this.op(b, "<", g) && this.op(b, ">", h)) && i.push(c);
			this.$stage.children("." + this.settings.activeClass).removeClass(this.settings.activeClass), this.$stage.children(":eq(" + i.join("), :eq(") + ")").addClass(this.settings.activeClass), this.settings.center && (this.$stage.children("." + this.settings.centerClass).removeClass(this.settings.centerClass), this.$stage.children().eq(this.current()).addClass(this.settings.centerClass))
		}
	}], e.prototype.initialize = function() {
		if (this.trigger("initialize"), this.$element.addClass(this.settings.baseClass).addClass(this.settings.themeClass).toggleClass("owl-rtl", this.settings.rtl), this.browserSupport(), this.settings.autoWidth && this.state.imagesLoaded !== !0) {
			var b, c, e;
			if (b = this.$element.find("img"), c = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : d, e = this.$element.children(c).width(), b.length && 0 >= e) return this.preloadAutoWidthImages(b), !1
		}
		this.$element.addClass("owl-loading"), this.$stage = a("<" + this.settings.stageElement + ' class="owl-stage"/>').wrap('<div class="owl-stage-outer">'), this.$element.append(this.$stage.parent()), this.replace(this.$element.children().not(this.$stage.parent())), this._width = this.$element.width(), this.refresh(), this.$element.removeClass("owl-loading").addClass("owl-loaded"), this.eventsCall(), this.internalEvents(), this.addTriggerableEvents(), this.trigger("initialized")
	}, e.prototype.setup = function() {
		var b = this.viewport(),
			c = this.options.responsive,
			d = -1,
			e = null;
		c ? (a.each(c, function(a) {
			b >= a && a > d && (d = Number(a))
		}), e = a.extend({}, this.options, c[d]), delete e.responsive, e.responsiveClass && this.$element.attr("class", function(a, b) {
			return b.replace(/\b owl-responsive-\S+/g, "")
		}).addClass("owl-responsive-" + d)) : e = a.extend({}, this.options), (null === this.settings || this._breakpoint !== d) && (this.trigger("change", {
			property: {
				name: "settings",
				value: e
			}
		}), this._breakpoint = d, this.settings = e, this.invalidate("settings"), this.trigger("changed", {
			property: {
				name: "settings",
				value: this.settings
			}
		}))
	}, e.prototype.optionsLogic = function() {
		this.$element.toggleClass("owl-center", this.settings.center), this.settings.loop && this._items.length < this.settings.items && (this.settings.loop = !1), this.settings.autoWidth && (this.settings.stagePadding = !1, this.settings.merge = !1)
	}, e.prototype.prepare = function(b) {
		var c = this.trigger("prepare", {
			content: b
		});
		return c.data || (c.data = a("<" + this.settings.itemElement + "/>").addClass(this.settings.itemClass).append(b)), this.trigger("prepared", {
			content: c.data
		}), c.data
	}, e.prototype.update = function() {
		for (var b = 0, c = this._pipe.length, d = a.proxy(function(a) {
				return this[a]
			}, this._invalidated), e = {}; c > b;)(this._invalidated.all || a.grep(this._pipe[b].filter, d).length > 0) && this._pipe[b].run(e), b++;
		this._invalidated = {}
	}, e.prototype.width = function(a) {
		switch (a = a || e.Width.Default) {
			case e.Width.Inner:
			case e.Width.Outer:
				return this._width;
			default:
				return this._width - 2 * this.settings.stagePadding + this.settings.margin
		}
	}, e.prototype.refresh = function() {
		if (0 === this._items.length) return !1;
		(new Date).getTime();
		this.trigger("refresh"), this.setup(), this.optionsLogic(), this.$stage.addClass("owl-refresh"), this.update(), this.$stage.removeClass("owl-refresh"), this.state.orientation = b.orientation, this.watchVisibility(), this.trigger("refreshed")
	}, e.prototype.eventsCall = function() {
		this.e._onDragStart = a.proxy(function(a) {
			this.onDragStart(a)
		}, this), this.e._onDragMove = a.proxy(function(a) {
			this.onDragMove(a)
		}, this), this.e._onDragEnd = a.proxy(function(a) {
			this.onDragEnd(a)
		}, this), this.e._onResize = a.proxy(function(a) {
			this.onResize(a)
		}, this), this.e._transitionEnd = a.proxy(function(a) {
			this.transitionEnd(a)
		}, this), this.e._preventClick = a.proxy(function(a) {
			this.preventClick(a)
		}, this)
	}, e.prototype.onThrottledResize = function() {
		b.clearTimeout(this.resizeTimer), this.resizeTimer = b.setTimeout(this.e._onResize, this.settings.responsiveRefreshRate)
	}, e.prototype.onResize = function() {
		return this._items.length ? this._width === this.$element.width() ? !1 : this.trigger("resize").isDefaultPrevented() ? !1 : (this._width = this.$element.width(), this.invalidate("width"), this.refresh(), void this.trigger("resized")) : !1
	}, e.prototype.eventsRouter = function(a) {
		var b = a.type;
		"mousedown" === b || "touchstart" === b ? this.onDragStart(a) : "mousemove" === b || "touchmove" === b ? this.onDragMove(a) : "mouseup" === b || "touchend" === b ? this.onDragEnd(a) : "touchcancel" === b && this.onDragEnd(a)
	}, e.prototype.internalEvents = function() {
		var c = (k(), l());
		this.settings.mouseDrag ? (this.$stage.on("mousedown", a.proxy(function(a) {
			this.eventsRouter(a)
		}, this)), this.$stage.on("dragstart", function() {
			return !1
		}), this.$stage.get(0).onselectstart = function() {
			return !1
		}) : this.$element.addClass("owl-text-select-on"), this.settings.touchDrag && !c && this.$stage.on("touchstart touchcancel", a.proxy(function(a) {
			this.eventsRouter(a)
		}, this)), this.transitionEndVendor && this.on(this.$stage.get(0), this.transitionEndVendor, this.e._transitionEnd, !1), this.settings.responsive !== !1 && this.on(b, "resize", a.proxy(this.onThrottledResize, this))
	}, e.prototype.onDragStart = function(d) {
		var e, g, h, i;
		if (e = d.originalEvent || d || b.event, 3 === e.which || this.state.isTouch) return !1;
		if ("mousedown" === e.type && this.$stage.addClass("owl-grab"), this.trigger("drag"), this.drag.startTime = (new Date).getTime(), this.speed(0), this.state.isTouch = !0, this.state.isScrolling = !1, this.state.isSwiping = !1, this.drag.distance = 0, g = f(e).x, h = f(e).y, this.drag.offsetX = this.$stage.position().left, this.drag.offsetY = this.$stage.position().top, this.settings.rtl && (this.drag.offsetX = this.$stage.position().left + this.$stage.width() - this.width() + this.settings.margin), this.state.inMotion && this.support3d) i = this.getTransformProperty(), this.drag.offsetX = i, this.animate(i), this.state.inMotion = !0;
		else if (this.state.inMotion && !this.support3d) return this.state.inMotion = !1, !1;
		this.drag.startX = g - this.drag.offsetX, this.drag.startY = h - this.drag.offsetY, this.drag.start = g - this.drag.startX, this.drag.targetEl = e.target || e.srcElement, this.drag.updatedX = this.drag.start, ("IMG" === this.drag.targetEl.tagName || "A" === this.drag.targetEl.tagName) && (this.drag.targetEl.draggable = !1), a(c).on("mousemove.owl.dragEvents mouseup.owl.dragEvents touchmove.owl.dragEvents touchend.owl.dragEvents", a.proxy(function(a) {
			this.eventsRouter(a)
		}, this))
	}, e.prototype.onDragMove = function(a) {
		var c, e, g, h, i, j;
		this.state.isTouch && (this.state.isScrolling || (c = a.originalEvent || a || b.event, e = f(c).x, g = f(c).y, this.drag.currentX = e - this.drag.startX, this.drag.currentY = g - this.drag.startY, this.drag.distance = this.drag.currentX - this.drag.offsetX, this.drag.distance < 0 ? this.state.direction = this.settings.rtl ? "right" : "left" : this.drag.distance > 0 && (this.state.direction = this.settings.rtl ? "left" : "right"), this.settings.loop ? this.op(this.drag.currentX, ">", this.coordinates(this.minimum())) && "right" === this.state.direction ? this.drag.currentX -= (this.settings.center && this.coordinates(0)) - this.coordinates(this._items.length) : this.op(this.drag.currentX, "<", this.coordinates(this.maximum())) && "left" === this.state.direction && (this.drag.currentX += (this.settings.center && this.coordinates(0)) - this.coordinates(this._items.length)) : (h = this.coordinates(this.settings.rtl ? this.maximum() : this.minimum()), i = this.coordinates(this.settings.rtl ? this.minimum() : this.maximum()), j = this.settings.pullDrag ? this.drag.distance / 5 : 0, this.drag.currentX = Math.max(Math.min(this.drag.currentX, h + j), i + j)), (this.drag.distance > 8 || this.drag.distance < -8) && (c.preventDefault !== d ? c.preventDefault() : c.returnValue = !1, this.state.isSwiping = !0), this.drag.updatedX = this.drag.currentX, (this.drag.currentY > 16 || this.drag.currentY < -16) && this.state.isSwiping === !1 && (this.state.isScrolling = !0, this.drag.updatedX = this.drag.start), this.animate(this.drag.updatedX)))
	}, e.prototype.onDragEnd = function(b) {
		var d, e, f;
		if (this.state.isTouch) {
			if ("mouseup" === b.type && this.$stage.removeClass("owl-grab"), this.trigger("dragged"), this.drag.targetEl.removeAttribute("draggable"), this.state.isTouch = !1, this.state.isScrolling = !1, this.state.isSwiping = !1, 0 === this.drag.distance && this.state.inMotion !== !0) return this.state.inMotion = !1, !1;
			this.drag.endTime = (new Date).getTime(), d = this.drag.endTime - this.drag.startTime, e = Math.abs(this.drag.distance), (e > 3 || d > 300) && this.removeClick(this.drag.targetEl), f = this.closest(this.drag.updatedX), this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed), this.current(f), this.invalidate("position"), this.update(), this.settings.pullDrag || this.drag.updatedX !== this.coordinates(f) || this.transitionEnd(), this.drag.distance = 0, a(c).off(".owl.dragEvents")
		}
	}, e.prototype.removeClick = function(c) {
		this.drag.targetEl = c, a(c).on("click.preventClick", this.e._preventClick), b.setTimeout(function() {
			a(c).off("click.preventClick")
		}, 300)
	}, e.prototype.preventClick = function(b) {
		b.preventDefault ? b.preventDefault() : b.returnValue = !1, b.stopPropagation && b.stopPropagation(), a(b.target).off("click.preventClick")
	}, e.prototype.getTransformProperty = function() {
		var a, c;
		return a = b.getComputedStyle(this.$stage.get(0), null).getPropertyValue(this.vendorName + "transform"), a = a.replace(/matrix(3d)?\(|\)/g, "").split(","), c = 16 === a.length, c !== !0 ? a[4] : a[12]
	}, e.prototype.closest = function(b) {
		var c = -1,
			d = 30,
			e = this.width(),
			f = this.coordinates();
		return this.settings.freeDrag || a.each(f, a.proxy(function(a, g) {
			return b > g - d && g + d > b ? c = a : this.op(b, "<", g) && this.op(b, ">", f[a + 1] || g - e) && (c = "left" === this.state.direction ? a + 1 : a), -1 === c
		}, this)), this.settings.loop || (this.op(b, ">", f[this.minimum()]) ? c = b = this.minimum() : this.op(b, "<", f[this.maximum()]) && (c = b = this.maximum())), c
	}, e.prototype.animate = function(b) {
		this.trigger("translate"), this.state.inMotion = this.speed() > 0, this.support3d ? this.$stage.css({
			transform: "translate3d(" + b + "px,0px, 0px)",
			transition: this.speed() / 1e3 + "s"
		}) : this.state.isTouch ? this.$stage.css({
			left: b + "px"
		}) : this.$stage.animate({
			left: b
		}, this.speed() / 1e3, this.settings.fallbackEasing, a.proxy(function() {
			this.state.inMotion && this.transitionEnd()
		}, this))
	}, e.prototype.current = function(a) {
		if (a === d) return this._current;
		if (0 === this._items.length) return d;
		if (a = this.normalize(a), this._current !== a) {
			var b = this.trigger("change", {
				property: {
					name: "position",
					value: a
				}
			});
			b.data !== d && (a = this.normalize(b.data)), this._current = a, this.invalidate("position"), this.trigger("changed", {
				property: {
					name: "position",
					value: this._current
				}
			})
		}
		return this._current
	}, e.prototype.invalidate = function(a) {
		this._invalidated[a] = !0
	}, e.prototype.reset = function(a) {
		a = this.normalize(a), a !== d && (this._speed = 0, this._current = a, this.suppress(["translate", "translated"]), this.animate(this.coordinates(a)), this.release(["translate", "translated"]))
	}, e.prototype.normalize = function(b, c) {
		var e = c ? this._items.length : this._items.length + this._clones.length;
		return !a.isNumeric(b) || 1 > e ? d : b = this._clones.length ? (b % e + e) % e : Math.max(this.minimum(c), Math.min(this.maximum(c), b))
	}, e.prototype.relative = function(a) {
		return a = this.normalize(a), a -= this._clones.length / 2, this.normalize(a, !0)
	}, e.prototype.maximum = function(a) {
		var b, c, d, e = 0,
			f = this.settings;
		if (a) return this._items.length - 1;
		if (!f.loop && f.center) b = this._items.length - 1;
		else if (f.loop || f.center)
			if (f.loop || f.center) b = this._items.length + f.items;
			else {
				if (!f.autoWidth && !f.merge) throw "Can not detect maximum absolute position.";
				for (revert = f.rtl ? 1 : -1, c = this.$stage.width() - this.$element.width();
					(d = this.coordinates(e)) && !(d * revert >= c);) b = ++e
			}
		else b = this._items.length - f.items;
		return b
	}, e.prototype.minimum = function(a) {
		return a ? 0 : this._clones.length / 2
	}, e.prototype.items = function(a) {
		return a === d ? this._items.slice() : (a = this.normalize(a, !0), this._items[a])
	}, e.prototype.mergers = function(a) {
		return a === d ? this._mergers.slice() : (a = this.normalize(a, !0), this._mergers[a])
	}, e.prototype.clones = function(b) {
		var c = this._clones.length / 2,
			e = c + this._items.length,
			f = function(a) {
				return a % 2 === 0 ? e + a / 2 : c - (a + 1) / 2
			};
		return b === d ? a.map(this._clones, function(a, b) {
			return f(b)
		}) : a.map(this._clones, function(a, c) {
			return a === b ? f(c) : null
		})
	}, e.prototype.speed = function(a) {
		return a !== d && (this._speed = a), this._speed
	}, e.prototype.coordinates = function(b) {
		var c = null;
		return b === d ? a.map(this._coordinates, a.proxy(function(a, b) {
			return this.coordinates(b)
		}, this)) : (this.settings.center ? (c = this._coordinates[b], c += (this.width() - c + (this._coordinates[b - 1] || 0)) / 2 * (this.settings.rtl ? -1 : 1)) : c = this._coordinates[b - 1] || 0, c)
	}, e.prototype.duration = function(a, b, c) {
		return Math.min(Math.max(Math.abs(b - a), 1), 6) * Math.abs(c || this.settings.smartSpeed)
	}, e.prototype.to = function(c, d) {
		if (this.settings.loop) {
			var e = c - this.relative(this.current()),
				f = this.current(),
				g = this.current(),
				h = this.current() + e,
				i = 0 > g - h ? !0 : !1,
				j = this._clones.length + this._items.length;
			h < this.settings.items && i === !1 ? (f = g + this._items.length, this.reset(f)) : h >= j - this.settings.items && i === !0 && (f = g - this._items.length, this.reset(f)), b.clearTimeout(this.e._goToLoop), this.e._goToLoop = b.setTimeout(a.proxy(function() {
				this.speed(this.duration(this.current(), f + e, d)), this.current(f + e), this.update()
			}, this), 30)
		} else this.speed(this.duration(this.current(), c, d)), this.current(c), this.update()
	}, e.prototype.next = function(a) {
		a = a || !1, this.to(this.relative(this.current()) + 1, a)
	}, e.prototype.prev = function(a) {
		a = a || !1, this.to(this.relative(this.current()) - 1, a)
	}, e.prototype.transitionEnd = function(a) {
		return a !== d && (a.stopPropagation(), (a.target || a.srcElement || a.originalTarget) !== this.$stage.get(0)) ? !1 : (this.state.inMotion = !1, void this.trigger("translated"))
	}, e.prototype.viewport = function() {
		var d;
		if (this.options.responsiveBaseElement !== b) d = a(this.options.responsiveBaseElement).width();
		else if (b.innerWidth) d = b.innerWidth;
		else {
			if (!c.documentElement || !c.documentElement.clientWidth) throw "Can not detect viewport width.";
			d = c.documentElement.clientWidth
		}
		return d
	}, e.prototype.replace = function(b) {
		this.$stage.empty(), this._items = [], b && (b = b instanceof jQuery ? b : a(b)), this.settings.nestedItemSelector && (b = b.find("." + this.settings.nestedItemSelector)), b.filter(function() {
			return 1 === this.nodeType
		}).each(a.proxy(function(a, b) {
			b = this.prepare(b), this.$stage.append(b), this._items.push(b), this._mergers.push(1 * b.find("[data-merge]").andSelf("[data-merge]").attr("data-merge") || 1)
		}, this)), this.reset(a.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0), this.invalidate("items")
	}, e.prototype.add = function(a, b) {
		b = b === d ? this._items.length : this.normalize(b, !0), this.trigger("add", {
			content: a,
			position: b
		}), 0 === this._items.length || b === this._items.length ? (this.$stage.append(a), this._items.push(a), this._mergers.push(1 * a.find("[data-merge]").andSelf("[data-merge]").attr("data-merge") || 1)) : (this._items[b].before(a), this._items.splice(b, 0, a), this._mergers.splice(b, 0, 1 * a.find("[data-merge]").andSelf("[data-merge]").attr("data-merge") || 1)), this.invalidate("items"), this.trigger("added", {
			content: a,
			position: b
		})
	}, e.prototype.remove = function(a) {
		a = this.normalize(a, !0), a !== d && (this.trigger("remove", {
			content: this._items[a],
			position: a
		}), this._items[a].remove(), this._items.splice(a, 1), this._mergers.splice(a, 1), this.invalidate("items"), this.trigger("removed", {
			content: null,
			position: a
		}))
	}, e.prototype.addTriggerableEvents = function() {
		var b = a.proxy(function(b, c) {
			return a.proxy(function(a) {
				a.relatedTarget !== this && (this.suppress([c]), b.apply(this, [].slice.call(arguments, 1)), this.release([c]))
			}, this)
		}, this);
		a.each({
			next: this.next,
			prev: this.prev,
			to: this.to,
			destroy: this.destroy,
			refresh: this.refresh,
			replace: this.replace,
			add: this.add,
			remove: this.remove
		}, a.proxy(function(a, c) {
			this.$element.on(a + ".owl.carousel", b(c, a + ".owl.carousel"))
		}, this))
	}, e.prototype.watchVisibility = function() {
		function c(a) {
			return a.offsetWidth > 0 && a.offsetHeight > 0
		}

		function d() {
			c(this.$element.get(0)) && (this.$element.removeClass("owl-hidden"), this.refresh(), b.clearInterval(this.e._checkVisibile))
		}
		c(this.$element.get(0)) || (this.$element.addClass("owl-hidden"), b.clearInterval(this.e._checkVisibile), this.e._checkVisibile = b.setInterval(a.proxy(d, this), 500))
	}, e.prototype.preloadAutoWidthImages = function(b) {
		var c, d, e, f;
		c = 0, d = this, b.each(function(g, h) {
			e = a(h), f = new Image, f.onload = function() {
				c++, e.attr("src", f.src), e.css("opacity", 1), c >= b.length && (d.state.imagesLoaded = !0, d.initialize())
			}, f.src = e.attr("src") || e.attr("data-src") || e.attr("data-src-retina")
		})
	}, e.prototype.destroy = function() {
		this.$element.hasClass(this.settings.themeClass) && this.$element.removeClass(this.settings.themeClass), this.settings.responsive !== !1 && a(b).off("resize.owl.carousel"), this.transitionEndVendor && this.off(this.$stage.get(0), this.transitionEndVendor, this.e._transitionEnd);
		for (var d in this._plugins) this._plugins[d].destroy();
		(this.settings.mouseDrag || this.settings.touchDrag) && (this.$stage.off("mousedown touchstart touchcancel"), a(c).off(".owl.dragEvents"), this.$stage.get(0).onselectstart = function() {}, this.$stage.off("dragstart", function() {
			return !1
		})), this.$element.off(".owl"), this.$stage.children(".cloned").remove(), this.e = null, this.$element.removeData("owlCarousel"), this.$stage.children().contents().unwrap(), this.$stage.children().unwrap(), this.$stage.unwrap()
	}, e.prototype.op = function(a, b, c) {
		var d = this.settings.rtl;
		switch (b) {
			case "<":
				return d ? a > c : c > a;
			case ">":
				return d ? c > a : a > c;
			case ">=":
				return d ? c >= a : a >= c;
			case "<=":
				return d ? a >= c : c >= a
		}
	}, e.prototype.on = function(a, b, c, d) {
		a.addEventListener ? a.addEventListener(b, c, d) : a.attachEvent && a.attachEvent("on" + b, c)
	}, e.prototype.off = function(a, b, c, d) {
		a.removeEventListener ? a.removeEventListener(b, c, d) : a.detachEvent && a.detachEvent("on" + b, c)
	}, e.prototype.trigger = function(b, c, d) {
		var e = {
				item: {
					count: this._items.length,
					index: this.current()
				}
			},
			f = a.camelCase(a.grep(["on", b, d], function(a) {
				return a
			}).join("-").toLowerCase()),
			g = a.Event([b, "owl", d || "carousel"].join(".").toLowerCase(), a.extend({
				relatedTarget: this
			}, e, c));
		return this._supress[b] || (a.each(this._plugins, function(a, b) {
			b.onTrigger && b.onTrigger(g)
		}), this.$element.trigger(g), this.settings && "function" == typeof this.settings[f] && this.settings[f].apply(this, g)), g
	}, e.prototype.suppress = function(b) {
		a.each(b, a.proxy(function(a, b) {
			this._supress[b] = !0
		}, this))
	}, e.prototype.release = function(b) {
		a.each(b, a.proxy(function(a, b) {
			delete this._supress[b]
		}, this))
	}, e.prototype.browserSupport = function() {
		if (this.support3d = j(), this.support3d) {
			this.transformVendor = i();
			var a = ["transitionend", "webkitTransitionEnd", "transitionend", "oTransitionEnd"];
			this.transitionEndVendor = a[h()], this.vendorName = this.transformVendor.replace(/Transform/i, ""), this.vendorName = "" !== this.vendorName ? "-" + this.vendorName.toLowerCase() + "-" : ""
		}
		this.state.orientation = b.orientation
	}, a.fn.owlCarousel = function(b) {
		return this.each(function() {
			a(this).data("owlCarousel") || a(this).data("owlCarousel", new e(this, b))
		})
	}, a.fn.owlCarousel.Constructor = e
}(window.Zepto || window.jQuery, window, document),
function(a, b) {
	var c = function(b) {
		this._core = b, this._loaded = [], this._handlers = {
			"initialized.owl.carousel change.owl.carousel": a.proxy(function(b) {
				if (b.namespace && this._core.settings && this._core.settings.lazyLoad && (b.property && "position" == b.property.name || "initialized" == b.type))
					for (var c = this._core.settings, d = c.center && Math.ceil(c.items / 2) || c.items, e = c.center && -1 * d || 0, f = (b.property && b.property.value || this._core.current()) + e, g = this._core.clones().length, h = a.proxy(function(a, b) {
							this.load(b)
						}, this); e++ < d;) this.load(g / 2 + this._core.relative(f)), g && a.each(this._core.clones(this._core.relative(f++)), h)
			}, this)
		}, this._core.options = a.extend({}, c.Defaults, this._core.options), this._core.$element.on(this._handlers)
	};
	c.Defaults = {
		lazyLoad: !1
	}, c.prototype.load = function(c) {
		var d = this._core.$stage.children().eq(c),
			e = d && d.find(".owl-lazy");
		!e || a.inArray(d.get(0), this._loaded) > -1 || (e.each(a.proxy(function(c, d) {
			var e, f = a(d),
				g = b.devicePixelRatio > 1 && f.attr("data-src-retina") || f.attr("data-src");
			this._core.trigger("load", {
				element: f,
				url: g
			}, "lazy"), f.is("img") ? f.one("load.owl.lazy", a.proxy(function() {
				f.css("opacity", 1), this._core.trigger("loaded", {
					element: f,
					url: g
				}, "lazy")
			}, this)).attr("src", g) : (e = new Image, e.onload = a.proxy(function() {
				f.css({
					"background-image": "url(" + g + ")",
					opacity: "1"
				}), this._core.trigger("loaded", {
					element: f,
					url: g
				}, "lazy")
			}, this), e.src = g)
		}, this)), this._loaded.push(d.get(0)))
	}, c.prototype.destroy = function() {
		var a, b;
		for (a in this.handlers) this._core.$element.off(a, this.handlers[a]);
		for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null)
	}, a.fn.owlCarousel.Constructor.Plugins.Lazy = c
}(window.Zepto || window.jQuery, window, document),
function(a) {
	var b = function(c) {
		this._core = c, this._handlers = {
			"initialized.owl.carousel": a.proxy(function() {
				this._core.settings.autoHeight && this.update()
			}, this),
			"changed.owl.carousel": a.proxy(function(a) {
				this._core.settings.autoHeight && "position" == a.property.name && this.update()
			}, this),
			"loaded.owl.lazy": a.proxy(function(a) {
				this._core.settings.autoHeight && a.element.closest("." + this._core.settings.itemClass) === this._core.$stage.children().eq(this._core.current()) && this.update()
			}, this)
		}, this._core.options = a.extend({}, b.Defaults, this._core.options), this._core.$element.on(this._handlers)
	};
	b.Defaults = {
		autoHeight: !1,
		autoHeightClass: "owl-height"
	}, b.prototype.update = function() {
		this._core.$stage.parent().height(this._core.$stage.children().eq(this._core.current()).height()).addClass(this._core.settings.autoHeightClass)
	}, b.prototype.destroy = function() {
		var a, b;
		for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
		for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null)
	}, a.fn.owlCarousel.Constructor.Plugins.AutoHeight = b
}(window.Zepto || window.jQuery, window, document),
function(a, b, c) {
	var d = function(b) {
		this._core = b, this._videos = {}, this._playing = null, this._fullscreen = !1, this._handlers = {
			"resize.owl.carousel": a.proxy(function(a) {
				this._core.settings.video && !this.isInFullScreen() && a.preventDefault()
			}, this),
			"refresh.owl.carousel changed.owl.carousel": a.proxy(function() {
				this._playing && this.stop()
			}, this),
			"prepared.owl.carousel": a.proxy(function(b) {
				var c = a(b.content).find(".owl-video");
				c.length && (c.css("display", "none"), this.fetch(c, a(b.content)))
			}, this)
		}, this._core.options = a.extend({}, d.Defaults, this._core.options), this._core.$element.on(this._handlers), this._core.$element.on("click.owl.video", ".owl-video-play-icon", a.proxy(function(a) {
			this.play(a)
		}, this))
	};
	d.Defaults = {
		video: !1,
		videoHeight: !1,
		videoWidth: !1
	}, d.prototype.fetch = function(a, b) {
		var c = a.attr("data-vimeo-id") ? "vimeo" : "youtube",
			d = a.attr("data-vimeo-id") || a.attr("data-youtube-id"),
			e = a.attr("data-width") || this._core.settings.videoWidth,
			f = a.attr("data-height") || this._core.settings.videoHeight,
			g = a.attr("href");
		if (!g) throw new Error("Missing video URL.");
		if (d = g.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/), d[3].indexOf("youtu") > -1) c = "youtube";
		else {
			if (!(d[3].indexOf("vimeo") > -1)) throw new Error("Video URL not supported.");
			c = "vimeo"
		}
		d = d[6], this._videos[g] = {
			type: c,
			id: d,
			width: e,
			height: f
		}, b.attr("data-video", g), this.thumbnail(a, this._videos[g])
	}, d.prototype.thumbnail = function(b, c) {
		var d, e, f, g = c.width && c.height ? 'style="width:' + c.width + "px;height:" + c.height + 'px;"' : "",
			h = b.find("img"),
			i = "src",
			j = "",
			k = this._core.settings,
			l = function(a) {
				e = '<div class="owl-video-play-icon"></div>', d = k.lazyLoad ? '<div class="owl-video-tn ' + j + '" ' + i + '="' + a + '"></div>' : '<div class="owl-video-tn" style="opacity:1;background-image:url(' + a + ')"></div>', b.after(d), b.after(e)
			};
		return b.wrap('<div class="owl-video-wrapper"' + g + "></div>"), this._core.settings.lazyLoad && (i = "data-src", j = "owl-lazy"), h.length ? (l(h.attr(i)), h.remove(), !1) : void("youtube" === c.type ? (f = "http://img.youtube.com/vi/" + c.id + "/hqdefault.jpg", l(f)) : "vimeo" === c.type && a.ajax({
			type: "GET",
			url: "http://vimeo.com/api/v2/video/" + c.id + ".json",
			jsonp: "callback",
			dataType: "jsonp",
			success: function(a) {
				f = a[0].thumbnail_large, l(f)
			}
		}))
	}, d.prototype.stop = function() {
		this._core.trigger("stop", null, "video"), this._playing.find(".owl-video-frame").remove(), this._playing.removeClass("owl-video-playing"), this._playing = null
	}, d.prototype.play = function(b) {
		this._core.trigger("play", null, "video"), this._playing && this.stop();
		var c, d, e = a(b.target || b.srcElement),
			f = e.closest("." + this._core.settings.itemClass),
			g = this._videos[f.attr("data-video")],
			h = g.width || "100%",
			i = g.height || this._core.$stage.height();
		"youtube" === g.type ? c = '<iframe width="' + h + '" height="' + i + '" src="http://www.youtube.com/embed/' + g.id + "?autoplay=1&v=" + g.id + '" frameborder="0" allowfullscreen></iframe>' : "vimeo" === g.type && (c = '<iframe src="http://player.vimeo.com/video/' + g.id + '?autoplay=1" width="' + h + '" height="' + i + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'), f.addClass("owl-video-playing"), this._playing = f, d = a('<div style="height:' + i + "px; width:" + h + 'px" class="owl-video-frame">' + c + "</div>"), e.after(d)
	}, d.prototype.isInFullScreen = function() {
		var d = c.fullscreenElement || c.mozFullScreenElement || c.webkitFullscreenElement;
		return d && a(d).parent().hasClass("owl-video-frame") && (this._core.speed(0), this._fullscreen = !0), d && this._fullscreen && this._playing ? !1 : this._fullscreen ? (this._fullscreen = !1, !1) : this._playing && this._core.state.orientation !== b.orientation ? (this._core.state.orientation = b.orientation, !1) : !0
	}, d.prototype.destroy = function() {
		var a, b;
		this._core.$element.off("click.owl.video");
		for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
		for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null)
	}, a.fn.owlCarousel.Constructor.Plugins.Video = d
}(window.Zepto || window.jQuery, window, document),
function(a, b, c, d) {
	var e = function(b) {
		this.core = b, this.core.options = a.extend({}, e.Defaults, this.core.options), this.swapping = !0, this.previous = d, this.next = d, this.handlers = {
			"change.owl.carousel": a.proxy(function(a) {
				"position" == a.property.name && (this.previous = this.core.current(), this.next = a.property.value)
			}, this),
			"drag.owl.carousel dragged.owl.carousel translated.owl.carousel": a.proxy(function(a) {
				this.swapping = "translated" == a.type
			}, this),
			"translate.owl.carousel": a.proxy(function() {
				this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap()
			}, this)
		}, this.core.$element.on(this.handlers)
	};
	e.Defaults = {
		animateOut: !1,
		animateIn: !1
	}, e.prototype.swap = function() {
		if (1 === this.core.settings.items && this.core.support3d) {
			this.core.speed(0);
			var b, c = a.proxy(this.clear, this),
				d = this.core.$stage.children().eq(this.previous),
				e = this.core.$stage.children().eq(this.next),
				f = this.core.settings.animateIn,
				g = this.core.settings.animateOut;
			this.core.current() !== this.previous && (g && (b = this.core.coordinates(this.previous) - this.core.coordinates(this.next), d.css({
				left: b + "px"
			}).addClass("animated owl-animated-out").addClass(g).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", c)), f && e.addClass("animated owl-animated-in").addClass(f).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", c))
		}
	}, e.prototype.clear = function(b) {
		a(b.target).css({
			left: ""
		}).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.transitionEnd()
	}, e.prototype.destroy = function() {
		var a, b;
		for (a in this.handlers) this.core.$element.off(a, this.handlers[a]);
		for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null)
	}, a.fn.owlCarousel.Constructor.Plugins.Animate = e
}(window.Zepto || window.jQuery, window, document),
function(a, b, c) {
	var d = function(b) {
		this.core = b, this.core.options = a.extend({}, d.Defaults, this.core.options), this.handlers = {
			"translated.owl.carousel refreshed.owl.carousel": a.proxy(function() {
				this.autoplay()
			}, this),
			"play.owl.autoplay": a.proxy(function(a, b, c) {
				this.play(b, c)
			}, this),
			"stop.owl.autoplay": a.proxy(function() {
				this.stop()
			}, this),
			"mouseover.owl.autoplay": a.proxy(function() {
				this.core.settings.autoplayHoverPause && this.pause()
			}, this),
			"mouseleave.owl.autoplay": a.proxy(function() {
				this.core.settings.autoplayHoverPause && this.autoplay()
			}, this)
		}, this.core.$element.on(this.handlers)
	};
	d.Defaults = {
		autoplay: !1,
		autoplayTimeout: 5e3,
		autoplayHoverPause: !1,
		autoplaySpeed: !1
	}, d.prototype.autoplay = function() {
		this.core.settings.autoplay && !this.core.state.videoPlay ? (b.clearInterval(this.interval), this.interval = b.setInterval(a.proxy(function() {
			this.play()
		}, this), this.core.settings.autoplayTimeout)) : b.clearInterval(this.interval)
	}, d.prototype.play = function() {
		return c.hidden === !0 || this.core.state.isTouch || this.core.state.isScrolling || this.core.state.isSwiping || this.core.state.inMotion ? void 0 : this.core.settings.autoplay === !1 ? void b.clearInterval(this.interval) : void this.core.next(this.core.settings.autoplaySpeed)
	}, d.prototype.stop = function() {
		b.clearInterval(this.interval)
	}, d.prototype.pause = function() {
		b.clearInterval(this.interval)
	}, d.prototype.destroy = function() {
		var a, c;
		b.clearInterval(this.interval);
		for (a in this.handlers) this.core.$element.off(a, this.handlers[a]);
		for (c in Object.getOwnPropertyNames(this)) "function" != typeof this[c] && (this[c] = null)
	}, a.fn.owlCarousel.Constructor.Plugins.autoplay = d
}(window.Zepto || window.jQuery, window, document),
function(a) {
	"use strict";
	var b = function(c) {
		this._core = c, this._initialized = !1, this._pages = [], this._controls = {}, this._templates = [], this.$element = this._core.$element, this._overrides = {
			next: this._core.next,
			prev: this._core.prev,
			to: this._core.to
		}, this._handlers = {
			"prepared.owl.carousel": a.proxy(function(b) {
				this._core.settings.dotsData && this._templates.push(a(b.content).find("[data-dot]").andSelf("[data-dot]").attr("data-dot"))
			}, this),
			"add.owl.carousel": a.proxy(function(b) {
				this._core.settings.dotsData && this._templates.splice(b.position, 0, a(b.content).find("[data-dot]").andSelf("[data-dot]").attr("data-dot"))
			}, this),
			"remove.owl.carousel prepared.owl.carousel": a.proxy(function(a) {
				this._core.settings.dotsData && this._templates.splice(a.position, 1)
			}, this),
			"change.owl.carousel": a.proxy(function(a) {
				if ("position" == a.property.name && !this._core.state.revert && !this._core.settings.loop && this._core.settings.navRewind) {
					var b = this._core.current(),
						c = this._core.maximum(),
						d = this._core.minimum();
					a.data = a.property.value > c ? b >= c ? d : c : a.property.value < d ? c : a.property.value
				}
			}, this),
			"changed.owl.carousel": a.proxy(function(a) {
				"position" == a.property.name && this.draw()
			}, this),
			"refreshed.owl.carousel": a.proxy(function() {
				this._initialized || (this.initialize(), this._initialized = !0), this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation")
			}, this)
		}, this._core.options = a.extend({}, b.Defaults, this._core.options), this.$element.on(this._handlers)
	};
	b.Defaults = {
		nav: !1,
		navRewind: !0,
		navText: ["prev", "next"],
		navSpeed: !1,
		navElement: "div",
		navContainer: !1,
		navContainerClass: "owl-nav",
		navClass: ["owl-prev", "owl-next"],
		slideBy: 1,
		dotClass: "owl-dot",
		dotsClass: "owl-dots",
		dots: !0,
		dotsEach: !1,
		dotData: !1,
		dotsSpeed: !1,
		dotsContainer: !1,
		controlsClass: "owl-controls"
	}, b.prototype.initialize = function() {
		var b, c, d = this._core.settings;
		d.dotsData || (this._templates = [a("<div>").addClass(d.dotClass).append(a("<span>")).prop("outerHTML")]), d.navContainer && d.dotsContainer || (this._controls.$container = a("<div>").addClass(d.controlsClass).appendTo(this.$element)), this._controls.$indicators = d.dotsContainer ? a(d.dotsContainer) : a("<div>").hide().addClass(d.dotsClass).appendTo(this._controls.$container), this._controls.$indicators.on("click", "div", a.proxy(function(b) {
			var c = a(b.target).parent().is(this._controls.$indicators) ? a(b.target).index() : a(b.target).parent().index();
			b.preventDefault(), this.to(c, d.dotsSpeed)
		}, this)), b = d.navContainer ? a(d.navContainer) : a("<div>").addClass(d.navContainerClass).prependTo(this._controls.$container), this._controls.$next = a("<" + d.navElement + ">"), this._controls.$previous = this._controls.$next.clone(), this._controls.$previous.addClass(d.navClass[0]).html(d.navText[0]).hide().prependTo(b).on("click", a.proxy(function() {
			this.prev(d.navSpeed)
		}, this)), this._controls.$next.addClass(d.navClass[1]).html(d.navText[1]).hide().appendTo(b).on("click", a.proxy(function() {
			this.next(d.navSpeed)
		}, this));
		for (c in this._overrides) this._core[c] = a.proxy(this[c], this)
	}, b.prototype.destroy = function() {
		var a, b, c, d;
		for (a in this._handlers) this.$element.off(a, this._handlers[a]);
		for (b in this._controls) this._controls[b].remove();
		for (d in this.overides) this._core[d] = this._overrides[d];
		for (c in Object.getOwnPropertyNames(this)) "function" != typeof this[c] && (this[c] = null)
	}, b.prototype.update = function() {
		var a, b, c, d = this._core.settings,
			e = this._core.clones().length / 2,
			f = e + this._core.items().length,
			g = d.center || d.autoWidth || d.dotData ? 1 : d.dotsEach || d.items;
		if ("page" !== d.slideBy && (d.slideBy = Math.min(d.slideBy, d.items)), d.dots || "page" == d.slideBy)
			for (this._pages = [], a = e, b = 0, c = 0; f > a; a++)(b >= g || 0 === b) && (this._pages.push({
				start: a - e,
				end: a - e + g - 1
			}), b = 0, ++c), b += this._core.mergers(this._core.relative(a))
	}, b.prototype.draw = function() {
		var b, c, d = "",
			e = this._core.settings,
			f = (this._core.$stage.children(), this._core.relative(this._core.current()));
		if (!e.nav || e.loop || e.navRewind || (this._controls.$previous.toggleClass("disabled", 0 >= f), this._controls.$next.toggleClass("disabled", f >= this._core.maximum())), this._controls.$previous.toggle(e.nav), this._controls.$next.toggle(e.nav), e.dots) {
			if (b = this._pages.length - this._controls.$indicators.children().length, e.dotData && 0 !== b) {
				for (c = 0; c < this._controls.$indicators.children().length; c++) d += this._templates[this._core.relative(c)];
				this._controls.$indicators.html(d)
			} else b > 0 ? (d = new Array(b + 1).join(this._templates[0]), this._controls.$indicators.append(d)) : 0 > b && this._controls.$indicators.children().slice(b).remove();
			this._controls.$indicators.find(".active").removeClass("active"), this._controls.$indicators.children().eq(a.inArray(this.current(), this._pages)).addClass("active")
		}
		this._controls.$indicators.toggle(e.dots)
	}, b.prototype.onTrigger = function(b) {
		var c = this._core.settings;
		b.page = {
			index: a.inArray(this.current(), this._pages),
			count: this._pages.length,
			size: c && (c.center || c.autoWidth || c.dotData ? 1 : c.dotsEach || c.items)
		}
	}, b.prototype.current = function() {
		var b = this._core.relative(this._core.current());
		return a.grep(this._pages, function(a) {
			return a.start <= b && a.end >= b
		}).pop()
	}, b.prototype.getPosition = function(b) {
		var c, d, e = this._core.settings;
		return "page" == e.slideBy ? (c = a.inArray(this.current(), this._pages), d = this._pages.length, b ? ++c : --c, c = this._pages[(c % d + d) % d].start) : (c = this._core.relative(this._core.current()), d = this._core.items().length, b ? c += e.slideBy : c -= e.slideBy), c
	}, b.prototype.next = function(b) {
		a.proxy(this._overrides.to, this._core)(this.getPosition(!0), b)
	}, b.prototype.prev = function(b) {
		a.proxy(this._overrides.to, this._core)(this.getPosition(!1), b)
	}, b.prototype.to = function(b, c, d) {
		var e;
		d ? a.proxy(this._overrides.to, this._core)(b, c) : (e = this._pages.length, a.proxy(this._overrides.to, this._core)(this._pages[(b % e + e) % e].start, c))
	}, a.fn.owlCarousel.Constructor.Plugins.Navigation = b
}(window.Zepto || window.jQuery, window, document),
function(a, b) {
	"use strict";
	var c = function(d) {
		this._core = d, this._hashes = {}, this.$element = this._core.$element, this._handlers = {
			"initialized.owl.carousel": a.proxy(function() {
				"URLHash" == this._core.settings.startPosition && a(b).trigger("hashchange.owl.navigation")
			}, this),
			"prepared.owl.carousel": a.proxy(function(b) {
				var c = a(b.content).find("[data-hash]").andSelf("[data-hash]").attr("data-hash");
				this._hashes[c] = b.content
			}, this)
		}, this._core.options = a.extend({}, c.Defaults, this._core.options), this.$element.on(this._handlers), a(b).on("hashchange.owl.navigation", a.proxy(function() {
			var a = b.location.hash.substring(1),
				c = this._core.$stage.children(),
				d = this._hashes[a] && c.index(this._hashes[a]) || 0;
			return a ? void this._core.to(d, !1, !0) : !1
		}, this))
	};
	c.Defaults = {
		URLhashListener: !1
	}, c.prototype.destroy = function() {
		var c, d;
		a(b).off("hashchange.owl.navigation");
		for (c in this._handlers) this._core.$element.off(c, this._handlers[c]);
		for (d in Object.getOwnPropertyNames(this)) "function" != typeof this[d] && (this[d] = null)
	}, a.fn.owlCarousel.Constructor.Plugins.Hash = c
}(window.Zepto || window.jQuery, window, document);
/*
jQuery Waypoints - v2.0.3
Copyright (c) 2011-2013 Caleb Troughton
Dual licensed under the MIT license and GPL license.
https://github.com/imakewebthings/jquery-waypoints/blob/master/licenses.txt
*/
(function() {
	var t = [].indexOf || function(t) {
			for (var e = 0, n = this.length; e < n; e++) {
				if (e in this && this[e] === t) return e
			}
			return -1
		},
		e = [].slice;
	(function(t, e) {
		if (typeof define === "function" && define.amd) {
			return define("waypoints", ["jquery"], function(n) {
				return e(n, t)
			})
		} else {
			return e(t.jQuery, t)
		}
	})(this, function(n, r) {
		var i, o, l, s, f, u, a, c, h, d, p, y, v, w, g, m;
		i = n(r);
		c = t.call(r, "ontouchstart") >= 0;
		s = {
			horizontal: {},
			vertical: {}
		};
		f = 1;
		a = {};
		u = "waypoints-context-id";
		p = "resize.waypoints";
		y = "scroll.waypoints";
		v = 1;
		w = "waypoints-waypoint-ids";
		g = "waypoint";
		m = "waypoints";
		o = function() {
			function t(t) {
				var e = this;
				this.$element = t;
				this.element = t[0];
				this.didResize = false;
				this.didScroll = false;
				this.id = "context" + f++;
				this.oldScroll = {
					x: t.scrollLeft(),
					y: t.scrollTop()
				};
				this.waypoints = {
					horizontal: {},
					vertical: {}
				};
				t.data(u, this.id);
				a[this.id] = this;
				t.bind(y, function() {
					var t;
					if (!(e.didScroll || c)) {
						e.didScroll = true;
						t = function() {
							e.doScroll();
							return e.didScroll = false
						};
						return r.setTimeout(t, n[m].settings.scrollThrottle)
					}
				});
				t.bind(p, function() {
					var t;
					if (!e.didResize) {
						e.didResize = true;
						t = function() {
							n[m]("refresh");
							return e.didResize = false
						};
						return r.setTimeout(t, n[m].settings.resizeThrottle)
					}
				})
			}
			t.prototype.doScroll = function() {
				var t, e = this;
				t = {
					horizontal: {
						newScroll: this.$element.scrollLeft(),
						oldScroll: this.oldScroll.x,
						forward: "right",
						backward: "left"
					},
					vertical: {
						newScroll: this.$element.scrollTop(),
						oldScroll: this.oldScroll.y,
						forward: "down",
						backward: "up"
					}
				};
				if (c && (!t.vertical.oldScroll || !t.vertical.newScroll)) {
					n[m]("refresh")
				}
				n.each(t, function(t, r) {
					var i, o, l;
					l = [];
					o = r.newScroll > r.oldScroll;
					i = o ? r.forward : r.backward;
					n.each(e.waypoints[t], function(t, e) {
						var n, i;
						if (r.oldScroll < (n = e.offset) && n <= r.newScroll) {
							return l.push(e)
						} else if (r.newScroll < (i = e.offset) && i <= r.oldScroll) {
							return l.push(e)
						}
					});
					l.sort(function(t, e) {
						return t.offset - e.offset
					});
					if (!o) {
						l.reverse()
					}
					return n.each(l, function(t, e) {
						if (e.options.continuous || t === l.length - 1) {
							return e.trigger([i])
						}
					})
				});
				return this.oldScroll = {
					x: t.horizontal.newScroll,
					y: t.vertical.newScroll
				}
			};
			t.prototype.refresh = function() {
				var t, e, r, i = this;
				r = n.isWindow(this.element);
				e = this.$element.offset();
				this.doScroll();
				t = {
					horizontal: {
						contextOffset: r ? 0 : e.left,
						contextScroll: r ? 0 : this.oldScroll.x,
						contextDimension: this.$element.width(),
						oldScroll: this.oldScroll.x,
						forward: "right",
						backward: "left",
						offsetProp: "left"
					},
					vertical: {
						contextOffset: r ? 0 : e.top,
						contextScroll: r ? 0 : this.oldScroll.y,
						contextDimension: r ? n[m]("viewportHeight") : this.$element.height(),
						oldScroll: this.oldScroll.y,
						forward: "down",
						backward: "up",
						offsetProp: "top"
					}
				};
				return n.each(t, function(t, e) {
					return n.each(i.waypoints[t], function(t, r) {
						var i, o, l, s, f;
						i = r.options.offset;
						l = r.offset;
						o = n.isWindow(r.element) ? 0 : r.$element.offset()[e.offsetProp];
						if (n.isFunction(i)) {
							i = i.apply(r.element)
						} else if (typeof i === "string") {
							i = parseFloat(i);
							if (r.options.offset.indexOf("%") > -1) {
								i = Math.ceil(e.contextDimension * i / 100)
							}
						}
						r.offset = o - e.contextOffset + e.contextScroll - i;
						if (r.options.onlyOnScroll && l != null || !r.enabled) {
							return
						}
						if (l !== null && l < (s = e.oldScroll) && s <= r.offset) {
							return r.trigger([e.backward])
						} else if (l !== null && l > (f = e.oldScroll) && f >= r.offset) {
							return r.trigger([e.forward])
						} else if (l === null && e.oldScroll >= r.offset) {
							return r.trigger([e.forward])
						}
					})
				})
			};
			t.prototype.checkEmpty = function() {
				if (n.isEmptyObject(this.waypoints.horizontal) && n.isEmptyObject(this.waypoints.vertical)) {
					this.$element.unbind([p, y].join(" "));
					return delete a[this.id]
				}
			};
			return t
		}();
		l = function() {
			function t(t, e, r) {
				var i, o;
				r = n.extend({}, n.fn[g].defaults, r);
				if (r.offset === "bottom-in-view") {
					r.offset = function() {
						var t;
						t = n[m]("viewportHeight");
						if (!n.isWindow(e.element)) {
							t = e.$element.height()
						}
						return t - n(this).outerHeight()
					}
				}
				this.$element = t;
				this.element = t[0];
				this.axis = r.horizontal ? "horizontal" : "vertical";
				this.callback = r.handler;
				this.context = e;
				this.enabled = r.enabled;
				this.id = "waypoints" + v++;
				this.offset = null;
				this.options = r;
				e.waypoints[this.axis][this.id] = this;
				s[this.axis][this.id] = this;
				i = (o = t.data(w)) != null ? o : [];
				i.push(this.id);
				t.data(w, i)
			}
			t.prototype.trigger = function(t) {
				if (!this.enabled) {
					return
				}
				if (this.callback != null) {
					this.callback.apply(this.element, t)
				}
				if (this.options.triggerOnce) {
					return this.destroy()
				}
			};
			t.prototype.disable = function() {
				return this.enabled = false
			};
			t.prototype.enable = function() {
				this.context.refresh();
				return this.enabled = true
			};
			t.prototype.destroy = function() {
				delete s[this.axis][this.id];
				delete this.context.waypoints[this.axis][this.id];
				return this.context.checkEmpty()
			};
			t.getWaypointsByElement = function(t) {
				var e, r;
				r = n(t).data(w);
				if (!r) {
					return []
				}
				e = n.extend({}, s.horizontal, s.vertical);
				return n.map(r, function(t) {
					return e[t]
				})
			};
			return t
		}();
		d = {
			init: function(t, e) {
				var r;
				if (e == null) {
					e = {}
				}
				if ((r = e.handler) == null) {
					e.handler = t
				}
				this.each(function() {
					var t, r, i, s;
					t = n(this);
					i = (s = e.context) != null ? s : n.fn[g].defaults.context;
					if (!n.isWindow(i)) {
						i = t.closest(i)
					}
					i = n(i);
					r = a[i.data(u)];
					if (!r) {
						r = new o(i)
					}
					return new l(t, r, e)
				});
				n[m]("refresh");
				return this
			},
			disable: function() {
				return d._invoke(this, "disable")
			},
			enable: function() {
				return d._invoke(this, "enable")
			},
			destroy: function() {
				return d._invoke(this, "destroy")
			},
			prev: function(t, e) {
				return d._traverse.call(this, t, e, function(t, e, n) {
					if (e > 0) {
						return t.push(n[e - 1])
					}
				})
			},
			next: function(t, e) {
				return d._traverse.call(this, t, e, function(t, e, n) {
					if (e < n.length - 1) {
						return t.push(n[e + 1])
					}
				})
			},
			_traverse: function(t, e, i) {
				var o, l;
				if (t == null) {
					t = "vertical"
				}
				if (e == null) {
					e = r
				}
				l = h.aggregate(e);
				o = [];
				this.each(function() {
					var e;
					e = n.inArray(this, l[t]);
					return i(o, e, l[t])
				});
				return this.pushStack(o)
			},
			_invoke: function(t, e) {
				t.each(function() {
					var t;
					t = l.getWaypointsByElement(this);
					return n.each(t, function(t, n) {
						n[e]();
						return true
					})
				});
				return this
			}
		};
		n.fn[g] = function() {
			var t, r;
			r = arguments[0], t = 2 <= arguments.length ? e.call(arguments, 1) : [];
			if (d[r]) {
				return d[r].apply(this, t)
			} else if (n.isFunction(r)) {
				return d.init.apply(this, arguments)
			} else if (n.isPlainObject(r)) {
				return d.init.apply(this, [null, r])
			} else if (!r) {
				return n.error("jQuery Waypoints needs a callback function or handler option.")
			} else {
				return n.error("The " + r + " method does not exist in jQuery Waypoints.")
			}
		};
		n.fn[g].defaults = {
			context: r,
			continuous: true,
			enabled: true,
			horizontal: false,
			offset: 0,
			triggerOnce: false
		};
		h = {
			refresh: function() {
				return n.each(a, function(t, e) {
					return e.refresh()
				})
			},
			viewportHeight: function() {
				var t;
				return (t = r.innerHeight) != null ? t : i.height()
			},
			aggregate: function(t) {
				var e, r, i;
				e = s;
				if (t) {
					e = (i = a[n(t).data(u)]) != null ? i.waypoints : void 0
				}
				if (!e) {
					return []
				}
				r = {
					horizontal: [],
					vertical: []
				};
				n.each(r, function(t, i) {
					n.each(e[t], function(t, e) {
						return i.push(e)
					});
					i.sort(function(t, e) {
						return t.offset - e.offset
					});
					r[t] = n.map(i, function(t) {
						return t.element
					});
					return r[t] = n.unique(r[t])
				});
				return r
			},
			above: function(t) {
				if (t == null) {
					t = r
				}
				return h._filter(t, "vertical", function(t, e) {
					return e.offset <= t.oldScroll.y
				})
			},
			below: function(t) {
				if (t == null) {
					t = r
				}
				return h._filter(t, "vertical", function(t, e) {
					return e.offset > t.oldScroll.y
				})
			},
			left: function(t) {
				if (t == null) {
					t = r
				}
				return h._filter(t, "horizontal", function(t, e) {
					return e.offset <= t.oldScroll.x
				})
			},
			right: function(t) {
				if (t == null) {
					t = r
				}
				return h._filter(t, "horizontal", function(t, e) {
					return e.offset > t.oldScroll.x
				})
			},
			enable: function() {
				return h._invoke("enable")
			},
			disable: function() {
				return h._invoke("disable")
			},
			destroy: function() {
				return h._invoke("destroy")
			},
			extendFn: function(t, e) {
				return d[t] = e
			},
			_invoke: function(t) {
				var e;
				e = n.extend({}, s.vertical, s.horizontal);
				return n.each(e, function(e, n) {
					n[t]();
					return true
				})
			},
			_filter: function(t, e, r) {
				var i, o;
				i = a[n(t).data(u)];
				if (!i) {
					return []
				}
				o = [];
				n.each(i.waypoints[e], function(t, e) {
					if (r(i, e)) {
						return o.push(e)
					}
				});
				o.sort(function(t, e) {
					return t.offset - e.offset
				});
				return n.map(o, function(t) {
					return t.element
				})
			}
		};
		n[m] = function() {
			var t, n;
			n = arguments[0], t = 2 <= arguments.length ? e.call(arguments, 1) : [];
			if (h[n]) {
				return h[n].apply(null, t)
			} else {
				return h.aggregate.call(null, n)
			}
		};
		n[m].settings = {
			resizeThrottle: 100,
			scrollThrottle: 30
		};
		return i.load(function() {
			return n[m]("refresh")
		})
	})
}).call(this);
/*!
 * jquery.counterup.js 1.0 
 * Copyright 2013, Benjamin Intal http://gambit.ph @bfintal 
 */
(function(e) {
	"use strict";
	e.fn.counterUp = function(t) {
		var n = e.extend({
			time: 400,
			delay: 10
		}, t);
		return this.each(function() {
			var t = e(this),
				r = n,
				i = function() {
					var e = [],
						n = r.time / r.delay,
						i = t.text(),
						s = /[0-9]+,[0-9]+/.test(i);
					i = i.replace(/,/g, "");
					var o = /^[0-9]+$/.test(i),
						u = /^[0-9]+\.[0-9]+$/.test(i),
						a = u ? (i.split(".")[1] || []).length : 0;
					for (var f = n; f >= 1; f--) {
						var l = parseInt(i / n * f);
						u && (l = parseFloat(i / n * f).toFixed(a));
						if (s)
							while (/(\d+)(\d{3})/.test(l.toString())) l = l.toString().replace(/(\d+)(\d{3})/, "$1,$2");
						e.unshift(l)
					}
					t.data("counterup-nums", e);
					t.text("0");
					var c = function() {
						t.text(t.data("counterup-nums").shift());
						if (t.data("counterup-nums").length) setTimeout(t.data("counterup-func"), r.delay);
						else {
							delete t.data("counterup-nums");
							t.data("counterup-nums", null);
							t.data("counterup-func", null)
						}
					};
					t.data("counterup-func", c);
					setTimeout(t.data("counterup-func"), r.delay)
				};
			t.waypoint(i, {
				offset: "100%",
				triggerOnce: !0
			})
		})
	}
})(jQuery);
/*! Magnific Popup - v1.1.0 - 2016-02-20
 * http://dimsemenov.com/plugins/magnific-popup/
 * Copyright (c) 2016 Dmitry Semenov; */
! function(a) {
	"function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == typeof exports ? require("jquery") : window.jQuery || window.Zepto)
}(function(a) {
	var b, c, d, e, f, g, h = "Close",
		i = "BeforeClose",
		j = "AfterClose",
		k = "BeforeAppend",
		l = "MarkupParse",
		m = "Open",
		n = "Change",
		o = "mfp",
		p = "." + o,
		q = "mfp-ready",
		r = "mfp-removing",
		s = "mfp-prevent-close",
		t = function() {},
		u = !!window.jQuery,
		v = a(window),
		w = function(a, c) {
			b.ev.on(o + a + p, c)
		},
		x = function(b, c, d, e) {
			var f = document.createElement("div");
			return f.className = "mfp-" + b, d && (f.innerHTML = d), e ? c && c.appendChild(f) : (f = a(f), c && f.appendTo(c)), f
		},
		y = function(c, d) {
			b.ev.triggerHandler(o + c, d), b.st.callbacks && (c = c.charAt(0).toLowerCase() + c.slice(1), b.st.callbacks[c] && b.st.callbacks[c].apply(b, a.isArray(d) ? d : [d]))
		},
		z = function(c) {
			return c === g && b.currTemplate.closeBtn || (b.currTemplate.closeBtn = a(b.st.closeMarkup.replace("%title%", b.st.tClose)), g = c), b.currTemplate.closeBtn
		},
		A = function() {
			a.magnificPopup.instance || (b = new t, b.init(), a.magnificPopup.instance = b)
		},
		B = function() {
			var a = document.createElement("p").style,
				b = ["ms", "O", "Moz", "Webkit"];
			if (void 0 !== a.transition) return !0;
			for (; b.length;)
				if (b.pop() + "Transition" in a) return !0;
			return !1
		};
	t.prototype = {
		constructor: t,
		init: function() {
			var c = navigator.appVersion;
			b.isLowIE = b.isIE8 = document.all && !document.addEventListener, b.isAndroid = /android/gi.test(c), b.isIOS = /iphone|ipad|ipod/gi.test(c), b.supportsTransition = B(), b.probablyMobile = b.isAndroid || b.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), d = a(document), b.popupsCache = {}
		},
		open: function(c) {
			var e;
			if (c.isObj === !1) {
				b.items = c.items.toArray(), b.index = 0;
				var g, h = c.items;
				for (e = 0; e < h.length; e++)
					if (g = h[e], g.parsed && (g = g.el[0]), g === c.el[0]) {
						b.index = e;
						break
					}
			} else b.items = a.isArray(c.items) ? c.items : [c.items], b.index = c.index || 0;
			if (b.isOpen) return void b.updateItemHTML();
			b.types = [], f = "", c.mainEl && c.mainEl.length ? b.ev = c.mainEl.eq(0) : b.ev = d, c.key ? (b.popupsCache[c.key] || (b.popupsCache[c.key] = {}), b.currTemplate = b.popupsCache[c.key]) : b.currTemplate = {}, b.st = a.extend(!0, {}, a.magnificPopup.defaults, c), b.fixedContentPos = "auto" === b.st.fixedContentPos ? !b.probablyMobile : b.st.fixedContentPos, b.st.modal && (b.st.closeOnContentClick = !1, b.st.closeOnBgClick = !1, b.st.showCloseBtn = !1, b.st.enableEscapeKey = !1), b.bgOverlay || (b.bgOverlay = x("bg").on("click" + p, function() {
				b.close()
			}), b.wrap = x("wrap").attr("tabindex", -1).on("click" + p, function(a) {
				b._checkIfClose(a.target) && b.close()
			}), b.container = x("container", b.wrap)), b.contentContainer = x("content"), b.st.preloader && (b.preloader = x("preloader", b.container, b.st.tLoading));
			var i = a.magnificPopup.modules;
			for (e = 0; e < i.length; e++) {
				var j = i[e];
				j = j.charAt(0).toUpperCase() + j.slice(1), b["init" + j].call(b)
			}
			y("BeforeOpen"), b.st.showCloseBtn && (b.st.closeBtnInside ? (w(l, function(a, b, c, d) {
				c.close_replaceWith = z(d.type)
			}), f += " mfp-close-btn-in") : b.wrap.append(z())), b.st.alignTop && (f += " mfp-align-top"), b.fixedContentPos ? b.wrap.css({
				overflow: b.st.overflowY,
				overflowX: "hidden",
				overflowY: b.st.overflowY
			}) : b.wrap.css({
				top: v.scrollTop(),
				position: "absolute"
			}), (b.st.fixedBgPos === !1 || "auto" === b.st.fixedBgPos && !b.fixedContentPos) && b.bgOverlay.css({
				height: d.height(),
				position: "absolute"
			}), b.st.enableEscapeKey && d.on("keyup" + p, function(a) {
				27 === a.keyCode && b.close()
			}), v.on("resize" + p, function() {
				b.updateSize()
			}), b.st.closeOnContentClick || (f += " mfp-auto-cursor"), f && b.wrap.addClass(f);
			var k = b.wH = v.height(),
				n = {};
			if (b.fixedContentPos && b._hasScrollBar(k)) {
				var o = b._getScrollbarSize();
				o && (n.marginRight = o)
			}
			b.fixedContentPos && (b.isIE7 ? a("body, html").css("overflow", "hidden") : n.overflow = "hidden");
			var r = b.st.mainClass;
			return b.isIE7 && (r += " mfp-ie7"), r && b._addClassToMFP(r), b.updateItemHTML(), y("BuildControls"), a("html").css(n), b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo || a(document.body)), b._lastFocusedEl = document.activeElement, setTimeout(function() {
				b.content ? (b._addClassToMFP(q), b._setFocus()) : b.bgOverlay.addClass(q), d.on("focusin" + p, b._onFocusIn)
			}, 16), b.isOpen = !0, b.updateSize(k), y(m), c
		},
		close: function() {
			b.isOpen && (y(i), b.isOpen = !1, b.st.removalDelay && !b.isLowIE && b.supportsTransition ? (b._addClassToMFP(r), setTimeout(function() {
				b._close()
			}, b.st.removalDelay)) : b._close())
		},
		_close: function() {
			y(h);
			var c = r + " " + q + " ";
			if (b.bgOverlay.detach(), b.wrap.detach(), b.container.empty(), b.st.mainClass && (c += b.st.mainClass + " "), b._removeClassFromMFP(c), b.fixedContentPos) {
				var e = {
					marginRight: ""
				};
				b.isIE7 ? a("body, html").css("overflow", "") : e.overflow = "", a("html").css(e)
			}
			d.off("keyup" + p + " focusin" + p), b.ev.off(p), b.wrap.attr("class", "mfp-wrap").removeAttr("style"), b.bgOverlay.attr("class", "mfp-bg"), b.container.attr("class", "mfp-container"), !b.st.showCloseBtn || b.st.closeBtnInside && b.currTemplate[b.currItem.type] !== !0 || b.currTemplate.closeBtn && b.currTemplate.closeBtn.detach(), b.st.autoFocusLast && b._lastFocusedEl && a(b._lastFocusedEl).focus(), b.currItem = null, b.content = null, b.currTemplate = null, b.prevHeight = 0, y(j)
		},
		updateSize: function(a) {
			if (b.isIOS) {
				var c = document.documentElement.clientWidth / window.innerWidth,
					d = window.innerHeight * c;
				b.wrap.css("height", d), b.wH = d
			} else b.wH = a || v.height();
			b.fixedContentPos || b.wrap.css("height", b.wH), y("Resize")
		},
		updateItemHTML: function() {
			var c = b.items[b.index];
			b.contentContainer.detach(), b.content && b.content.detach(), c.parsed || (c = b.parseEl(b.index));
			var d = c.type;
			if (y("BeforeChange", [b.currItem ? b.currItem.type : "", d]), b.currItem = c, !b.currTemplate[d]) {
				var f = b.st[d] ? b.st[d].markup : !1;
				y("FirstMarkupParse", f), f ? b.currTemplate[d] = a(f) : b.currTemplate[d] = !0
			}
			e && e !== c.type && b.container.removeClass("mfp-" + e + "-holder");
			var g = b["get" + d.charAt(0).toUpperCase() + d.slice(1)](c, b.currTemplate[d]);
			b.appendContent(g, d), c.preloaded = !0, y(n, c), e = c.type, b.container.prepend(b.contentContainer), y("AfterChange")
		},
		appendContent: function(a, c) {
			b.content = a, a ? b.st.showCloseBtn && b.st.closeBtnInside && b.currTemplate[c] === !0 ? b.content.find(".mfp-close").length || b.content.append(z()) : b.content = a : b.content = "", y(k), b.container.addClass("mfp-" + c + "-holder"), b.contentContainer.append(b.content)
		},
		parseEl: function(c) {
			var d, e = b.items[c];
			if (e.tagName ? e = {
					el: a(e)
				} : (d = e.type, e = {
					data: e,
					src: e.src
				}), e.el) {
				for (var f = b.types, g = 0; g < f.length; g++)
					if (e.el.hasClass("mfp-" + f[g])) {
						d = f[g];
						break
					}
				e.src = e.el.attr("data-mfp-src"), e.src || (e.src = e.el.attr("href"))
			}
			return e.type = d || b.st.type || "inline", e.index = c, e.parsed = !0, b.items[c] = e, y("ElementParse", e), b.items[c]
		},
		addGroup: function(a, c) {
			var d = function(d) {
				d.mfpEl = this, b._openClick(d, a, c)
			};
			c || (c = {});
			var e = "click.magnificPopup";
			c.mainEl = a, c.items ? (c.isObj = !0, a.off(e).on(e, d)) : (c.isObj = !1, c.delegate ? a.off(e).on(e, c.delegate, d) : (c.items = a, a.off(e).on(e, d)))
		},
		_openClick: function(c, d, e) {
			var f = void 0 !== e.midClick ? e.midClick : a.magnificPopup.defaults.midClick;
			if (f || !(2 === c.which || c.ctrlKey || c.metaKey || c.altKey || c.shiftKey)) {
				var g = void 0 !== e.disableOn ? e.disableOn : a.magnificPopup.defaults.disableOn;
				if (g)
					if (a.isFunction(g)) {
						if (!g.call(b)) return !0
					} else if (v.width() < g) return !0;
				c.type && (c.preventDefault(), b.isOpen && c.stopPropagation()), e.el = a(c.mfpEl), e.delegate && (e.items = d.find(e.delegate)), b.open(e)
			}
		},
		updateStatus: function(a, d) {
			if (b.preloader) {
				c !== a && b.container.removeClass("mfp-s-" + c), d || "loading" !== a || (d = b.st.tLoading);
				var e = {
					status: a,
					text: d
				};
				y("UpdateStatus", e), a = e.status, d = e.text, b.preloader.html(d), b.preloader.find("a").on("click", function(a) {
					a.stopImmediatePropagation()
				}), b.container.addClass("mfp-s-" + a), c = a
			}
		},
		_checkIfClose: function(c) {
			if (!a(c).hasClass(s)) {
				var d = b.st.closeOnContentClick,
					e = b.st.closeOnBgClick;
				if (d && e) return !0;
				if (!b.content || a(c).hasClass("mfp-close") || b.preloader && c === b.preloader[0]) return !0;
				if (c === b.content[0] || a.contains(b.content[0], c)) {
					if (d) return !0
				} else if (e && a.contains(document, c)) return !0;
				return !1
			}
		},
		_addClassToMFP: function(a) {
			b.bgOverlay.addClass(a), b.wrap.addClass(a)
		},
		_removeClassFromMFP: function(a) {
			this.bgOverlay.removeClass(a), b.wrap.removeClass(a)
		},
		_hasScrollBar: function(a) {
			return (b.isIE7 ? d.height() : document.body.scrollHeight) > (a || v.height())
		},
		_setFocus: function() {
			(b.st.focus ? b.content.find(b.st.focus).eq(0) : b.wrap).focus()
		},
		_onFocusIn: function(c) {
			return c.target === b.wrap[0] || a.contains(b.wrap[0], c.target) ? void 0 : (b._setFocus(), !1)
		},
		_parseMarkup: function(b, c, d) {
			var e;
			d.data && (c = a.extend(d.data, c)), y(l, [b, c, d]), a.each(c, function(c, d) {
				if (void 0 === d || d === !1) return !0;
				if (e = c.split("_"), e.length > 1) {
					var f = b.find(p + "-" + e[0]);
					if (f.length > 0) {
						var g = e[1];
						"replaceWith" === g ? f[0] !== d[0] && f.replaceWith(d) : "img" === g ? f.is("img") ? f.attr("src", d) : f.replaceWith(a("<img>").attr("src", d).attr("class", f.attr("class"))) : f.attr(e[1], d)
					}
				} else b.find(p + "-" + c).html(d)
			})
		},
		_getScrollbarSize: function() {
			if (void 0 === b.scrollbarSize) {
				var a = document.createElement("div");
				a.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(a), b.scrollbarSize = a.offsetWidth - a.clientWidth, document.body.removeChild(a)
			}
			return b.scrollbarSize
		}
	}, a.magnificPopup = {
		instance: null,
		proto: t.prototype,
		modules: [],
		open: function(b, c) {
			return A(), b = b ? a.extend(!0, {}, b) : {}, b.isObj = !0, b.index = c || 0, this.instance.open(b)
		},
		close: function() {
			return a.magnificPopup.instance && a.magnificPopup.instance.close()
		},
		registerModule: function(b, c) {
			c.options && (a.magnificPopup.defaults[b] = c.options), a.extend(this.proto, c.proto), this.modules.push(b)
		},
		defaults: {
			disableOn: 0,
			key: null,
			midClick: !1,
			mainClass: "",
			preloader: !0,
			focus: "",
			closeOnContentClick: !1,
			closeOnBgClick: !0,
			closeBtnInside: !0,
			showCloseBtn: !0,
			enableEscapeKey: !0,
			modal: !1,
			alignTop: !1,
			removalDelay: 0,
			prependTo: null,
			fixedContentPos: "auto",
			fixedBgPos: "auto",
			overflowY: "auto",
			closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
			tClose: "Close (Esc)",
			tLoading: "Loading...",
			autoFocusLast: !0
		}
	}, a.fn.magnificPopup = function(c) {
		A();
		var d = a(this);
		if ("string" == typeof c)
			if ("open" === c) {
				var e, f = u ? d.data("magnificPopup") : d[0].magnificPopup,
					g = parseInt(arguments[1], 10) || 0;
				f.items ? e = f.items[g] : (e = d, f.delegate && (e = e.find(f.delegate)), e = e.eq(g)), b._openClick({
					mfpEl: e
				}, d, f)
			} else b.isOpen && b[c].apply(b, Array.prototype.slice.call(arguments, 1));
		else c = a.extend(!0, {}, c), u ? d.data("magnificPopup", c) : d[0].magnificPopup = c, b.addGroup(d, c);
		return d
	};
	var C, D, E, F = "inline",
		G = function() {
			E && (D.after(E.addClass(C)).detach(), E = null)
		};
	a.magnificPopup.registerModule(F, {
		options: {
			hiddenClass: "hide",
			markup: "",
			tNotFound: "Content not found"
		},
		proto: {
			initInline: function() {
				b.types.push(F), w(h + "." + F, function() {
					G()
				})
			},
			getInline: function(c, d) {
				if (G(), c.src) {
					var e = b.st.inline,
						f = a(c.src);
					if (f.length) {
						var g = f[0].parentNode;
						g && g.tagName && (D || (C = e.hiddenClass, D = x(C), C = "mfp-" + C), E = f.after(D).detach().removeClass(C)), b.updateStatus("ready")
					} else b.updateStatus("error", e.tNotFound), f = a("<div>");
					return c.inlineElement = f, f
				}
				return b.updateStatus("ready"), b._parseMarkup(d, {}, c), d
			}
		}
	});
	var H, I = "ajax",
		J = function() {
			H && a(document.body).removeClass(H)
		},
		K = function() {
			J(), b.req && b.req.abort()
		};
	a.magnificPopup.registerModule(I, {
		options: {
			settings: null,
			cursor: "mfp-ajax-cur",
			tError: '<a href="%url%">The content</a> could not be loaded.'
		},
		proto: {
			initAjax: function() {
				b.types.push(I), H = b.st.ajax.cursor, w(h + "." + I, K), w("BeforeChange." + I, K)
			},
			getAjax: function(c) {
				H && a(document.body).addClass(H), b.updateStatus("loading");
				var d = a.extend({
					url: c.src,
					success: function(d, e, f) {
						var g = {
							data: d,
							xhr: f
						};
						y("ParseAjax", g), b.appendContent(a(g.data), I), c.finished = !0, J(), b._setFocus(), setTimeout(function() {
							b.wrap.addClass(q)
						}, 16), b.updateStatus("ready"), y("AjaxContentAdded")
					},
					error: function() {
						J(), c.finished = c.loadError = !0, b.updateStatus("error", b.st.ajax.tError.replace("%url%", c.src))
					}
				}, b.st.ajax.settings);
				return b.req = a.ajax(d), ""
			}
		}
	});
	var L, M = function(c) {
		if (c.data && void 0 !== c.data.title) return c.data.title;
		var d = b.st.image.titleSrc;
		if (d) {
			if (a.isFunction(d)) return d.call(b, c);
			if (c.el) return c.el.attr(d) || ""
		}
		return ""
	};
	a.magnificPopup.registerModule("image", {
		options: {
			markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
			cursor: "mfp-zoom-out-cur",
			titleSrc: "title",
			verticalFit: !0,
			tError: '<a href="%url%">The image</a> could not be loaded.'
		},
		proto: {
			initImage: function() {
				var c = b.st.image,
					d = ".image";
				b.types.push("image"), w(m + d, function() {
					"image" === b.currItem.type && c.cursor && a(document.body).addClass(c.cursor)
				}), w(h + d, function() {
					c.cursor && a(document.body).removeClass(c.cursor), v.off("resize" + p)
				}), w("Resize" + d, b.resizeImage), b.isLowIE && w("AfterChange", b.resizeImage)
			},
			resizeImage: function() {
				var a = b.currItem;
				if (a && a.img && b.st.image.verticalFit) {
					var c = 0;
					b.isLowIE && (c = parseInt(a.img.css("padding-top"), 10) + parseInt(a.img.css("padding-bottom"), 10)), a.img.css("max-height", b.wH - c)
				}
			},
			_onImageHasSize: function(a) {
				a.img && (a.hasSize = !0, L && clearInterval(L), a.isCheckingImgSize = !1, y("ImageHasSize", a), a.imgHidden && (b.content && b.content.removeClass("mfp-loading"), a.imgHidden = !1))
			},
			findImageSize: function(a) {
				var c = 0,
					d = a.img[0],
					e = function(f) {
						L && clearInterval(L), L = setInterval(function() {
							return d.naturalWidth > 0 ? void b._onImageHasSize(a) : (c > 200 && clearInterval(L), c++, void(3 === c ? e(10) : 40 === c ? e(50) : 100 === c && e(500)))
						}, f)
					};
				e(1)
			},
			getImage: function(c, d) {
				var e = 0,
					f = function() {
						c && (c.img[0].complete ? (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("ready")), c.hasSize = !0, c.loaded = !0, y("ImageLoadComplete")) : (e++, 200 > e ? setTimeout(f, 100) : g()))
					},
					g = function() {
						c && (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("error", h.tError.replace("%url%", c.src))), c.hasSize = !0, c.loaded = !0, c.loadError = !0)
					},
					h = b.st.image,
					i = d.find(".mfp-img");
				if (i.length) {
					var j = document.createElement("img");
					j.className = "mfp-img", c.el && c.el.find("img").length && (j.alt = c.el.find("img").attr("alt")), c.img = a(j).on("load.mfploader", f).on("error.mfploader", g), j.src = c.src, i.is("img") && (c.img = c.img.clone()), j = c.img[0], j.naturalWidth > 0 ? c.hasSize = !0 : j.width || (c.hasSize = !1)
				}
				return b._parseMarkup(d, {
					title: M(c),
					img_replaceWith: c.img
				}, c), b.resizeImage(), c.hasSize ? (L && clearInterval(L), c.loadError ? (d.addClass("mfp-loading"), b.updateStatus("error", h.tError.replace("%url%", c.src))) : (d.removeClass("mfp-loading"), b.updateStatus("ready")), d) : (b.updateStatus("loading"), c.loading = !0, c.hasSize || (c.imgHidden = !0, d.addClass("mfp-loading"), b.findImageSize(c)), d)
			}
		}
	});
	var N, O = function() {
		return void 0 === N && (N = void 0 !== document.createElement("p").style.MozTransform), N
	};
	a.magnificPopup.registerModule("zoom", {
		options: {
			enabled: !1,
			easing: "ease-in-out",
			duration: 300,
			opener: function(a) {
				return a.is("img") ? a : a.find("img")
			}
		},
		proto: {
			initZoom: function() {
				var a, c = b.st.zoom,
					d = ".zoom";
				if (c.enabled && b.supportsTransition) {
					var e, f, g = c.duration,
						j = function(a) {
							var b = a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
								d = "all " + c.duration / 1e3 + "s " + c.easing,
								e = {
									position: "fixed",
									zIndex: 9999,
									left: 0,
									top: 0,
									"-webkit-backface-visibility": "hidden"
								},
								f = "transition";
							return e["-webkit-" + f] = e["-moz-" + f] = e["-o-" + f] = e[f] = d, b.css(e), b
						},
						k = function() {
							b.content.css("visibility", "visible")
						};
					w("BuildControls" + d, function() {
						if (b._allowZoom()) {
							if (clearTimeout(e), b.content.css("visibility", "hidden"), a = b._getItemToZoom(), !a) return void k();
							f = j(a), f.css(b._getOffset()), b.wrap.append(f), e = setTimeout(function() {
								f.css(b._getOffset(!0)), e = setTimeout(function() {
									k(), setTimeout(function() {
										f.remove(), a = f = null, y("ZoomAnimationEnded")
									}, 16)
								}, g)
							}, 16)
						}
					}), w(i + d, function() {
						if (b._allowZoom()) {
							if (clearTimeout(e), b.st.removalDelay = g, !a) {
								if (a = b._getItemToZoom(), !a) return;
								f = j(a)
							}
							f.css(b._getOffset(!0)), b.wrap.append(f), b.content.css("visibility", "hidden"), setTimeout(function() {
								f.css(b._getOffset())
							}, 16)
						}
					}), w(h + d, function() {
						b._allowZoom() && (k(), f && f.remove(), a = null)
					})
				}
			},
			_allowZoom: function() {
				return "image" === b.currItem.type
			},
			_getItemToZoom: function() {
				return b.currItem.hasSize ? b.currItem.img : !1
			},
			_getOffset: function(c) {
				var d;
				d = c ? b.currItem.img : b.st.zoom.opener(b.currItem.el || b.currItem);
				var e = d.offset(),
					f = parseInt(d.css("padding-top"), 10),
					g = parseInt(d.css("padding-bottom"), 10);
				e.top -= a(window).scrollTop() - f;
				var h = {
					width: d.width(),
					height: (u ? d.innerHeight() : d[0].offsetHeight) - g - f
				};
				return O() ? h["-moz-transform"] = h.transform = "translate(" + e.left + "px," + e.top + "px)" : (h.left = e.left, h.top = e.top), h
			}
		}
	});
	var P = "iframe",
		Q = "//about:blank",
		R = function(a) {
			if (b.currTemplate[P]) {
				var c = b.currTemplate[P].find("iframe");
				c.length && (a || (c[0].src = Q), b.isIE8 && c.css("display", a ? "block" : "none"))
			}
		};
	a.magnificPopup.registerModule(P, {
		options: {
			markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
			srcAction: "iframe_src",
			patterns: {
				youtube: {
					index: "youtube.com",
					id: "v=",
					src: "//www.youtube.com/embed/%id%?autoplay=1"
				},
				vimeo: {
					index: "vimeo.com/",
					id: "/",
					src: "//player.vimeo.com/video/%id%?autoplay=1"
				},
				gmaps: {
					index: "//maps.google.",
					src: "%id%&output=embed"
				}
			}
		},
		proto: {
			initIframe: function() {
				b.types.push(P), w("BeforeChange", function(a, b, c) {
					b !== c && (b === P ? R() : c === P && R(!0))
				}), w(h + "." + P, function() {
					R()
				})
			},
			getIframe: function(c, d) {
				var e = c.src,
					f = b.st.iframe;
				a.each(f.patterns, function() {
					return e.indexOf(this.index) > -1 ? (this.id && (e = "string" == typeof this.id ? e.substr(e.lastIndexOf(this.id) + this.id.length, e.length) : this.id.call(this, e)), e = this.src.replace("%id%", e), !1) : void 0
				});
				var g = {};
				return f.srcAction && (g[f.srcAction] = e), b._parseMarkup(d, g, c), b.updateStatus("ready"), d
			}
		}
	});
	var S = function(a) {
			var c = b.items.length;
			return a > c - 1 ? a - c : 0 > a ? c + a : a
		},
		T = function(a, b, c) {
			return a.replace(/%curr%/gi, b + 1).replace(/%total%/gi, c)
		};
	a.magnificPopup.registerModule("gallery", {
		options: {
			enabled: !1,
			arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
			preload: [0, 2],
			navigateByImgClick: !0,
			arrows: !0,
			tPrev: "Previous (Left arrow key)",
			tNext: "Next (Right arrow key)",
			tCounter: "%curr% of %total%"
		},
		proto: {
			initGallery: function() {
				var c = b.st.gallery,
					e = ".mfp-gallery";
				return b.direction = !0, c && c.enabled ? (f += " mfp-gallery", w(m + e, function() {
					c.navigateByImgClick && b.wrap.on("click" + e, ".mfp-img", function() {
						return b.items.length > 1 ? (b.next(), !1) : void 0
					}), d.on("keydown" + e, function(a) {
						37 === a.keyCode ? b.prev() : 39 === a.keyCode && b.next()
					})
				}), w("UpdateStatus" + e, function(a, c) {
					c.text && (c.text = T(c.text, b.currItem.index, b.items.length))
				}), w(l + e, function(a, d, e, f) {
					var g = b.items.length;
					e.counter = g > 1 ? T(c.tCounter, f.index, g) : ""
				}), w("BuildControls" + e, function() {
					if (b.items.length > 1 && c.arrows && !b.arrowLeft) {
						var d = c.arrowMarkup,
							e = b.arrowLeft = a(d.replace(/%title%/gi, c.tPrev).replace(/%dir%/gi, "left")).addClass(s),
							f = b.arrowRight = a(d.replace(/%title%/gi, c.tNext).replace(/%dir%/gi, "right")).addClass(s);
						e.click(function() {
							b.prev()
						}), f.click(function() {
							b.next()
						}), b.container.append(e.add(f))
					}
				}), w(n + e, function() {
					b._preloadTimeout && clearTimeout(b._preloadTimeout), b._preloadTimeout = setTimeout(function() {
						b.preloadNearbyImages(), b._preloadTimeout = null
					}, 16)
				}), void w(h + e, function() {
					d.off(e), b.wrap.off("click" + e), b.arrowRight = b.arrowLeft = null
				})) : !1
			},
			next: function() {
				b.direction = !0, b.index = S(b.index + 1), b.updateItemHTML()
			},
			prev: function() {
				b.direction = !1, b.index = S(b.index - 1), b.updateItemHTML()
			},
			goTo: function(a) {
				b.direction = a >= b.index, b.index = a, b.updateItemHTML()
			},
			preloadNearbyImages: function() {
				var a, c = b.st.gallery.preload,
					d = Math.min(c[0], b.items.length),
					e = Math.min(c[1], b.items.length);
				for (a = 1; a <= (b.direction ? e : d); a++) b._preloadItem(b.index + a);
				for (a = 1; a <= (b.direction ? d : e); a++) b._preloadItem(b.index - a)
			},
			_preloadItem: function(c) {
				if (c = S(c), !b.items[c].preloaded) {
					var d = b.items[c];
					d.parsed || (d = b.parseEl(c)), y("LazyLoad", d), "image" === d.type && (d.img = a('<img class="mfp-img" />').on("load.mfploader", function() {
						d.hasSize = !0
					}).on("error.mfploader", function() {
						d.hasSize = !0, d.loadError = !0, y("LazyLoadError", d)
					}).attr("src", d.src)), d.preloaded = !0
				}
			}
		}
	});
	var U = "retina";
	a.magnificPopup.registerModule(U, {
		options: {
			replaceSrc: function(a) {
				return a.src.replace(/\.\w+$/, function(a) {
					return "@2x" + a
				})
			},
			ratio: 1
		},
		proto: {
			initRetina: function() {
				if (window.devicePixelRatio > 1) {
					var a = b.st.retina,
						c = a.ratio;
					c = isNaN(c) ? c() : c, c > 1 && (w("ImageHasSize." + U, function(a, b) {
						b.img.css({
							"max-width": b.img[0].naturalWidth / c,
							width: "100%"
						})
					}), w("ElementParse." + U, function(b, d) {
						d.src = a.replaceSrc(d, c)
					}))
				}
			}
		}
	}), A()
});
/*!
 *  GMAP3 Plugin for jQuery
 *  Version   : 6.1.0
 *  Date      : 2016-01-01
 *  Author    : DEMONTE Jean-Baptiste
 *  Contact   : jbdemonte@gmail.com
 *  Web site  : http://gmap3.net
 *  Licence   : GPL v3 : http://www.gnu.org/licenses/gpl.html
 *  
 *  Copyright (c) 2010-2014 Jean-Baptiste DEMONTE
 *  All rights reserved.
 */
! function(t, n) {
	function e(t) {
		return "object" == typeof t
	}

	function o(t) {
		return "string" == typeof t
	}

	function i(t) {
		return "number" == typeof t
	}

	function a(t) {
		return t === n
	}

	function r() {
		q = google.maps, A || (A = {
			verbose: !1,
			queryLimit: {
				attempt: 5,
				delay: 250,
				random: 250
			},
			classes: function() {
				var n = {};
				return t.each("Map Marker InfoWindow Circle Rectangle OverlayView StreetViewPanorama KmlLayer TrafficLayer TransitLayer BicyclingLayer GroundOverlay StyledMapType ImageMapType".split(" "), function(t, e) {
					n[e] = q[e]
				}), n
			}(),
			map: {
				mapTypeId: q.MapTypeId.ROADMAP,
				center: [46.578498, 2.457275],
				zoom: 2
			},
			overlay: {
				pane: "floatPane",
				content: "",
				offset: {
					x: 0,
					y: 0
				}
			},
			geoloc: {
				getCurrentPosition: {
					maximumAge: 6e4,
					timeout: 5e3
				}
			}
		})
	}

	function s(t, n) {
		return a(t) ? "gmap3_" + (n ? Z + 1 : ++Z) : t
	}

	function u(t) {
		var n, e = q.version.split(".");
		for (t = t.split("."), n = 0; n < e.length; n++) e[n] = parseInt(e[n], 10);
		for (n = 0; n < t.length; n++) {
			if (t[n] = parseInt(t[n], 10), !e.hasOwnProperty(n)) return !1;
			if (e[n] < t[n]) return !1
		}
		return !0
	}

	function l(n, e, o, i, a) {
		function r(e, i) {
			e && t.each(e, function(t, e) {
				var r = n,
					s = e;
				R(e) && (r = e[0], s = e[1]), i(o, t, function(t) {
					s.apply(r, [a || o, t, u])
				})
			})
		}
		var s = e.td || {},
			u = {
				id: i,
				data: s.data,
				tag: s.tag
			};
		r(s.events, q.event.addListener), r(s.onces, q.event.addListenerOnce)
	}

	function d(t) {
		var n, e = [];
		for (n in t) t.hasOwnProperty(n) && e.push(n);
		return e
	}

	function c(t, n) {
		var e, o = arguments;
		for (e = 2; e < o.length; e++)
			if (n in o[e] && o[e].hasOwnProperty(n)) return void(t[n] = o[e][n])
	}

	function p(n, e) {
		var o, i, a = ["data", "tag", "id", "events", "onces"],
			r = {};
		if (n.td)
			for (o in n.td) n.td.hasOwnProperty(o) && "options" !== o && "values" !== o && (r[o] = n.td[o]);
		for (i = 0; i < a.length; i++) c(r, a[i], e, n.td);
		return r.options = t.extend({}, n.opts || {}, e.options || {}), r
	}

	function f() {
		if (A.verbose) {
			var t, n = [];
			if (window.console && z(console.error)) {
				for (t = 0; t < arguments.length; t++) n.push(arguments[t]);
				console.error.apply(console, n)
			} else {
				for (n = "", t = 0; t < arguments.length; t++) n += arguments[t].toString() + " ";
				alert(n)
			}
		}
	}

	function g(t) {
		return (i(t) || o(t)) && "" !== t && !isNaN(t)
	}

	function h(t) {
		var n, o = [];
		if (!a(t))
			if (e(t))
				if (i(t.length)) o = t;
				else
					for (n in t) o.push(t[n]);
		else o.push(t);
		return o
	}

	function v(n) {
		return n ? z(n) ? n : (n = h(n), function(o) {
			var i;
			if (a(o)) return !1;
			if (e(o)) {
				for (i = 0; i < o.length; i++)
					if (t.inArray(o[i], n) >= 0) return !0;
				return !1
			}
			return t.inArray(o, n) >= 0
		}) : void 0
	}

	function m(t, n, e) {
		var i = n ? t : null;
		return !t || o(t) ? i : t.latLng ? m(t.latLng) : t instanceof q.LatLng ? t : g(t.lat) ? new q.LatLng(t.lat, t.lng) : !e && R(t) && g(t[0]) && g(t[1]) ? new q.LatLng(t[0], t[1]) : i
	}

	function y(t) {
		var n, e;
		return !t || t instanceof q.LatLngBounds ? t || null : (R(t) ? 2 === t.length ? (n = m(t[0]), e = m(t[1])) : 4 === t.length && (n = m([t[0], t[1]]), e = m([t[2], t[3]])) : "ne" in t && "sw" in t ? (n = m(t.ne), e = m(t.sw)) : "n" in t && "e" in t && "s" in t && "w" in t && (n = m([t.n, t.e]), e = m([t.s, t.w])), n && e ? new q.LatLngBounds(e, n) : null)
	}

	function w(t, n, e, i, a) {
		var r = e ? m(i.td, !1, !0) : !1,
			s = r ? {
				latLng: r
			} : i.td.address ? o(i.td.address) ? {
				address: i.td.address
			} : i.td.address : !1,
			u = s ? G.get(s) : !1,
			l = this;
		s ? (a = a || 0, u ? (i.latLng = u.results[0].geometry.location, i.results = u.results, i.status = u.status, n.apply(t, [i])) : (s.location && (s.location = m(s.location)), s.bounds && (s.bounds = y(s.bounds)), M().geocode(s, function(o, r) {
			r === q.GeocoderStatus.OK ? (G.store(s, {
				results: o,
				status: r
			}), i.latLng = o[0].geometry.location, i.results = o, i.status = r, n.apply(t, [i])) : r === q.GeocoderStatus.OVER_QUERY_LIMIT && a < A.queryLimit.attempt ? setTimeout(function() {
				w.apply(l, [t, n, e, i, a + 1])
			}, A.queryLimit.delay + Math.floor(Math.random() * A.queryLimit.random)) : (f("geocode failed", r, s), i.latLng = i.results = !1, i.status = r, n.apply(t, [i]))
		}))) : (i.latLng = m(i.td, !1, !0), n.apply(t, [i]))
	}

	function L(n, e, o, i) {
		function a() {
			do s++; while (s < n.length && !("address" in n[s]));
			return s >= n.length ? void o.apply(e, [i]) : void w(r, function(e) {
				delete e.td, t.extend(n[s], e), a.apply(r, [])
			}, !0, {
				td: n[s]
			})
		}
		var r = this,
			s = -1;
		a()
	}

	function b(t, n, e) {
		var o = !1;
		navigator && navigator.geolocation ? navigator.geolocation.getCurrentPosition(function(i) {
			o || (o = !0, e.latLng = new q.LatLng(i.coords.latitude, i.coords.longitude), n.apply(t, [e]))
		}, function() {
			o || (o = !0, e.latLng = !1, n.apply(t, [e]))
		}, e.opts.getCurrentPosition) : (e.latLng = !1, n.apply(t, [e]))
	}

	function x(t) {
		var n, o = !1;
		if (e(t) && t.hasOwnProperty("get")) {
			for (n in t)
				if ("get" !== n) return !1;
			o = !t.get.hasOwnProperty("callback")
		}
		return o
	}

	function M() {
		return V.geocoder || (V.geocoder = new q.Geocoder), V.geocoder
	}

	function I() {
		var t = [];
		this.get = function(n) {
			if (t.length) {
				var o, i, a, r, s, u = d(n);
				for (o = 0; o < t.length; o++) {
					for (r = t[o], s = u.length === r.keys.length, i = 0; i < u.length && s; i++) a = u[i], s = a in r.request, s && (s = e(n[a]) && "equals" in n[a] && z(n[a]) ? n[a].equals(r.request[a]) : n[a] === r.request[a]);
					if (s) return r.results
				}
			}
		}, this.store = function(n, e) {
			t.push({
				request: n,
				keys: d(n),
				results: e
			})
		}
	}

	function P() {
		var t = [],
			n = this;
		n.empty = function() {
			return !t.length
		}, n.add = function(n) {
			t.push(n)
		}, n.get = function() {
			return t.length ? t[0] : !1
		}, n.ack = function() {
			t.shift()
		}
	}

	function B() {
		function n(t) {
			return {
				id: t.id,
				name: t.name,
				object: t.obj,
				tag: t.tag,
				data: t.data
			}
		}

		function e(t) {
			z(t.setMap) && t.setMap(null), z(t.remove) && t.remove(), z(t.free) && t.free(), t = null
		}
		var o = {},
			i = {},
			r = this;
		r.add = function(t, n, e, a) {
			var u = t.td || {},
				l = s(u.id);
			return o[n] || (o[n] = []), l in i && r.clearById(l), i[l] = {
				obj: e,
				sub: a,
				name: n,
				id: l,
				tag: u.tag,
				data: u.data
			}, o[n].push(l), l
		}, r.getById = function(t, e, o) {
			var a = !1;
			return t in i && (a = e ? i[t].sub : o ? n(i[t]) : i[t].obj), a
		}, r.get = function(t, e, a, r) {
			var s, u, l = v(a);
			if (!o[t] || !o[t].length) return null;
			for (s = o[t].length; s;)
				if (s--, u = o[t][e ? s : o[t].length - s - 1], u && i[u]) {
					if (l && !l(i[u].tag)) continue;
					return r ? n(i[u]) : i[u].obj
				}
			return null
		}, r.all = function(t, e, r) {
			var s = [],
				u = v(e),
				l = function(t) {
					var e, a;
					for (e = 0; e < o[t].length; e++)
						if (a = o[t][e], a && i[a]) {
							if (u && !u(i[a].tag)) continue;
							s.push(r ? n(i[a]) : i[a].obj)
						}
				};
			if (t in o) l(t);
			else if (a(t))
				for (t in o) l(t);
			return s
		}, r.rm = function(t, n, e) {
			var a, s;
			if (!o[t]) return !1;
			if (n)
				if (e)
					for (a = o[t].length - 1; a >= 0 && (s = o[t][a], !n(i[s].tag)); a--);
				else
					for (a = 0; a < o[t].length && (s = o[t][a], !n(i[s].tag)); a++);
			else a = e ? o[t].length - 1 : 0;
			return a in o[t] ? r.clearById(o[t][a], a) : !1
		}, r.clearById = function(t, n) {
			if (t in i) {
				var r, s = i[t].name;
				for (r = 0; a(n) && r < o[s].length; r++) t === o[s][r] && (n = r);
				return e(i[t].obj), i[t].sub && e(i[t].sub), delete i[t], o[s].splice(n, 1), !0
			}
			return !1
		}, r.objGetById = function(t) {
			var n, e;
			if (o.clusterer)
				for (e in o.clusterer)
					if ((n = i[o.clusterer[e]].obj.getById(t)) !== !1) return n;
			return !1
		}, r.objClearById = function(t) {
			var n;
			if (o.clusterer)
				for (n in o.clusterer)
					if (i[o.clusterer[n]].obj.clearById(t)) return !0;
			return null
		}, r.clear = function(t, n, e, i) {
			var a, s, u, l = v(i);
			if (t && t.length) t = h(t);
			else {
				t = [];
				for (a in o) t.push(a)
			}
			for (s = 0; s < t.length; s++)
				if (u = t[s], n) r.rm(u, l, !0);
				else if (e) r.rm(u, l, !1);
			else
				for (; r.rm(u, l, !1););
		}, r.objClear = function(n, e, a, r) {
			var s;
			if (o.clusterer && (t.inArray("marker", n) >= 0 || !n.length))
				for (s in o.clusterer) i[o.clusterer[s]].obj.clear(e, a, r)
		}
	}

	function k(n, e, i) {
		function a(t) {
			var n = {};
			return n[t] = {}, n
		}

		function r() {
			var t;
			for (t in i)
				if (i.hasOwnProperty(t) && !u.hasOwnProperty(t)) return t
		}
		var s, u = {},
			l = this,
			d = {
				latLng: {
					map: !1,
					marker: !1,
					infowindow: !1,
					circle: !1,
					overlay: !1,
					getlatlng: !1,
					getmaxzoom: !1,
					getelevation: !1,
					streetviewpanorama: !1,
					getaddress: !0
				},
				geoloc: {
					getgeoloc: !0
				}
			};
		o(i) && (i = a(i)), l.run = function() {
			for (var o, a; o = r();) {
				if (z(n[o])) return s = o, a = t.extend(!0, {}, A[o] || {}, i[o].options || {}), void(o in d.latLng ? i[o].values ? L(i[o].values, n, n[o], {
					td: i[o],
					opts: a,
					session: u
				}) : w(n, n[o], d.latLng[o], {
					td: i[o],
					opts: a,
					session: u
				}) : o in d.geoloc ? b(n, n[o], {
					td: i[o],
					opts: a,
					session: u
				}) : n[o].apply(n, [{
					td: i[o],
					opts: a,
					session: u
				}]));
				u[o] = null
			}
			e.apply(n, [i, u])
		}, l.ack = function(t) {
			u[s] = t, l.run.apply(l, [])
		}
	}

	function j() {
		return V.ds || (V.ds = new q.DirectionsService), V.ds
	}

	function O() {
		return V.dms || (V.dms = new q.DistanceMatrixService), V.dms
	}

	function C() {
		return V.mzs || (V.mzs = new q.MaxZoomService), V.mzs
	}

	function T() {
		return V.es || (V.es = new q.ElevationService), V.es
	}

	function E(t, n) {
		function e() {
			var t = this;
			return t.onAdd = function() {}, t.onRemove = function() {}, t.draw = function() {}, A.classes.OverlayView.apply(t, [])
		}
		e.prototype = A.classes.OverlayView.prototype;
		var o = new e;
		return o.setMap(t), o
	}

	function S(n, o, i) {
		function a(t) {
			S[t] || (delete _[t].options.map, S[t] = new A.classes.Marker(_[t].options), l(n, {
				td: _[t]
			}, S[t], _[t].id))
		}

		function r() {
			return (y = U.getProjection()) ? (P = !0, j.push(q.event.addListener(o, "zoom_changed", f)), j.push(q.event.addListener(o, "bounds_changed", f)), void h()) : void setTimeout(function() {
				r.apply(k, [])
			}, 25)
		}

		function u(t) {
			e(O[t]) ? (z(O[t].obj.setMap) && O[t].obj.setMap(null), z(O[t].obj.remove) && O[t].obj.remove(), z(O[t].shadow.remove) && O[t].obj.remove(), z(O[t].shadow.setMap) && O[t].shadow.setMap(null), delete O[t].obj, delete O[t].shadow) : S[t] && S[t].setMap(null), delete O[t]
		}

		function d() {
			var t, n, e, o, i, a, r, s, u = Math.cos,
				l = Math.sin,
				d = arguments;
			return d[0] instanceof q.LatLng ? (t = d[0].lat(), e = d[0].lng(), d[1] instanceof q.LatLng ? (n = d[1].lat(), o = d[1].lng()) : (n = d[1], o = d[2])) : (t = d[0], e = d[1], d[2] instanceof q.LatLng ? (n = d[2].lat(), o = d[2].lng()) : (n = d[2], o = d[3])), i = Math.PI * t / 180, a = Math.PI * e / 180, r = Math.PI * n / 180, s = Math.PI * o / 180, 6371e3 * Math.acos(Math.min(u(i) * u(r) * u(a) * u(s) + u(i) * l(a) * u(r) * l(s) + l(i) * l(r), 1))
		}

		function c() {
			var t = d(o.getCenter(), o.getBounds().getNorthEast()),
				n = new q.Circle({
					center: o.getCenter(),
					radius: 1.25 * t
				});
			return n.getBounds()
		}

		function p() {
			var t, n = {};
			for (t in O) n[t] = !0;
			return n
		}

		function f() {
			clearTimeout(m), m = setTimeout(h, 25)
		}

		function g(t) {
			var n = y.fromLatLngToDivPixel(t),
				e = y.fromDivPixelToLatLng(new q.Point(n.x + i.radius, n.y - i.radius)),
				o = y.fromDivPixelToLatLng(new q.Point(n.x - i.radius, n.y + i.radius));
			return new q.LatLngBounds(o, e)
		}

		function h() {
			if (!x && !I && P) {
				var n, e, a, r, s, l, d, f, h, v, m, y = !1,
					b = [],
					k = {},
					j = o.getZoom(),
					C = "maxZoom" in i && j > i.maxZoom,
					T = p();
				for (M = !1, j > 3 && (s = c(), y = s.getSouthWest().lng() < s.getNorthEast().lng()), n = 0; n < _.length; n++) !_[n] || y && !s.contains(_[n].options.position) || w && !w(D[n]) || b.push(n);
				for (;;) {
					for (n = 0; k[n] && n < b.length;) n++;
					if (n === b.length) break;
					if (r = [], B && !C) {
						m = 10;
						do
							for (f = r, r = [], m--, d = f.length ? s.getCenter() : _[b[n]].options.position, s = g(d), e = n; e < b.length; e++) k[e] || s.contains(_[b[e]].options.position) && r.push(e); while (f.length < r.length && r.length > 1 && m)
					} else
						for (e = n; e < b.length; e++)
							if (!k[e]) {
								r.push(e);
								break
							} for (l = {
							indexes: [],
							ref: []
						}, h = v = 0, a = 0; a < r.length; a++) k[r[a]] = !0, l.indexes.push(b[r[a]]), l.ref.push(b[r[a]]), h += _[b[r[a]]].options.position.lat(), v += _[b[r[a]]].options.position.lng();
					h /= r.length, v /= r.length, l.latLng = new q.LatLng(h, v), l.ref = l.ref.join("-"), l.ref in T ? delete T[l.ref] : (1 === r.length && (O[l.ref] = !0), L(l))
				}
				t.each(T, function(t) {
					u(t)
				}), I = !1
			}
		}
		var m, y, w, L, b, x = !1,
			M = !1,
			I = !1,
			P = !1,
			B = !0,
			k = this,
			j = [],
			O = {},
			C = {},
			T = {},
			S = [],
			_ = [],
			D = [],
			U = E(o, i.radius);
		r(), k.getById = function(t) {
			return t in C ? (a(C[t]), S[C[t]]) : !1
		}, k.rm = function(t) {
			var n = C[t];
			S[n] && S[n].setMap(null), delete S[n], S[n] = !1, delete _[n], _[n] = !1, delete D[n], D[n] = !1, delete C[t], delete T[n], M = !0
		}, k.clearById = function(t) {
			return t in C ? (k.rm(t), !0) : void 0
		}, k.clear = function(t, n, e) {
			var o, i, a, r, s, u = [],
				l = v(e);
			for (t ? (o = _.length - 1, i = -1, a = -1) : (o = 0, i = _.length, a = 1), r = o; r !== i && (!_[r] || l && !l(_[r].tag) || (u.push(T[r]), !n && !t)); r += a);
			for (s = 0; s < u.length; s++) k.rm(u[s])
		}, k.add = function(t, n) {
			t.id = s(t.id), k.clearById(t.id), C[t.id] = S.length, T[S.length] = t.id, S.push(null), _.push(t), D.push(n), M = !0
		}, k.addMarker = function(t, e) {
			e = e || {}, e.id = s(e.id), k.clearById(e.id), e.options || (e.options = {}), e.options.position = t.getPosition(), l(n, {
				td: e
			}, t, e.id), C[e.id] = S.length, T[S.length] = e.id, S.push(t), _.push(e), D.push(e.data || {}), M = !0
		}, k.td = function(t) {
			return _[t]
		}, k.value = function(t) {
			return D[t]
		}, k.marker = function(t) {
			return t in S ? (a(t), S[t]) : !1
		}, k.markerIsSet = function(t) {
			return Boolean(S[t])
		}, k.setMarker = function(t, n) {
			S[t] = n
		}, k.store = function(t, n, e) {
			O[t.ref] = {
				obj: n,
				shadow: e
			}
		}, k.free = function() {
			var n;
			for (n = 0; n < j.length; n++) q.event.removeListener(j[n]);
			j = [], t.each(O, function(t) {
				u(t)
			}), O = {}, t.each(_, function(t) {
				_[t] = null
			}), _ = [], t.each(S, function(t) {
				S[t] && (S[t].setMap(null), delete S[t])
			}), S = [], t.each(D, function(t) {
				delete D[t]
			}), D = [], C = {}, T = {}
		}, k.filter = function(t) {
			w = t, h()
		}, k.enable = function(t) {
			B !== t && (B = t, h())
		}, k.display = function(t) {
			L = t
		}, k.error = function(t) {
			b = t
		}, k.beginUpdate = function() {
			x = !0
		}, k.endUpdate = function() {
			x = !1, M && h()
		}, k.autofit = function(t) {
			var n;
			for (n = 0; n < _.length; n++) _[n] && t.extend(_[n].options.position)
		}
	}

	function _(t, n) {
		var e = this;
		e.id = function() {
			return t
		}, e.filter = function(t) {
			n.filter(t)
		}, e.enable = function() {
			n.enable(!0)
		}, e.disable = function() {
			n.enable(!1)
		}, e.add = function(t, e, o) {
			o || n.beginUpdate(), n.addMarker(t, e), o || n.endUpdate()
		}, e.getById = function(t) {
			return n.getById(t)
		}, e.clearById = function(t, e) {
			var o;
			return e || n.beginUpdate(), o = n.clearById(t), e || n.endUpdate(), o
		}, e.clear = function(t, e, o, i) {
			i || n.beginUpdate(), n.clear(t, e, o), i || n.endUpdate()
		}
	}

	function D(n, e, o, i) {
		var a = this,
			r = [];
		A.classes.OverlayView.call(a), a.setMap(n), a.onAdd = function() {
			var n = a.getPanes();
			e.pane in n && t(n[e.pane]).append(i), t.each("dblclick click mouseover mousemove mouseout mouseup mousedown".split(" "), function(n, e) {
				r.push(q.event.addDomListener(i[0], e, function(n) {
					t.Event(n).stopPropagation(), q.event.trigger(a, e, [n]), a.draw()
				}))
			}), r.push(q.event.addDomListener(i[0], "contextmenu", function(n) {
				t.Event(n).stopPropagation(), q.event.trigger(a, "rightclick", [n]), a.draw()
			}))
		}, a.getPosition = function() {
			return o
		}, a.setPosition = function(t) {
			o = t, a.draw()
		}, a.draw = function() {
			var t = a.getProjection().fromLatLngToDivPixel(o);
			i.css("left", t.x + e.offset.x + "px").css("top", t.y + e.offset.y + "px")
		}, a.onRemove = function() {
			var t;
			for (t = 0; t < r.length; t++) q.event.removeListener(r[t]);
			i.remove()
		}, a.hide = function() {
			i.hide()
		}, a.show = function() {
			i.show()
		}, a.toggle = function() {
			i && (i.is(":visible") ? a.show() : a.hide())
		}, a.toggleDOM = function() {
			a.setMap(a.getMap() ? null : n)
		}, a.getDOMElement = function() {
			return i[0]
		}
	}

	function U(i) {
		function r() {
			!b && (b = M.get()) && b.run()
		}

		function d() {
			b = null, M.ack(), r.call(x)
		}

		function c(t) {
			var n, e = t.td.callback;
			e && (n = Array.prototype.slice.call(arguments, 1), z(e) ? e.apply(i, n) : R(e) && z(e[1]) && e[1].apply(e[0], n))
		}

		function g(t, n, e) {
			e && l(i, t, n, e), c(t, n), b.ack(n)
		}

		function v(n, e) {
			e = e || {};
			var o = e.td && e.td.options ? e.td.options : 0;
			E ? o && (o.center && (o.center = m(o.center)), E.setOptions(o)) : (o = e.opts || t.extend(!0, {}, A.map, o || {}), o.center = n || m(o.center), E = new A.classes.Map(i.get(0), o))
		}

		function w(e) {
			var o, a, r = new S(i, E, e),
				s = {},
				u = {},
				d = [],
				c = /^[0-9]+$/;
			for (a in e) c.test(a) ? (d.push(1 * a), u[a] = e[a], u[a].width = u[a].width || 0, u[a].height = u[a].height || 0) : s[a] = e[a];
			return d.sort(function(t, n) {
				return t > n
			}), o = s.calculator ? function(n) {
				var e = [];
				return t.each(n, function(t, n) {
					e.push(r.value(n))
				}), s.calculator.apply(i, [e])
			} : function(t) {
				return t.length
			}, r.error(function() {
				f.apply(x, arguments)
			}), r.display(function(a) {
				var c, p, f, g, h, v, y = o(a.indexes);
				if (e.force || y > 1)
					for (c = 0; c < d.length; c++) d[c] <= y && (p = u[d[c]]);
				p ? (h = p.offset || [-p.width / 2, -p.height / 2], f = t.extend({}, s), f.options = t.extend({
					pane: "overlayLayer",
					content: p.content ? p.content.replace("CLUSTER_COUNT", y) : "",
					offset: {
						x: ("x" in h ? h.x : h[0]) || 0,
						y: ("y" in h ? h.y : h[1]) || 0
					}
				}, s.options || {}), g = x.overlay({
					td: f,
					opts: f.options,
					latLng: m(a)
				}, !0), f.options.pane = "floatShadow", f.options.content = t(document.createElement("div")).width(p.width + "px").height(p.height + "px").css({
					cursor: "pointer"
				}), v = x.overlay({
					td: f,
					opts: f.options,
					latLng: m(a)
				}, !0), s.data = {
					latLng: m(a),
					markers: []
				}, t.each(a.indexes, function(t, n) {
					s.data.markers.push(r.value(n)), r.markerIsSet(n) && r.marker(n).setMap(null)
				}), l(i, {
					td: s
				}, v, n, {
					main: g,
					shadow: v
				}), r.store(a, g, v)) : t.each(a.indexes, function(t, n) {
					r.marker(n).setMap(E)
				})
			}), r
		}

		function L(n, e, o) {
			var a = [],
				r = "values" in n.td;
			return r || (n.td.values = [{
				options: n.opts
			}]), n.td.values.length ? (v(), t.each(n.td.values, function(t, r) {
				var s, u, d, c, f = p(n, r);
				if (f.options[o])
					if (f.options[o][0][0] && R(f.options[o][0][0]))
						for (u = 0; u < f.options[o].length; u++)
							for (d = 0; d < f.options[o][u].length; d++) f.options[o][u][d] = m(f.options[o][u][d]);
					else
						for (u = 0; u < f.options[o].length; u++) f.options[o][u] = m(f.options[o][u]);
				f.options.map = E, c = new q[e](f.options), a.push(c), s = I.add({
					td: f
				}, e.toLowerCase(), c), l(i, {
					td: f
				}, c, s)
			}), void g(n, r ? a : a[0])) : void g(n, !1)
		}
		var b, x = this,
			M = new P,
			I = new B,
			E = null;
		x._plan = function(t) {
			var n;
			for (n = 0; n < t.length; n++) M.add(new k(x, d, t[n]));
			r()
		}, x.map = function(t) {
			v(t.latLng, t), l(i, t, E), g(t, E)
		}, x.destroy = function(t) {
			I.clear(), i.empty(), E && (E = null), g(t, !0)
		}, x.overlay = function(n, e) {
			var o = [],
				a = "values" in n.td;
			return a || (n.td.values = [{
				latLng: n.latLng,
				options: n.opts
			}]), n.td.values.length ? (D.__initialised || (D.prototype = new A.classes.OverlayView, D.__initialised = !0), t.each(n.td.values, function(a, r) {
				var s, u, d = p(n, r),
					c = t(document.createElement("div")).css({
						border: "none",
						borderWidth: 0,
						position: "absolute"
					});
				c.append(d.options.content), u = new D(E, d.options, m(d) || m(r), c), o.push(u), c = null, e || (s = I.add(n, "overlay", u), l(i, {
					td: d
				}, u, s))
			}), e ? o[0] : void g(n, a ? o : o[0])) : void g(n, !1)
		}, x.marker = function(n) {
			var e, o, a, r = "values" in n.td,
				u = !E;
			return r || (n.opts.position = n.latLng || m(n.opts.position), n.td.values = [{
				options: n.opts
			}]), n.td.values.length ? (u && v(), n.td.cluster && !E.getBounds() ? void q.event.addListenerOnce(E, "bounds_changed", function() {
				x.marker.apply(x, [n])
			}) : void(n.td.cluster ? (n.td.cluster instanceof _ ? (o = n.td.cluster, a = I.getById(o.id(), !0)) : (a = w(n.td.cluster), o = new _(s(n.td.id, !0), a), I.add(n, "clusterer", o, a)), a.beginUpdate(), t.each(n.td.values, function(t, e) {
				var o = p(n, e);
				o.options.position = m(o.options.position ? o.options.position : e), o.options.position && (o.options.map = E, u && (E.setCenter(o.options.position), u = !1), a.add(o, e))
			}), a.endUpdate(), g(n, o)) : (e = [], t.each(n.td.values, function(t, o) {
				var a, r, s = p(n, o);
				s.options.position = m(s.options.position ? s.options.position : o), s.options.position && (s.options.map = E, u && (E.setCenter(s.options.position), u = !1), r = new A.classes.Marker(s.options), e.push(r), a = I.add({
					td: s
				}, "marker", r), l(i, {
					td: s
				}, r, a))
			}), g(n, r ? e : e[0])))) : void g(n, !1)
		}, x.getroute = function(t) {
			t.opts.origin = m(t.opts.origin, !0), t.opts.destination = m(t.opts.destination, !0), j().route(t.opts, function(n, e) {
				c(t, e === q.DirectionsStatus.OK ? n : !1, e), b.ack()
			})
		}, x.getdistance = function(t) {
			var n;
			for (t.opts.origins = h(t.opts.origins), n = 0; n < t.opts.origins.length; n++) t.opts.origins[n] = m(t.opts.origins[n], !0);
			for (t.opts.destinations = h(t.opts.destinations), n = 0; n < t.opts.destinations.length; n++) t.opts.destinations[n] = m(t.opts.destinations[n], !0);
			O().getDistanceMatrix(t.opts, function(n, e) {
				c(t, e === q.DistanceMatrixStatus.OK ? n : !1, e), b.ack()
			})
		}, x.infowindow = function(e) {
			var o = [],
				r = "values" in e.td;
			r || (e.latLng && (e.opts.position = e.latLng), e.td.values = [{
				options: e.opts
			}]), t.each(e.td.values, function(t, s) {
				var u, d, c = p(e, s);
				c.options.position = m(c.options.position ? c.options.position : s.latLng), E || v(c.options.position), d = new A.classes.InfoWindow(c.options), d && (a(c.open) || c.open) && (r ? d.open(E, c.anchor || n) : d.open(E, c.anchor || (e.latLng ? n : e.session.marker ? e.session.marker : n))), o.push(d), u = I.add({
					td: c
				}, "infowindow", d), l(i, {
					td: c
				}, d, u)
			}), g(e, r ? o : o[0])
		}, x.circle = function(n) {
			var e = [],
				o = "values" in n.td;
			return o || (n.opts.center = n.latLng || m(n.opts.center), n.td.values = [{
				options: n.opts
			}]), n.td.values.length ? (t.each(n.td.values, function(t, o) {
				var a, r, s = p(n, o);
				s.options.center = m(s.options.center ? s.options.center : o), E || v(s.options.center), s.options.map = E, r = new A.classes.Circle(s.options), e.push(r), a = I.add({
					td: s
				}, "circle", r), l(i, {
					td: s
				}, r, a)
			}), void g(n, o ? e : e[0])) : void g(n, !1)
		}, x.getaddress = function(t) {
			c(t, t.results, t.status), b.ack()
		}, x.getlatlng = function(t) {
			c(t, t.results, t.status), b.ack()
		}, x.getmaxzoom = function(t) {
			C().getMaxZoomAtLatLng(t.latLng, function(n) {
				c(t, n.status === q.MaxZoomStatus.OK ? n.zoom : !1, status), b.ack()
			})
		}, x.getelevation = function(t) {
			var n, e = [],
				o = function(n, e) {
					c(t, e === q.ElevationStatus.OK ? n : !1, e), b.ack()
				};
			if (t.latLng) e.push(t.latLng);
			else
				for (e = h(t.td.locations || []), n = 0; n < e.length; n++) e[n] = m(e[n]);
			if (e.length) T().getElevationForLocations({
				locations: e
			}, o);
			else {
				if (t.td.path && t.td.path.length)
					for (n = 0; n < t.td.path.length; n++) e.push(m(t.td.path[n]));
				e.length ? T().getElevationAlongPath({
					path: e,
					samples: t.td.samples
				}, o) : b.ack()
			}
		}, x.defaults = function(n) {
			t.each(n.td, function(n, o) {
				e(A[n]) ? A[n] = t.extend({}, A[n], o) : A[n] = o
			}), b.ack(!0)
		}, x.rectangle = function(n) {
			var e = [],
				o = "values" in n.td;
			return o || (n.td.values = [{
				options: n.opts
			}]), n.td.values.length ? (t.each(n.td.values, function(t, o) {
				var a, r, s = p(n, o);
				s.options.bounds = y(s.options.bounds ? s.options.bounds : o), E || v(s.options.bounds.getCenter()), s.options.map = E, r = new A.classes.Rectangle(s.options), e.push(r), a = I.add({
					td: s
				}, "rectangle", r), l(i, {
					td: s
				}, r, a)
			}), void g(n, o ? e : e[0])) : void g(n, !1)
		}, x.polyline = function(t) {
			L(t, "Polyline", "path")
		}, x.polygon = function(t) {
			L(t, "Polygon", "paths")
		}, x.trafficlayer = function(t) {
			v();
			var n = I.get("trafficlayer");
			n || (n = new A.classes.TrafficLayer, n.setMap(E), I.add(t, "trafficlayer", n)), g(t, n)
		}, x.transitlayer = function(t) {
			v();
			var n = I.get("transitlayer");
			n || (n = new A.classes.TransitLayer, n.setMap(E), I.add(t, "transitlayer", n)), g(t, n)
		}, x.bicyclinglayer = function(t) {
			v();
			var n = I.get("bicyclinglayer");
			n || (n = new A.classes.BicyclingLayer, n.setMap(E), I.add(t, "bicyclinglayer", n)), g(t, n)
		}, x.groundoverlay = function(t) {
			t.opts.bounds = y(t.opts.bounds), t.opts.bounds && v(t.opts.bounds.getCenter());
			var n, e = new A.classes.GroundOverlay(t.opts.url, t.opts.bounds, t.opts.opts);
			e.setMap(E), n = I.add(t, "groundoverlay", e), g(t, e, n)
		}, x.streetviewpanorama = function(n) {
			n.opts.opts || (n.opts.opts = {}), n.latLng ? n.opts.opts.position = n.latLng : n.opts.opts.position && (n.opts.opts.position = m(n.opts.opts.position)), n.td.divId ? n.opts.container = document.getElementById(n.td.divId) : n.opts.container && (n.opts.container = t(n.opts.container).get(0));
			var e, o = new A.classes.StreetViewPanorama(n.opts.container, n.opts.opts);
			o && E.setStreetView(o), e = I.add(n, "streetviewpanorama", o), g(n, o, e)
		}, x.kmllayer = function(n) {
			var e = [],
				o = "values" in n.td;
			return o || (n.td.values = [{
				options: n.opts
			}]), n.td.values.length ? (t.each(n.td.values, function(t, o) {
				var a, r, s, d = p(n, o);
				E || v(), s = d.options, d.options.opts && (s = d.options.opts, d.options.url && (s.url = d.options.url)), s.map = E, r = u("3.10") ? new A.classes.KmlLayer(s) : new A.classes.KmlLayer(s.url, s), e.push(r), a = I.add({
					td: d
				}, "kmllayer", r), l(i, {
					td: d
				}, r, a)
			}), void g(n, o ? e : e[0])) : void g(n, !1)
		}, x.panel = function(n) {
			v();
			var e, o, r = 0,
				s = 0,
				u = t(document.createElement("div"));
			u.css({
				position: "absolute",
				zIndex: 1e3,
				visibility: "hidden"
			}), n.opts.content && (o = t(n.opts.content), u.append(o), i.first().prepend(u), a(n.opts.left) ? a(n.opts.right) ? n.opts.center && (r = (i.width() - o.width()) / 2) : r = i.width() - o.width() - n.opts.right : r = n.opts.left, a(n.opts.top) ? a(n.opts.bottom) ? n.opts.middle && (s = (i.height() - o.height()) / 2) : s = i.height() - o.height() - n.opts.bottom : s = n.opts.top, u.css({
				top: s,
				left: r,
				visibility: "visible"
			})), e = I.add(n, "panel", u), g(n, u, e), u = null
		}, x.directionsrenderer = function(n) {
			n.opts.map = E;
			var e, o = new q.DirectionsRenderer(n.opts);
			n.td.divId ? o.setPanel(document.getElementById(n.td.divId)) : n.td.container && o.setPanel(t(n.td.container).get(0)), e = I.add(n, "directionsrenderer", o), g(n, o, e)
		}, x.getgeoloc = function(t) {
			g(t, t.latLng)
		}, x.styledmaptype = function(t) {
			v();
			var n = new A.classes.StyledMapType(t.td.styles, t.opts);
			E.mapTypes.set(t.td.id, n), g(t, n)
		}, x.imagemaptype = function(t) {
			v();
			var n = new A.classes.ImageMapType(t.opts);
			E.mapTypes.set(t.td.id, n), g(t, n)
		}, x.autofit = function(n) {
			var e = new q.LatLngBounds;
			t.each(I.all(), function(t, n) {
				n.getPosition && n.getPosition() ? e.extend(n.getPosition()) : n.getBounds && n.getBounds() ? (e.extend(n.getBounds().getNorthEast()), e.extend(n.getBounds().getSouthWest())) : n.getPaths && n.getPaths() ? n.getPaths().forEach(function(t) {
					t.forEach(function(t) {
						e.extend(t)
					})
				}) : n.getPath && n.getPath() ? n.getPath().forEach(function(t) {
					e.extend(t)
				}) : n.getCenter && n.getCenter() ? e.extend(n.getCenter()) : "function" == typeof _ && n instanceof _ && (n = I.getById(n.id(), !0), n && n.autofit(e))
			}), e.isEmpty() || E.getBounds() && E.getBounds().equals(e) || ("maxZoom" in n.td && q.event.addListenerOnce(E, "bounds_changed", function() {
				this.getZoom() > n.td.maxZoom && this.setZoom(n.td.maxZoom)
			}), E.fitBounds(e)), g(n, !0)
		}, x.clear = function(n) {
			if (o(n.td)) {
				if (I.clearById(n.td) || I.objClearById(n.td)) return void g(n, !0);
				n.td = {
					name: n.td
				}
			}
			n.td.id ? t.each(h(n.td.id), function(t, n) {
				I.clearById(n) || I.objClearById(n)
			}) : (I.clear(h(n.td.name), n.td.last, n.td.first, n.td.tag), I.objClear(h(n.td.name), n.td.last, n.td.first, n.td.tag)), g(n, !0)
		}, x.get = function(e, i, a) {
			var r, s, u = i ? e : e.td;
			return i || (a = u.full), o(u) ? (s = I.getById(u, !1, a) || I.objGetById(u), s === !1 && (r = u, u = {})) : r = u.name, "map" === r && (s = E), s || (s = [], u.id ? (t.each(h(u.id), function(t, n) {
				s.push(I.getById(n, !1, a) || I.objGetById(n))
			}), R(u.id) || (s = s[0])) : (t.each(r ? h(r) : [n], function(n, e) {
				var o;
				u.first ? (o = I.get(e, !1, u.tag, a), o && s.push(o)) : u.all ? t.each(I.all(e, u.tag, a), function(t, n) {
					s.push(n)
				}) : (o = I.get(e, !0, u.tag, a), o && s.push(o))
			}), u.all || R(r) || (s = s[0]))), s = R(s) || !u.all ? s : [s], i ? s : void g(e, s)
		}, x.exec = function(n) {
			t.each(h(n.td.func), function(e, o) {
				t.each(x.get(n.td, !0, n.td.hasOwnProperty("full") ? n.td.full : !0), function(t, n) {
					o.call(i, n)
				})
			}), g(n, !0)
		}, x.trigger = function(n) {
			if (o(n.td)) q.event.trigger(E, n.td);
			else {
				var e = [E, n.td.eventName];
				n.td.var_args && t.each(n.td.var_args, function(t, n) {
					e.push(n)
				}), q.event.trigger.apply(q.event, e)
			}
			c(n), b.ack()
		}
	}
	var A, q, Z = 0,
		z = t.isFunction,
		R = t.isArray,
		V = {},
		G = new I;
	t.fn.gmap3 = function() {
		var n, e = [],
			o = !0,
			i = [];
		for (r(), n = 0; n < arguments.length; n++) arguments[n] && e.push(arguments[n]);
		return e.length || e.push("map"), t.each(this, function() {
			var n = t(this),
				a = n.data("gmap3");
			o = !1, a || (a = new U(n), n.data("gmap3", a)), 1 !== e.length || "get" !== e[0] && !x(e[0]) ? a._plan(e) : "get" === e[0] ? i.push(a.get("map", !0)) : i.push(a.get(e[0].get, !0, e[0].get.full))
		}), i.length ? 1 === i.length ? i[0] : i : this
	}
}(jQuery);
/*********************************************************************
 *  #### Twitter Post Fetcher v15.0.1 ####
 *  Coded by Jason Mayes 2015. A present to all the developers out there.
 *  www.jasonmayes.com
 *  Please keep this disclaimer with my code if you use it. Thanks. :-)
 *  Got feedback or questions, ask here:
 *  http://www.jasonmayes.com/projects/twitterApi/
 *  Github: https://github.com/jasonmayes/Twitter-Post-Fetcher
 *  Updates will be posted to this site.
 *********************************************************************/
(function(C, p) {
	"function" === typeof define && define.amd ? define([], p) : "object" === typeof exports ? module.exports = p() : p()
})(this, function() {
	function C(a) {
		if (null === r) {
			for (var g = a.length, c = 0, k = document.getElementById(D), f = "<ul>"; c < g;) f += "<li>" + a[c] + "</li>", c++;
			k.innerHTML = f + "</ul>"
		} else r(a)
	}

	function p(a) {
		return a.replace(/<b[^>]*>(.*?)<\/b>/gi, function(a, c) {
			return c
		}).replace(/class="(?!(tco-hidden|tco-display|tco-ellipsis))+.*?"|data-query-source=".*?"|dir=".*?"|rel=".*?"/gi, "")
	}

	function E(a) {
		a = a.getElementsByTagName("a");
		for (var g = a.length - 1; 0 <= g; g--) a[g].setAttribute("target", "_blank")
	}

	function l(a, g) {
		for (var c = [], k = new RegExp("(^| )" + g + "( |$)"), f = a.getElementsByTagName("*"), h = 0, b = f.length; h < b; h++) k.test(f[h].className) && c.push(f[h]);
		return c
	}

	function F(a) {
		if (void 0 !== a && 0 <= a.innerHTML.indexOf("data-srcset")) return a = a.innerHTML.match(/data-srcset="([A-z0-9%_\.-]+)/i)[0], decodeURIComponent(a).split('"')[1]
	}
	var D = "",
		g = 20,
		G = !0,
		v = [],
		x = !1,
		y = !0,
		w = !0,
		z = null,
		A = !0,
		B = !0,
		r = null,
		H = !0,
		I = !1,
		t = !0,
		J = !0,
		K = !1,
		m = null,
		L = {
			fetch: function(a) {
				void 0 === a.maxTweets && (a.maxTweets = 20);
				void 0 === a.enableLinks && (a.enableLinks = !0);
				void 0 === a.showUser && (a.showUser = !0);
				void 0 === a.showTime && (a.showTime = !0);
				void 0 === a.dateFunction && (a.dateFunction = "default");
				void 0 === a.showRetweet && (a.showRetweet = !0);
				void 0 === a.customCallback && (a.customCallback = null);
				void 0 === a.showInteraction && (a.showInteraction = !0);
				void 0 === a.showImages && (a.showImages = !1);
				void 0 === a.linksInNewWindow && (a.linksInNewWindow = !0);
				void 0 === a.showPermalinks && (a.showPermalinks = !0);
				void 0 === a.dataOnly && (a.dataOnly = !1);
				if (x) v.push(a);
				else {
					x = !0;
					D = a.domId;
					g = a.maxTweets;
					G = a.enableLinks;
					w = a.showUser;
					y = a.showTime;
					B = a.showRetweet;
					z = a.dateFunction;
					r = a.customCallback;
					H = a.showInteraction;
					I = a.showImages;
					t = a.linksInNewWindow;
					J = a.showPermalinks;
					K = a.dataOnly;
					var l = document.getElementsByTagName("head")[0];
					null !== m && l.removeChild(m);
					m = document.createElement("script");
					m.type = "text/javascript";
					m.src = "https://cdn.syndication.twimg.com/widgets/timelines/" + a.id + "?&lang=" + (a.lang || "en") + "&callback=twitterFetcher.callback&suppress_response_codes=true&rnd=" + Math.random();
					l.appendChild(m)
				}
			},
			callback: function(a) {
				function m(a) {
					var b = a.getElementsByTagName("img")[0];
					b.src = b.getAttribute("data-src-2x");
					return a
				}
				var c = document.createElement("div");
				c.innerHTML = a.body;
				"undefined" === typeof c.getElementsByClassName && (A = !1);
				a = [];
				var k = [],
					f = [],
					h = [],
					b = [],
					q = [],
					n = [],
					e = 0;
				if (A)
					for (c = c.getElementsByClassName("timeline-Tweet"); e < c.length;) {
						0 < c[e].getElementsByClassName("timeline-Tweet-retweetCredit").length ? b.push(!0) : b.push(!1);
						if (!b[e] || b[e] && B) a.push(c[e].getElementsByClassName("timeline-Tweet-text")[0]),
							q.push(c[e].getAttribute("data-tweet-id")), k.push(m(c[e].getElementsByClassName("timeline-Tweet-author")[0])), f.push(c[e].getElementsByClassName("dt-updated")[0]), n.push(c[e].getElementsByClassName("timeline-Tweet-timestamp")[0]), void 0 !== c[e].getElementsByClassName("timeline-Tweet-media")[0] ? h.push(c[e].getElementsByClassName("timeline-Tweet-media")[0]) : h.push(void 0);
						e++
					} else
						for (c = l(c, "timeline-Tweet"); e < c.length;) {
							0 < l(c[e], "timeline-Tweet-retweetCredit").length ? b.push(!0) : b.push(!1);
							if (!b[e] || b[e] && B) a.push(l(c[e], "timeline-Tweet-text")[0]), q.push(c[e].getAttribute("data-tweet-id")), k.push(m(l(c[e], "timeline-Tweet-author")[0])), f.push(l(c[e], "dt-updated")[0]), n.push(l(c[e], "timeline-Tweet-timestamp")[0]), void 0 !== l(c[e], "timeline-Tweet-media")[0] ? h.push(l(c[e], "timeline-Tweet-media")[0]) : h.push(void 0);
							e++
						}
				a.length > g && (a.splice(g, a.length - g), k.splice(g, k.length - g), f.splice(g, f.length - g), b.splice(g, b.length - g), h.splice(g, h.length - g), n.splice(g, n.length - g));
				var c = [],
					e = a.length,
					d = 0;
				if (K)
					for (; d < e;) c.push({
						tweet: a[d].innerHTML,
						author: k[d].innerHTML,
						time: f[d].textContent,
						image: F(h[d]),
						rt: b[d],
						tid: q[d],
						permalinkURL: void 0 === n[d] ? "" : n[d].href
					}), d++;
				else
					for (; d < e;) {
						if ("string" !== typeof z) {
							var b = f[d].getAttribute("datetime"),
								u = new Date(f[d].getAttribute("datetime").replace(/-/g, "/").replace("T", " ").split("+")[0]),
								b = z(u, b);
							f[d].setAttribute("aria-label", b);
							if (a[d].textContent)
								if (A) f[d].textContent = b;
								else {
									var u = document.createElement("p"),
										r = document.createTextNode(b);
									u.appendChild(r);
									u.setAttribute("aria-label", b);
									f[d] = u
								}
							else f[d].textContent = b
						}
						b = "";
						G ? (t && (E(a[d]), w && E(k[d])), w && (b += '<div class="user">' + p(k[d].innerHTML) + "</div>"), b += '<p class="tweet">' + p(a[d].innerHTML) + "</p>", y && (b = J ? b + ('<p class="timePosted"><a href="' + n[d] + '">' + f[d].getAttribute("aria-label") + "</a></p>") : b + ('<p class="timePosted">' + f[d].getAttribute("aria-label") + "</p>"))) : (w && (b += '<p class="user">' + k[d].textContent + "</p>"), b += '<p class="tweet">' + a[d].textContent + "</p>", y && (b += '<p class="timePosted">' + f[d].textContent + "</p>"));
						H && (b += '<p class="interact"><a href="https://twitter.com/intent/tweet?in_reply_to=' + q[d] + '" class="twitter_reply_icon"' + (t ? ' target="_blank">' : ">") + 'Reply</a><a href="https://twitter.com/intent/retweet?tweet_id=' + q[d] + '" class="twitter_retweet_icon"' + (t ? ' target="_blank">' : ">") + 'Retweet</a><a href="https://twitter.com/intent/favorite?tweet_id=' + q[d] + '" class="twitter_fav_icon"' + (t ? ' target="_blank">' : ">") + "Favorite</a></p>");
						I && void 0 !== h[d] && (b += '<div class="media"><img src="' + F(h[d]) + '" alt="Image from tweet" /></div>');
						c.push(b);
						d++
					}
				C(c);
				x = !1;
				0 < v.length && (L.fetch(v[0]), v.splice(0, 1))
			}
		};
	return window.twitterFetcher = L
});
/*!
 * Spectragram by Adrian Quevedo (http://adrianquevedo.com/)
 * http://spectragram.js.org/  
 */
if (typeof Object.create !== "function") {
	Object.create = function(obj) {
		function F() {}
		F.prototype = obj;
		return new F
	}
}(function($, window, document, undefined) {
	var Instagram = {
		API_URL: "https://api.instagram.com/v1",
		initialize: function(options, elem) {
			this.elem = elem;
			this.$elem = $(elem);
			this.accessData = $.fn.spectragram.accessData, this.accessToken = this.accessData.accessToken, this.clientID = this.accessData.clientID, this.userCredentials = this.clientID + "&access_token=" + this.accessToken + "", this.options = $.extend({}, $.fn.spectragram.options, options);
			this.messages = {
				defaultImageAltText: "Instagram Photo related with " + this.options.query,
				notFound: "This user account is private or doesn't have any photos."
			}
		},
		getRecentMedia: function(userID) {
			var self = this,
				getData = "/users/" + userID + "/media/recent/?" + self.userCredentials;
			self.fetch(getData).done(function(results) {
				self.display(results)
			})
		},
		getUserFeed: function() {
			var self = this,
				getData = "/users/search?q=" + self.options.query + "&count=" + self.options.max + "&access_token=" + self.accessToken + "",
				isUsernameValid = false;
			self.fetch(getData).done(function(results) {
				if (results.data.length) {
					for (var length = results.data.length, i = 0; i < length; i++) {
						if (results.data[i].username === self.options.query) {
							self.getRecentMedia(results.data[i].id);
							isUsernameValid = true
						}
					}
				}
				if (isUsernameValid === false) {
					$.error("Spectragram.js - Error: the username " + self.options.query + " does not exist.")
				}
			})
		},
		getPopular: function() {
			var self = this,
				getData = "/media/popular?client_id=" + self.userCredentials;
			self.fetch(getData).done(function(results) {
				self.display(results)
			})
		},
		getRecentTagged: function() {
			var self = this,
				getData = "/tags/" + self.options.query + "/media/recent?client_id=" + self.userCredentials;
			self.fetch(getData).done(function(results) {
				if (results.data.length) {
					self.display(results)
				} else {
					$.error("Spectragram.js - Error: the tag " + self.options.query + " does not have results.")
				}
			})
		},
		fetch: function(getData) {
			var getUrl = this.API_URL + getData;
			return $.ajax({
				type: "GET",
				dataType: "jsonp",
				cache: false,
				url: getUrl
			})
		},
		display: function(results) {
			var $element, $image, imageGroup = [],
				imageCaption, max, setSize, size;
			if (results.data === undefined || results.meta.code !== 200 || results.data.length === 0) {
				this.$elem.append($(this.options.wrapEachWith).append(this.messages.notFound))
			} else {
				max = this.options.max >= results.data.length ? results.data.length : this.options.max;
				setSize = this.options.size;
				for (var i = 0; i < max; i++) {
					if (setSize === "small") {
						size = results.data[i].images.thumbnail.url
					} else if (setSize === "medium") {
						size = results.data[i].images.low_resolution.url
					} else {
						size = results.data[i].images.standard_resolution.url
					}
					imageCaption = results.data[i].caption !== null ? $("<span>").text(results.data[i].caption.text).html() : this.messages.defaultImageAltText;
					$image = $("<img>", {
						src: size
					});
					$element = $("<a>", {
						href: results.data[i].link,
						target: "_blank",
						title: imageCaption
					}).append($image);
					imageGroup.push($(this.options.wrapEachWith).append($element))
				}
				this.$elem.append(imageGroup)
			}
			if (typeof this.options.complete === "function") {
				this.options.complete.call(this)
			}
		}
	};
	jQuery.fn.spectragram = function(method, options) {
		if (jQuery.fn.spectragram.accessData.clientID) {
			this.each(function() {
				var instagram = Object.create(Instagram);
				instagram.initialize(options, this);
				if (instagram[method]) {
					return instagram[method](this)
				} else {
					$.error("Method " + method + " does not exist on jQuery.spectragram")
				}
			})
		} else {
			$.error("You must define an accessToken and a clientID on jQuery.spectragram")
		}
	};
	jQuery.fn.spectragram.options = {
		complete: null,
		max: 10,
		query: "instagram",
		size: "medium",
		wrapEachWith: "<li></li>"
	};
	jQuery.fn.spectragram.accessData = {
		accessToken: null,
		clientID: null
	}
})(jQuery, window, document);
/*!
 * Cube Portfolio - Responsive jQuery Grid Plugin
 *
 * version: 3.5.2 (11 February, 2016)
 * require: jQuery v1.7+
 *
 * Copyright 2013-2016, Mihai Buricea (http://scriptpie.com/cubeportfolio/live-preview/)
 * Licensed under CodeCanyon License (http://codecanyon.net/licenses)
 *
 */
! function(a, b, c, d) {
	"use strict";

	function e(b, c, d) {
		var f, g = this,
			h = "cbp";
		if (a.data(b, "cubeportfolio")) throw new Error("cubeportfolio is already initialized. Destroy it before initialize again!");
		a.data(b, "cubeportfolio", g), g.options = a.extend({}, a.fn.cubeportfolio.options, c), g.isAnimating = !0, g.defaultFilter = g.options.defaultFilter, g.registeredEvents = [], g.queue = [], g.addedWrapp = !1, a.isFunction(d) && g.registerEvent("initFinish", d, !0), g.obj = b, g.$obj = a(b), f = g.$obj.children(), g.options.caption && ("expand" === g.options.caption || e["private"].modernBrowser || (g.options.caption = "minimal"), h += " cbp-caption-active cbp-caption-" + g.options.caption), g.$obj.addClass(h), (0 === f.length || f.first().hasClass("cbp-item")) && (g.wrapInner(g.obj, "cbp-wrapper"), g.addedWrapp = !0), g.$ul = g.$obj.children().addClass("cbp-wrapper"), g.wrapInner(g.obj, "cbp-wrapper-outer"), g.wrapper = g.$obj.children(".cbp-wrapper-outer"), g.blocks = g.$ul.children(".cbp-item"), g.blocksOn = g.blocks, g.wrapInner(g.blocks, "cbp-item-wrapper"), g.plugins = a.map(e.plugins, function(a) {
			return a(g)
		}), g.triggerEvent("afterPlugins"), g.loadImages(g.$obj, g.display)
	}
	a.extend(e.prototype, {
		storeData: function(b, c) {
			var d = this;
			c = c || 0, b.each(function(b, e) {
				var f = a(e),
					g = f.width(),
					h = f.height();
				f.data("cbp", {
					index: c + b,
					wrapper: f.children(".cbp-item-wrapper"),
					widthInitial: g,
					heightInitial: h,
					width: g,
					height: h,
					widthAndGap: g + d.options.gapVertical,
					heightAndGap: h + d.options.gapHorizontal,
					left: null,
					leftNew: null,
					top: null,
					topNew: null,
					pack: !1
				})
			})
		},
		wrapInner: function(a, b) {
			var e, f, g;
			if (b = b || "", !(a.length && a.length < 1))
				for (a.length === d && (a = [a]), f = a.length - 1; f >= 0; f--) {
					for (e = a[f], g = c.createElement("div"), g.setAttribute("class", b); e.childNodes.length;) g.appendChild(e.childNodes[0]);
					e.appendChild(g)
				}
		},
		removeAttrImage: function(a) {
			a.removeAttribute("width"), a.removeAttribute("height"), a.removeAttribute("style")
		},
		loadImages: function(b, c) {
			var d = this;
			requestAnimationFrame(function() {
				var e = b.find("img").map(function(b, c) {
						return c.hasAttribute("width") && c.hasAttribute("height") ? (c.style.width = c.getAttribute("width") + "px", c.style.height = c.getAttribute("height") + "px", c.hasAttribute("data-cbp-src") ? null : (null === d.checkSrc(c.src) ? d.removeAttrImage(c) : a("<img>").on("load.cbp error.cbp", function() {
							d.removeAttrImage(c)
						}).attr("src", c.src), null)) : d.checkSrc(c.src)
					}),
					f = e.length;
				return 0 === f ? void c.call(d) : void a.each(e, function(b, e) {
					a("<img>").on("load.cbp error.cbp", function() {
						f--, 0 === f && c.call(d)
					}).attr("src", e)
				})
			})
		},
		checkSrc: function(a) {
			if ("" === a) return null;
			var b = new Image;
			return b.src = a, b.complete && b.naturalWidth !== d && 0 !== b.naturalWidth ? null : a
		},
		display: function() {
			var a = this;
			a.width = a.$obj.outerWidth(), a.storeData(a.blocks), a.triggerEvent("initStartRead"), a.triggerEvent("initStartWrite"), a.layoutAndAdjustment(), a.triggerEvent("initEndRead"), a.triggerEvent("initEndWrite"), a.$obj.addClass("cbp-ready"), a.runQueue("delayFrame", a.delayFrame)
		},
		delayFrame: function() {
			var a = this;
			requestAnimationFrame(function() {
				a.resizeEvent(), a.triggerEvent("initFinish"), a.isAnimating = !1, a.$obj.trigger("initComplete.cbp")
			})
		},
		resizeEvent: function() {
			var a, b = this;
			e["private"].initResizeEvent({
				instance: b,
				fn: function() {
					var b = this;
					b.triggerEvent("beforeResizeGrid"), a = b.$obj.outerWidth(), b.width !== a && ("alignCenter" === b.options.gridAdjustment && (b.wrapper[0].style.maxWidth = ""), b.width = a, b.layoutAndAdjustment(), b.triggerEvent("resizeGrid")), b.triggerEvent("resizeWindow")
				}
			})
		},
		gridAdjust: function() {
			var b = this;
			"responsive" === b.options.gridAdjustment ? b.responsiveLayout() : (b.blocks.removeAttr("style"), b.blocks.each(function(c, d) {
				var e = a(d).data("cbp"),
					f = d.getBoundingClientRect(),
					g = b.columnWidthTruncate(f.right - f.left),
					h = Math.round(f.bottom - f.top);
				e.height = h, e.heightAndGap = h + b.options.gapHorizontal, e.width = g, e.widthAndGap = g + b.options.gapVertical
			}), b.widthAvailable = b.width + b.options.gapVertical), b.triggerEvent("gridAdjust")
		},
		layoutAndAdjustment: function() {
			var a = this;
			a.gridAdjust(), a.layout()
		},
		layout: function() {
			var a = this;
			a.computeBlocks(a.filterConcat(a.defaultFilter)), "slider" === a.options.layoutMode ? (a.sliderLayoutReset(), a.sliderLayout()) : (a.mosaicLayoutReset(), a.mosaicLayout()), a.positionateItems(), a.resizeMainContainer()
		},
		computeFilter: function(a) {
			var b = this;
			b.computeBlocks(a), b.mosaicLayoutReset(), b.mosaicLayout(), b.filterLayout()
		},
		filterLayout: function() {
			var b = this;
			b.blocksOff.addClass("cbp-item-off"), b.blocksOn.removeClass("cbp-item-off").each(function(b, c) {
				var d = a(c).data("cbp");
				d.left = d.leftNew, d.top = d.topNew, c.style.left = d.left + "px", c.style.top = d.top + "px"
			}), b.resizeMainContainer(), b.filterFinish()
		},
		filterFinish: function() {
			var a = this;
			a.blocksAreSorted && a.sortBlocks(a.blocks, "index"), a.isAnimating = !1, a.$obj.trigger("filterComplete.cbp"), a.triggerEvent("filterFinish")
		},
		computeBlocks: function(a) {
			var b = this;
			b.blocksOnInitial = b.blocksOn, b.blocksOn = b.blocks.filter(a), b.blocksOff = b.blocks.not(a), b.triggerEvent("computeBlocksFinish", a)
		},
		responsiveLayout: function() {
			var b = this;
			b.cols = b[a.isArray(b.options.mediaQueries) ? "getColumnsBreakpoints" : "getColumnsAuto"](), b.columnWidth = b.columnWidthTruncate((b.width + b.options.gapVertical) / b.cols), b.widthAvailable = b.columnWidth * b.cols, "mosaic" === b.options.layoutMode && b.getMosaicWidthReference(), b.blocks.each(function(c, d) {
				var e, f = a(d).data("cbp"),
					g = 1;
				"mosaic" === b.options.layoutMode && (g = b.getColsMosaic(f.widthInitial)), e = b.columnWidth * g - b.options.gapVertical, d.style.width = e + "px", f.width = e, f.widthAndGap = e + b.options.gapVertical, d.style.height = ""
			});
			var c = [];
			b.blocks.each(function(b, d) {
				var e = a(d),
					f = e.data("cbp").width;
				a.each(e.find("img").filter("[width][height]"), function(a, b) {
					var d = f / parseInt(b.getAttribute("width"), 10);
					c.push({
						el: b,
						width: f,
						height: Math.floor(parseInt(b.getAttribute("height"), 10) * d)
					})
				})
			}), a.each(c, function(a, b) {
				b.el.width = b.width, b.el.height = b.height, b.el.style.width = b.width + "px", b.el.style.height = b.height + "px"
			}), b.blocks.each(function(c, d) {
				var e = a(d).data("cbp"),
					f = d.getBoundingClientRect(),
					g = Math.round(f.bottom - f.top);
				e.height = g, e.heightAndGap = g + b.options.gapHorizontal
			})
		},
		getMosaicWidthReference: function() {
			var b = this,
				c = [];
			b.blocks.each(function(b, d) {
				var e = a(d).data("cbp");
				c.push(e.widthInitial)
			}), c.sort(function(a, b) {
				return a - b
			}), c[0] ? b.mosaicWidthReference = c[0] : b.mosaicWidthReference = b.columnWidth
		},
		getColsMosaic: function(a) {
			var b = this;
			if (a === b.width) return b.cols;
			var c = a / b.mosaicWidthReference;
			return c = c % 1 >= .79 ? Math.ceil(c) : Math.floor(c), Math.min(Math.max(c, 1), b.cols)
		},
		getColumnsAuto: function() {
			var a = this;
			if (0 === a.blocks.length) return 1;
			var b = a.blocks.first().data("cbp").widthInitial + a.options.gapVertical;
			return Math.max(Math.round(a.width / b), 1)
		},
		getColumnsBreakpoints: function() {
			var b, c = this,
				e = c.width;
			return a.each(c.options.mediaQueries, function(a, c) {
				return e >= c.width ? (b = c.cols, !1) : void 0
			}), b === d && (b = c.options.mediaQueries[c.options.mediaQueries.length - 1].cols), b
		},
		columnWidthTruncate: function(a) {
			return Math.floor(a)
		},
		positionateItems: function() {
			var b, c = this;
			c.blocksOn.removeClass("cbp-item-off").each(function(c, d) {
				b = a(d).data("cbp"), b.left = b.leftNew, b.top = b.topNew, d.style.left = b.left + "px", d.style.top = b.top + "px"
			}), c.blocksOff.addClass("cbp-item-off"), c.blocksAreSorted && c.sortBlocks(c.blocks, "index")
		},
		resizeMainContainer: function() {
			var b, c = this,
				f = Math.max(c.freeSpaces.slice(-1)[0].topStart - c.options.gapHorizontal, 0);
			return "alignCenter" === c.options.gridAdjustment && (b = 0, c.blocksOn.each(function(c, d) {
				var e = a(d).data("cbp"),
					f = e.left + e.width;
				f > b && (b = f)
			}), c.wrapper[0].style.maxWidth = b + "px"), f === c.height ? void c.triggerEvent("resizeMainContainer") : (c.obj.style.height = f + "px", c.height !== d && (e["private"].modernBrowser ? c.$obj.one(e["private"].transitionend, function() {
				c.$obj.trigger("pluginResize.cbp")
			}) : c.$obj.trigger("pluginResize.cbp")), c.height = f, void c.triggerEvent("resizeMainContainer"))
		},
		filterConcat: function(a) {
			return a.replace(/\|/gi, "")
		},
		pushQueue: function(a, b) {
			var c = this;
			c.queue[a] = c.queue[a] || [], c.queue[a].push(b)
		},
		runQueue: function(b, c) {
			var d = this,
				e = d.queue[b] || [];
			a.when.apply(a, e).then(a.proxy(c, d))
		},
		clearQueue: function(a) {
			var b = this;
			b.queue[a] = []
		},
		registerEvent: function(a, b, c) {
			var d = this;
			d.registeredEvents[a] || (d.registeredEvents[a] = []), d.registeredEvents[a].push({
				func: b,
				oneTime: c || !1
			})
		},
		triggerEvent: function(a, b) {
			var c, d, e = this;
			if (e.registeredEvents[a])
				for (c = 0, d = e.registeredEvents[a].length; d > c; c++) e.registeredEvents[a][c].func.call(e, b), e.registeredEvents[a][c].oneTime && (e.registeredEvents[a].splice(c, 1), c--, d--)
		},
		addItems: function(b, c) {
			var d = this;
			d.wrapInner(b, "cbp-item-wrapper"), b.addClass("cbp-item-loading").css({
				top: "100%",
				left: 0
			}).appendTo(d.$ul), e["private"].modernBrowser ? b.last().one(e["private"].animationend, function() {
				d.addItemsFinish(b, c)
			}) : d.addItemsFinish(b, c), d.loadImages(b, function() {
				d.$obj.addClass("cbp-addItems"), d.storeData(b, d.blocks.length), a.merge(d.blocks, b), d.triggerEvent("addItemsToDOM", b), d.layoutAndAdjustment(), d.elems && e["public"].showCounter.call(d.obj, d.elems), d.triggerEvent("appendItemsFinish")
			})
		},
		addItemsFinish: function(b, c) {
			var d = this;
			d.isAnimating = !1, d.$obj.removeClass("cbp-addItems"), b.removeClass("cbp-item-loading"), a.isFunction(c) && c.call(d, b)
		}
	}), a.fn.cubeportfolio = function(a, b, c) {
		return this.each(function() {
			if ("object" == typeof a || !a) return e["public"].init.call(this, a, b);
			if (e["public"][a]) return e["public"][a].call(this, b, c);
			throw new Error("Method " + a + " does not exist on jquery.cubeportfolio.js")
		})
	}, e.plugins = {}, a.fn.cubeportfolio.constructor = e
}(jQuery, window, document),
function(a, b, c, d) {
	"use strict";
	var e = a.fn.cubeportfolio.constructor;
	a.extend(e.prototype, {
		mosaicLayoutReset: function() {
			var b = this;
			b.blocksAreSorted = !1, b.blocksOn.each(function(b, c) {
				a(c).data("cbp").pack = !1
			})
		},
		mosaicLayout: function() {
			var a, b = this,
				c = b.blocksOn.length,
				d = {};
			for (b.freeSpaces = [{
					leftStart: 0,
					leftEnd: b.widthAvailable,
					topStart: 0,
					topEnd: Math.pow(2, 18)
				}], a = 0; c > a; a++) {
				if (d = b.getSpaceIndexAndBlock(), null === d) return b.sortBlocksToPreventGaps(), void b.mosaicLayout();
				b.generateF1F2(d.spaceIndex, d.dataBlock), b.generateG1G2G3G4(d.dataBlock), b.cleanFreeSpaces(), b.addHeightToBlocks()
			}
			b.blocksAreSorted && b.sortBlocks(b.blocksOn, "topNew")
		},
		getSpaceIndexAndBlock: function() {
			var b = this,
				c = null;
			return a.each(b.freeSpaces, function(d, e) {
				var f = e.leftEnd - e.leftStart,
					g = e.topEnd - e.topStart;
				return b.blocksOn.each(function(b, h) {
					var i = a(h).data("cbp");
					if (i.pack !== !0) return i.widthAndGap <= f && i.heightAndGap <= g ? (i.pack = !0, c = {
						spaceIndex: d,
						dataBlock: i
					}, i.leftNew = e.leftStart, i.topNew = e.topStart, !1) : void 0
				}), !b.blocksAreSorted && b.options.sortToPreventGaps && d > 0 ? (c = null, !1) : null !== c ? !1 : void 0
			}), c
		},
		generateF1F2: function(a, b) {
			var c = this,
				d = c.freeSpaces[a],
				e = {
					leftStart: d.leftStart + b.widthAndGap,
					leftEnd: d.leftEnd,
					topStart: d.topStart,
					topEnd: d.topEnd
				},
				f = {
					leftStart: d.leftStart,
					leftEnd: d.leftEnd,
					topStart: d.topStart + b.heightAndGap,
					topEnd: d.topEnd
				};
			c.freeSpaces.splice(a, 1), e.leftEnd > e.leftStart && e.topEnd > e.topStart && (c.freeSpaces.splice(a, 0, e), a++), f.leftEnd > f.leftStart && f.topEnd > f.topStart && c.freeSpaces.splice(a, 0, f)
		},
		generateG1G2G3G4: function(b) {
			var c = this,
				d = [];
			a.each(c.freeSpaces, function(a, e) {
				var f = c.intersectSpaces(e, b);
				return null === f ? void d.push(e) : (c.generateG1(e, f, d), c.generateG2(e, f, d), c.generateG3(e, f, d), void c.generateG4(e, f, d))
			}), c.freeSpaces = d
		},
		intersectSpaces: function(a, b) {
			var c = {
				leftStart: b.leftNew,
				leftEnd: b.leftNew + b.widthAndGap,
				topStart: b.topNew,
				topEnd: b.topNew + b.heightAndGap
			};
			if (a.leftStart === c.leftStart && a.leftEnd === c.leftEnd && a.topStart === c.topStart && a.topEnd === c.topEnd) return null;
			var d = Math.max(a.leftStart, c.leftStart),
				e = Math.min(a.leftEnd, c.leftEnd),
				f = Math.max(a.topStart, c.topStart),
				g = Math.min(a.topEnd, c.topEnd);
			return d >= e || f >= g ? null : {
				leftStart: d,
				leftEnd: e,
				topStart: f,
				topEnd: g
			}
		},
		generateG1: function(a, b, c) {
			a.topStart !== b.topStart && c.push({
				leftStart: a.leftStart,
				leftEnd: a.leftEnd,
				topStart: a.topStart,
				topEnd: b.topStart
			})
		},
		generateG2: function(a, b, c) {
			a.leftEnd !== b.leftEnd && c.push({
				leftStart: b.leftEnd,
				leftEnd: a.leftEnd,
				topStart: a.topStart,
				topEnd: a.topEnd
			})
		},
		generateG3: function(a, b, c) {
			a.topEnd !== b.topEnd && c.push({
				leftStart: a.leftStart,
				leftEnd: a.leftEnd,
				topStart: b.topEnd,
				topEnd: a.topEnd
			})
		},
		generateG4: function(a, b, c) {
			a.leftStart !== b.leftStart && c.push({
				leftStart: a.leftStart,
				leftEnd: b.leftStart,
				topStart: a.topStart,
				topEnd: a.topEnd
			})
		},
		cleanFreeSpaces: function() {
			var a = this;
			a.freeSpaces.sort(function(a, b) {
				return a.topStart > b.topStart ? 1 : a.topStart < b.topStart ? -1 : a.leftStart > b.leftStart ? 1 : a.leftStart < b.leftStart ? -1 : 0
			}), a.correctSubPixelValues(), a.removeNonMaximalFreeSpaces()
		},
		correctSubPixelValues: function() {
			var a, b, c, d, e = this;
			for (a = 0, b = e.freeSpaces.length - 1; b > a; a++) c = e.freeSpaces[a], d = e.freeSpaces[a + 1], d.topStart - c.topStart <= 1 && (d.topStart = c.topStart)
		},
		removeNonMaximalFreeSpaces: function() {
			var b = this;
			b.uniqueFreeSpaces(), b.freeSpaces = a.map(b.freeSpaces, function(c, d) {
				return a.each(b.freeSpaces, function(a, b) {
					return d !== a && b.leftStart <= c.leftStart && b.leftEnd >= c.leftEnd && b.topStart <= c.topStart && b.topEnd >= c.topEnd ? (c = null, !1) : void 0
				}), c
			})
		},
		uniqueFreeSpaces: function() {
			var b = this,
				c = [];
			a.each(b.freeSpaces, function(b, d) {
				a.each(c, function(a, b) {
					return b.leftStart === d.leftStart && b.leftEnd === d.leftEnd && b.topStart === d.topStart && b.topEnd === d.topEnd ? (d = null, !1) : void 0
				}), null !== d && c.push(d)
			}), b.freeSpaces = c
		},
		addHeightToBlocks: function() {
			var b = this;
			if (!(b.freeSpaces.length > 1)) {
				var c = b.freeSpaces[0].topStart;
				b.blocksOn.each(function(b, d) {
					var e = a(d).data("cbp");
					if (e.pack === !0) {
						var f = c - e.topNew - e.heightAndGap;
						0 > f && (d.style.height = e.height + f + "px")
					}
				})
			}
		},
		sortBlocksToPreventGaps: function() {
			var b = this;
			b.blocksAreSorted = !0, b.blocksOn.sort(function(b, c) {
				var d = a(b).data("cbp"),
					e = a(c).data("cbp");
				return d.widthAndGap < e.widthAndGap ? 1 : d.widthAndGap > e.widthAndGap ? -1 : d.heightAndGap < e.heightAndGap ? 1 : d.heightAndGap > e.heightAndGap ? -1 : d.index > e.index ? 1 : d.index < e.index ? -1 : void 0
			}), b.blocksOn.each(function(b, c) {
				a(c).data("cbp").pack = !1, c.style.height = ""
			})
		},
		sortBlocks: function(b, c) {
			b.sort(function(b, d) {
				var e = a(b).data("cbp"),
					f = a(d).data("cbp");
				return e[c] > f[c] ? 1 : e[c] < f[c] ? -1 : e.leftNew > f.leftNew ? 1 : e.leftNew < f.leftNew ? -1 : 0
			})
		}
	})
}(jQuery, window, document), jQuery.fn.cubeportfolio.options = {
		filters: "",
		loadMore: "",
		loadMoreAction: "click",
		search: "",
		layoutMode: "grid",
		sortToPreventGaps: !1,
		drag: !0,
		auto: !1,
		autoTimeout: 5e3,
		autoPauseOnHover: !0,
		showNavigation: !0,
		showPagination: !0,
		rewindNav: !0,
		scrollByPage: !1,
		defaultFilter: "*",
		filterDeeplinking: !1,
		animationType: "fadeOut",
		gridAdjustment: "responsive",
		mediaQueries: !1,
		gapHorizontal: 10,
		gapVertical: 10,
		caption: "pushTop",
		displayType: "fadeIn",
		displayTypeSpeed: 400,
		lightboxDelegate: ".cbp-lightbox",
		lightboxGallery: !0,
		lightboxTitleSrc: "data-title",
		lightboxCounter: '<div class="cbp-popup-lightbox-counter">{{current}} of {{total}}</div>',
		singlePageDelegate: ".cbp-singlePage",
		singlePageDeeplinking: !0,
		singlePageStickyNavigation: !0,
		singlePageCounter: '<div class="cbp-popup-singlePage-counter">{{current}} of {{total}}</div>',
		singlePageAnimation: "left",
		singlePageCallback: function(a, b) {},
		singlePageInlineDelegate: ".cbp-singlePageInline",
		singlePageInlineDeeplinking: !1,
		singlePageInlinePosition: "top",
		singlePageInlineInFocus: !0,
		singlePageInlineCallback: function(a, b) {},
		plugins: {}
	},
	function(a, b, c, d) {
		"use strict";
		var e = a.fn.cubeportfolio.constructor;
		e["private"] = {
			resizeEventArray: [],
			initResizeEvent: function(a) {
				var b = e["private"];
				0 === b.resizeEventArray.length && b.resizeEvent(), b.resizeEventArray.push(a)
			},
			destroyResizeEvent: function(c) {
				var d = e["private"],
					f = a.map(d.resizeEventArray, function(a, b) {
						return a.instance !== c ? a : void 0
					});
				d.resizeEventArray = f, 0 === d.resizeEventArray.length && a(b).off("resize.cbp")
			},
			resizeEvent: function() {
				var c, d = e["private"];
				a(b).on("resize.cbp", function() {
					clearTimeout(c), c = setTimeout(function() {
						b.innerHeight != screen.height && a.each(d.resizeEventArray, function(a, b) {
							b.fn.call(b.instance)
						})
					}, 50)
				})
			},
			checkInstance: function(b) {
				var c = a.data(this, "cubeportfolio");
				if (!c) throw new Error("cubeportfolio is not initialized. Initialize it before calling " + b + " method!");
				return c.triggerEvent("publicMethod"), c
			},
			browserInfo: function() {
				var a, c, f, g = e["private"],
					h = navigator.appVersion; - 1 !== h.indexOf("MSIE 8.") ? g.browser = "ie8" : -1 !== h.indexOf("MSIE 9.") ? g.browser = "ie9" : -1 !== h.indexOf("MSIE 10.") ? g.browser = "ie10" : b.ActiveXObject || "ActiveXObject" in b ? g.browser = "ie11" : /android/gi.test(h) ? g.browser = "android" : /iphone|ipad|ipod/gi.test(h) ? g.browser = "ios" : /chrome/gi.test(h) ? g.browser = "chrome" : g.browser = "", f = g.styleSupport("perspective"), typeof f !== d && (a = g.styleSupport("transition"), g.transitionend = {
					WebkitTransition: "webkitTransitionEnd",
					transition: "transitionend"
				}[a], c = g.styleSupport("animation"), g.animationend = {
					WebkitAnimation: "webkitAnimationEnd",
					animation: "animationend"
				}[c], g.animationDuration = {
					WebkitAnimation: "webkitAnimationDuration",
					animation: "animationDuration"
				}[c], g.animationDelay = {
					WebkitAnimation: "webkitAnimationDelay",
					animation: "animationDelay"
				}[c], g.transform = g.styleSupport("transform"), a && c && g.transform && (g.modernBrowser = !0))
			},
			styleSupport: function(a) {
				var b, d = "Webkit" + a.charAt(0).toUpperCase() + a.slice(1),
					e = c.createElement("div");
				return a in e.style ? b = a : d in e.style && (b = d), e = null, b
			}
		}, e["private"].browserInfo()
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";
		var e = a.fn.cubeportfolio.constructor;
		e["public"] = {
			init: function(a, b) {
				new e(this, a, b)
			},
			destroy: function(b) {
				var c = e["private"].checkInstance.call(this, "destroy");
				c.triggerEvent("beforeDestroy"), a.removeData(this, "cubeportfolio"), c.blocks.removeData("cbp"), c.$obj.removeClass("cbp-ready").removeAttr("style"), c.$ul.removeClass("cbp-wrapper"), e["private"].destroyResizeEvent(c), c.$obj.off(".cbp"), c.blocks.removeClass("cbp-item-off").removeAttr("style"), c.blocks.find(".cbp-item-wrapper").children().unwrap(), c.options.caption && c.$obj.removeClass("cbp-caption-active cbp-caption-" + c.options.caption), c.destroySlider(), c.$ul.unwrap(), c.addedWrapp && c.blocks.unwrap(), a.each(c.plugins, function(a, b) {
					"function" == typeof b.destroy && b.destroy()
				}), a.isFunction(b) && b.call(c), c.triggerEvent("afterDestroy")
			},
			filter: function(b, c) {
				var f, g = e["private"].checkInstance.call(this, "filter");
				if (!g.isAnimating) {
					if (g.isAnimating = !0, a.isFunction(c) && g.registerEvent("filterFinish", c, !0), a.isFunction(b)) {
						if (f = b.call(g, g.blocks), f === d) throw new Error("When you call cubeportfolio API `filter` method with a param of type function you must return the blocks that will be visible.")
					} else {
						if (g.options.filterDeeplinking) {
							var h = location.href.replace(/#cbpf=(.*?)([#\?&]|$)/gi, "");
							location.href = h + "#cbpf=" + encodeURIComponent(b), g.singlePage && g.singlePage.url && (g.singlePage.url = location.href)
						}
						g.defaultFilter = b, f = g.filterConcat(g.defaultFilter)
					}
					g.singlePageInline && g.singlePageInline.isOpen ? g.singlePageInline.close("promise", {
						callback: function() {
							g.computeFilter(f)
						}
					}) : g.computeFilter(f)
				}
			},
			showCounter: function(b, c) {
				var d = e["private"].checkInstance.call(this, "showCounter");
				a.isFunction(c) && d.registerEvent("showCounterFinish", c, !0), d.elems = b, b.each(function() {
					var b = a(this),
						c = d.blocks.filter(b.data("filter")).length;
					b.find(".cbp-filter-counter").text(c)
				}), d.triggerEvent("showCounterFinish", b)
			},
			appendItems: function(b, c) {
				var d = e["private"].checkInstance.call(this, "appendItems"),
					f = a(b).filter(".cbp-item");
				return d.isAnimating || f.length < 1 ? void(a.isFunction(c) && c.call(d, f)) : (d.isAnimating = !0, void(d.singlePageInline && d.singlePageInline.isOpen ? d.singlePageInline.close("promise", {
					callback: function() {
						d.addItems(f, c)
					}
				}) : d.addItems(f, c)))
			}
		}
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";
		var e = a.fn.cubeportfolio.constructor;
		a.extend(e.prototype, {
			updateSliderPagination: function() {
				var b, c, d = this;
				if (d.options.showPagination) {
					for (b = Math.ceil(d.blocksOn.length / d.cols), d.navPagination.empty(), c = b - 1; c >= 0; c--) a("<div/>", {
						"class": "cbp-nav-pagination-item",
						"data-slider-action": "jumpTo"
					}).appendTo(d.navPagination);
					d.navPaginationItems = d.navPagination.children()
				}
				d.enableDisableNavSlider()
			},
			destroySlider: function() {
				var b = this;
				"slider" === b.options.layoutMode && (b.$obj.removeClass("cbp-mode-slider"), b.$ul.removeAttr("style"), b.$ul.off(".cbp"), a(c).off(".cbp"), b.options.auto && b.stopSliderAuto())
			},
			nextSlider: function(a) {
				var b = this;
				if (b.isEndSlider()) {
					if (!b.isRewindNav()) return;
					b.sliderActive = 0
				} else b.options.scrollByPage ? b.sliderActive = Math.min(b.sliderActive + b.cols, b.blocksOn.length - b.cols) : b.sliderActive += 1;
				b.goToSlider()
			},
			prevSlider: function(a) {
				var b = this;
				if (b.isStartSlider()) {
					if (!b.isRewindNav()) return;
					b.sliderActive = b.blocksOn.length - b.cols
				} else b.options.scrollByPage ? b.sliderActive = Math.max(0, b.sliderActive - b.cols) : b.sliderActive -= 1;
				b.goToSlider()
			},
			jumpToSlider: function(a) {
				var b = this,
					c = Math.min(a.index() * b.cols, b.blocksOn.length - b.cols);
				c !== b.sliderActive && (b.sliderActive = c, b.goToSlider())
			},
			jumpDragToSlider: function(a) {
				var b, c, d, e = this,
					f = a > 0 ? !0 : !1;
				e.options.scrollByPage ? (b = e.cols * e.columnWidth, c = e.cols) : (b = e.columnWidth, c = 1), a = Math.abs(a), d = Math.floor(a / b) * c, a % b > 20 && (d += c), f ? e.sliderActive = Math.min(e.sliderActive + d, e.blocksOn.length - e.cols) : e.sliderActive = Math.max(0, e.sliderActive - d), e.goToSlider()
			},
			isStartSlider: function() {
				return 0 === this.sliderActive
			},
			isEndSlider: function() {
				var a = this;
				return a.sliderActive + a.cols > a.blocksOn.length - 1
			},
			goToSlider: function() {
				var a = this;
				a.enableDisableNavSlider(), a.updateSliderPosition()
			},
			startSliderAuto: function() {
				var a = this;
				return a.isDrag ? void a.stopSliderAuto() : void(a.timeout = setTimeout(function() {
					a.nextSlider(), a.startSliderAuto()
				}, a.options.autoTimeout))
			},
			stopSliderAuto: function() {
				clearTimeout(this.timeout)
			},
			enableDisableNavSlider: function() {
				var a, b, c = this;
				c.isRewindNav() || (b = c.isStartSlider() ? "addClass" : "removeClass", c.navPrev[b]("cbp-nav-stop"), b = c.isEndSlider() ? "addClass" : "removeClass", c.navNext[b]("cbp-nav-stop")), c.options.showPagination && (a = c.options.scrollByPage ? Math.ceil(c.sliderActive / c.cols) : c.isEndSlider() ? c.navPaginationItems.length - 1 : Math.floor(c.sliderActive / c.cols), c.navPaginationItems.removeClass("cbp-nav-pagination-active").eq(a).addClass("cbp-nav-pagination-active")), c.customPagination && (a = c.options.scrollByPage ? Math.ceil(c.sliderActive / c.cols) : c.isEndSlider() ? c.customPaginationItems.length - 1 : Math.floor(c.sliderActive / c.cols), c.customPaginationItems.removeClass(c.customPaginationClass).eq(a).addClass(c.customPaginationClass))
			},
			isRewindNav: function() {
				var a = this;
				return a.options.showNavigation ? a.blocksOn.length <= a.cols ? !1 : a.options.rewindNav ? !0 : !1 : !0
			},
			sliderItemsLength: function() {
				return this.blocksOn.length <= this.cols
			},
			sliderLayout: function() {
				var b = this;
				b.blocksOn.each(function(c, d) {
					var e = a(d).data("cbp");
					e.leftNew = b.columnWidth * c, e.topNew = 0, b.sliderFreeSpaces.push({
						topStart: e.heightAndGap
					})
				}), b.getFreeSpacesForSlider(), b.$ul.width(b.columnWidth * b.blocksOn.length - b.options.gapVertical)
			},
			getFreeSpacesForSlider: function() {
				var a = this;
				a.freeSpaces = a.sliderFreeSpaces.slice(a.sliderActive, a.sliderActive + a.cols), a.freeSpaces.sort(function(a, b) {
					return a.topStart > b.topStart ? 1 : a.topStart < b.topStart ? -1 : void 0
				})
			},
			updateSliderPosition: function() {
				var a = this,
					b = -a.sliderActive * a.columnWidth;
				e["private"].modernBrowser ? a.$ul[0].style[e["private"].transform] = "translate3d(" + b + "px, 0px, 0)" : a.$ul[0].style.left = b + "px", a.getFreeSpacesForSlider(), a.resizeMainContainer()
			},
			dragSlider: function() {
				function f(b) {
					if (!q.sliderItemsLength()) {
						if (u ? p = b : b.preventDefault(), q.options.auto && q.stopSliderAuto(), s) return void a(m).one("click.cbp", function() {
							return !1
						});
						m = a(b.target), k = j(b).x, l = 0, n = -q.sliderActive * q.columnWidth, o = q.columnWidth * (q.blocksOn.length - q.cols), r.on(t.move, h), r.on(t.end, g), q.$obj.addClass("cbp-mode-slider-dragStart")
					}
				}

				function g(a) {
					q.$obj.removeClass("cbp-mode-slider-dragStart"), s = !0, 0 !== l ? (m.one("click.cbp", function(a) {
						return !1
					}), requestAnimationFrame(function() {
						q.jumpDragToSlider(l), q.$ul.one(e["private"].transitionend, i)
					})) : i.call(q), r.off(t.move), r.off(t.end)
				}

				function h(a) {
					l = k - j(a).x, (l > 8 || -8 > l) && a.preventDefault(), q.isDrag = !0;
					var b = n - l;
					0 > l && n > l ? b = (n - l) / 5 : l > 0 && -o > n - l && (b = -o + (o + n - l) / 5), e["private"].modernBrowser ? q.$ul[0].style[e["private"].transform] = "translate3d(" + b + "px, 0px, 0)" : q.$ul[0].style.left = b + "px"
				}

				function i() {
					if (s = !1, q.isDrag = !1, q.options.auto) {
						if (q.mouseIsEntered) return;
						q.startSliderAuto()
					}
				}

				function j(a) {
					return a.originalEvent !== d && a.originalEvent.touches !== d && (a = a.originalEvent.touches[0]), {
						x: a.pageX,
						y: a.pageY
					}
				}
				var k, l, m, n, o, p, q = this,
					r = a(c),
					s = !1,
					t = {},
					u = !1;
				q.isDrag = !1, "ontouchstart" in b || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? (t = {
					start: "touchstart.cbp",
					move: "touchmove.cbp",
					end: "touchend.cbp"
				}, u = !0) : t = {
					start: "mousedown.cbp",
					move: "mousemove.cbp",
					end: "mouseup.cbp"
				}, q.$ul.on(t.start, f)
			},
			sliderLayoutReset: function() {
				var a = this;
				a.freeSpaces = [], a.sliderFreeSpaces = []
			}
		})
	}(jQuery, window, document), "function" != typeof Object.create && (Object.create = function(a) {
		function b() {}
		return b.prototype = a, new b
	}),
	function() {
		for (var a = 0, b = ["moz", "webkit"], c = 0; c < b.length && !window.requestAnimationFrame; c++) window.requestAnimationFrame = window[b[c] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[b[c] + "CancelAnimationFrame"] || window[b[c] + "CancelRequestAnimationFrame"];
		window.requestAnimationFrame || (window.requestAnimationFrame = function(b, c) {
			var d = (new Date).getTime(),
				e = Math.max(0, 16 - (d - a)),
				f = window.setTimeout(function() {
					b(d + e)
				}, e);
			return a = d + e, f
		}), window.cancelAnimationFrame || (window.cancelAnimationFrame = function(a) {
			clearTimeout(a)
		})
	}(),
	function(a, b, c, d) {
		"use strict";

		function e(a) {
			var b = this;
			b.parent = a, a.filterLayout = b.filterLayout, a.registerEvent("computeBlocksFinish", function(b) {
				a.blocksOn2On = a.blocksOnInitial.filter(b), a.blocksOn2Off = a.blocksOnInitial.not(b)
			})
		}
		var f = a.fn.cubeportfolio.constructor;
		e.prototype.filterLayout = function() {
			function b() {
				c.blocks.removeClass("cbp-item-on2off cbp-item-off2on cbp-item-on2on").each(function(b, c) {
					var d = a(c).data("cbp");
					d.left = d.leftNew, d.top = d.topNew, c.style.left = d.left + "px", c.style.top = d.top + "px", c.style[f["private"].transform] = ""
				}), c.blocksOff.addClass("cbp-item-off"), c.$obj.removeClass("cbp-animation-" + c.options.animationType), c.filterFinish()
			}
			var c = this;
			c.$obj.addClass("cbp-animation-" + c.options.animationType), c.blocksOn2On.addClass("cbp-item-on2on").each(function(b, c) {
				var d = a(c).data("cbp");
				c.style[f["private"].transform] = "translate3d(" + (d.leftNew - d.left) + "px, " + (d.topNew - d.top) + "px, 0)"
			}), c.blocksOn2Off.addClass("cbp-item-on2off"), c.blocksOff2On = c.blocksOn.filter(".cbp-item-off").removeClass("cbp-item-off").addClass("cbp-item-off2on").each(function(b, c) {
				var d = a(c).data("cbp");
				c.style.left = d.leftNew + "px", c.style.top = d.topNew + "px"
			}), c.blocksOn2Off.length ? c.blocksOn2Off.last().data("cbp").wrapper.one(f["private"].animationend, b) : c.blocksOff2On.length ? c.blocksOff2On.last().data("cbp").wrapper.one(f["private"].animationend, b) : b(), c.resizeMainContainer()
		}, e.prototype.destroy = function() {
			var a = this.parent;
			a.$obj.removeClass("cbp-animation-" + a.options.animationType)
		}, f.plugins.animationClassic = function(b) {
			return !f["private"].modernBrowser || a.inArray(b.options.animationType, ["boxShadow", "fadeOut", "flipBottom", "flipOut", "quicksand", "scaleSides", "skew"]) < 0 ? null : new e(b)
		}
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";

		function e(a) {
			var b = this;
			b.parent = a, a.filterLayout = b.filterLayout
		}
		var f = a.fn.cubeportfolio.constructor;
		e.prototype.filterLayout = function() {
			function b() {
				c.wrapper[0].removeChild(d), "sequentially" === c.options.animationType && c.blocksOn.each(function(b, c) {
					a(c).data("cbp").wrapper[0].style[f["private"].animationDelay] = ""
				}), c.$obj.removeClass("cbp-animation-" + c.options.animationType), c.filterFinish()
			}
			var c = this,
				d = c.$ul[0].cloneNode(!0);
			d.setAttribute("class", "cbp-wrapper-helper"), c.wrapper[0].insertBefore(d, c.$ul[0]), requestAnimationFrame(function() {
				c.$obj.addClass("cbp-animation-" + c.options.animationType), c.blocksOff.addClass("cbp-item-off"), c.blocksOn.removeClass("cbp-item-off").each(function(b, d) {
					var e = a(d).data("cbp");
					e.left = e.leftNew, e.top = e.topNew, d.style.left = e.left + "px", d.style.top = e.top + "px", "sequentially" === c.options.animationType && (e.wrapper[0].style[f["private"].animationDelay] = 60 * b + "ms")
				}), c.blocksOn.length ? c.blocksOn.last().data("cbp").wrapper.one(f["private"].animationend, b) : c.blocksOnInitial.length ? c.blocksOnInitial.last().data("cbp").wrapper.one(f["private"].animationend, b) : b(), c.resizeMainContainer()
			})
		}, e.prototype.destroy = function() {
			var a = this.parent;
			a.$obj.removeClass("cbp-animation-" + a.options.animationType)
		}, f.plugins.animationClone = function(b) {
			return !f["private"].modernBrowser || a.inArray(b.options.animationType, ["fadeOutTop", "slideLeft", "sequentially"]) < 0 ? null : new e(b)
		}
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";

		function e(a) {
			var b = this;
			b.parent = a, a.filterLayout = b.filterLayout
		}
		var f = a.fn.cubeportfolio.constructor;
		e.prototype.filterLayout = function() {
			function b() {
				c.wrapper[0].removeChild(d[0]), c.$obj.removeClass("cbp-animation-" + c.options.animationType), c.blocks.each(function(b, c) {
					a(c).data("cbp").wrapper[0].style[f["private"].animationDelay] = ""
				}), c.filterFinish()
			}
			var c = this,
				d = c.$ul.clone(!0, !0);
			d[0].setAttribute("class", "cbp-wrapper-helper"), c.wrapper[0].insertBefore(d[0], c.$ul[0]);
			var e = d.find(".cbp-item").not(".cbp-item-off");
			c.sortBlocks(e, "top"), e.children(".cbp-item-wrapper").each(function(a, b) {
				b.style[f["private"].animationDelay] = 50 * a + "ms"
			}), requestAnimationFrame(function() {
				c.$obj.addClass("cbp-animation-" + c.options.animationType), c.blocksOff.addClass("cbp-item-off"), c.blocksOn.removeClass("cbp-item-off").each(function(b, c) {
					var d = a(c).data("cbp");
					d.left = d.leftNew, d.top = d.topNew, c.style.left = d.left + "px", c.style.top = d.top + "px", d.wrapper[0].style[f["private"].animationDelay] = 50 * b + "ms"
				});
				var d = c.blocksOn.length,
					g = e.length;
				0 === d && 0 === g ? b() : g > d ? e.last().children(".cbp-item-wrapper").one(f["private"].animationend, b) : c.blocksOn.last().data("cbp").wrapper.one(f["private"].animationend, b), c.resizeMainContainer()
			})
		}, e.prototype.destroy = function() {
			var a = this.parent;
			a.$obj.removeClass("cbp-animation-" + a.options.animationType)
		}, f.plugins.animationCloneDelay = function(b) {
			return !f["private"].modernBrowser || a.inArray(b.options.animationType, ["3dflip", "flipOutDelay", "foldLeft", "frontRow", "rotateRoom", "rotateSides", "scaleDown", "slideDelay", "unfold"]) < 0 ? null : new e(b)
		}
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";

		function e(a) {
			var b = this;
			b.parent = a, a.filterLayout = b.filterLayout
		}
		var f = a.fn.cubeportfolio.constructor;
		e.prototype.filterLayout = function() {
			function b() {
				c.wrapper[0].removeChild(d), c.$obj.removeClass("cbp-animation-" + c.options.animationType), c.filterFinish()
			}
			var c = this,
				d = c.$ul[0].cloneNode(!0);
			d.setAttribute("class", "cbp-wrapper-helper"), c.wrapper[0].insertBefore(d, c.$ul[0]), requestAnimationFrame(function() {
				c.$obj.addClass("cbp-animation-" + c.options.animationType), c.blocksOff.addClass("cbp-item-off"), c.blocksOn.removeClass("cbp-item-off").each(function(b, c) {
					var d = a(c).data("cbp");
					d.left = d.leftNew, d.top = d.topNew, c.style.left = d.left + "px", c.style.top = d.top + "px"
				}), c.blocksOn.length ? c.$ul.one(f["private"].animationend, b) : c.blocksOnInitial.length ? a(d).one(f["private"].animationend, b) : b(), c.resizeMainContainer()
			})
		}, e.prototype.destroy = function() {
			var a = this.parent;
			a.$obj.removeClass("cbp-animation-" + a.options.animationType)
		}, f.plugins.animationWrapper = function(b) {
			return !f["private"].modernBrowser || a.inArray(b.options.animationType, ["bounceBottom", "bounceLeft", "bounceTop", "moveLeft"]) < 0 ? null : new e(b)
		}
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";

		function e(b) {
			var c = this;
			c.parent = b, b.registerEvent("initFinish", function() {
				b.$obj.on("click.cbp", ".cbp-caption-defaultWrap", function(c) {
					if (c.preventDefault(), !b.isAnimating) {
						b.isAnimating = !0;
						var d = a(this),
							e = d.next(),
							f = d.parent(),
							g = {
								position: "relative",
								height: e.outerHeight(!0)
							},
							h = {
								position: "relative",
								height: 0
							};
						if (b.$obj.addClass("cbp-caption-expand-active"), f.hasClass("cbp-caption-expand-open")) {
							var i = h;
							h = g, g = i, f.removeClass("cbp-caption-expand-open")
						}
						e.css(g), b.$obj.one("pluginResize.cbp", function() {
							b.isAnimating = !1, b.$obj.removeClass("cbp-caption-expand-active"), 0 === g.height && (f.removeClass("cbp-caption-expand-open"), e.attr("style", ""))
						}), b.layoutAndAdjustment(), e.css(h), requestAnimationFrame(function() {
							f.addClass("cbp-caption-expand-open"), e.css(g), b.triggerEvent("gridAdjust"), b.triggerEvent("resizeGrid")
						})
					}
				})
			}, !0)
		}
		var f = a.fn.cubeportfolio.constructor;
		e.prototype.destroy = function() {
			this.parent.$obj.find(".cbp-caption-defaultWrap").off("click.cbp").parent().removeClass("cbp-caption-expand-active");
		}, f.plugins.captionExpand = function(a) {
			return "expand" !== a.options.caption ? null : new e(a)
		}
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";

		function e(b) {
			var c = a.Deferred();
			b.pushQueue("delayFrame", c), b.registerEvent("initEndWrite", function() {
				b.blocksOn.each(function(a, c) {
					c.style[f["private"].animationDelay] = a * b.options.displayTypeSpeed + "ms"
				}), b.$obj.addClass("cbp-displayType-bottomToTop"), b.blocksOn.last().one(f["private"].animationend, function() {
					b.$obj.removeClass("cbp-displayType-bottomToTop"), b.blocksOn.each(function(a, b) {
						b.style[f["private"].animationDelay] = ""
					}), c.resolve()
				})
			}, !0)
		}
		var f = a.fn.cubeportfolio.constructor;
		f.plugins.displayBottomToTop = function(a) {
			return f["private"].modernBrowser && "bottomToTop" === a.options.displayType && 0 !== a.blocksOn.length ? new e(a) : null
		}
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";

		function e(b) {
			var c = a.Deferred();
			b.pushQueue("delayFrame", c), b.registerEvent("initEndWrite", function() {
				b.obj.style[f["private"].animationDuration] = b.options.displayTypeSpeed + "ms", b.$obj.addClass("cbp-displayType-fadeIn"), b.$obj.one(f["private"].animationend, function() {
					b.$obj.removeClass("cbp-displayType-fadeIn"), b.obj.style[f["private"].animationDuration] = "", c.resolve()
				})
			}, !0)
		}
		var f = a.fn.cubeportfolio.constructor;
		f.plugins.displayFadeIn = function(a) {
			return !f["private"].modernBrowser || "lazyLoading" !== a.options.displayType && "fadeIn" !== a.options.displayType || 0 === a.blocksOn.length ? null : new e(a)
		}
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";

		function e(b) {
			var c = a.Deferred();
			b.pushQueue("delayFrame", c), b.registerEvent("initEndWrite", function() {
				b.obj.style[f["private"].animationDuration] = b.options.displayTypeSpeed + "ms", b.$obj.addClass("cbp-displayType-fadeInToTop"), b.$obj.one(f["private"].animationend, function() {
					b.$obj.removeClass("cbp-displayType-fadeInToTop"), b.obj.style[f["private"].animationDuration] = "", c.resolve()
				})
			}, !0)
		}
		var f = a.fn.cubeportfolio.constructor;
		f.plugins.displayFadeInToTop = function(a) {
			return f["private"].modernBrowser && "fadeInToTop" === a.options.displayType && 0 !== a.blocksOn.length ? new e(a) : null
		}
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";

		function e(b) {
			var c = a.Deferred();
			b.pushQueue("delayFrame", c), b.registerEvent("initEndWrite", function() {
				b.blocksOn.each(function(a, c) {
					c.style[f["private"].animationDelay] = a * b.options.displayTypeSpeed + "ms"
				}), b.$obj.addClass("cbp-displayType-sequentially"), b.blocksOn.last().one(f["private"].animationend, function() {
					b.$obj.removeClass("cbp-displayType-sequentially"), b.blocksOn.each(function(a, b) {
						b.style[f["private"].animationDelay] = ""
					}), c.resolve()
				})
			}, !0)
		}
		var f = a.fn.cubeportfolio.constructor;
		f.plugins.displaySequentially = function(a) {
			return f["private"].modernBrowser && "sequentially" === a.options.displayType && 0 !== a.blocksOn.length ? new e(a) : null
		}
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";

		function e(b) {
			var c = this;
			c.parent = b, c.filters = a(b.options.filters), c.filterData = [], b.registerEvent("afterPlugins", function(a) {
				c.filterFromUrl(), c.registerFilter()
			})
		}
		var f = a.fn.cubeportfolio.constructor;
		e.prototype.registerFilter = function() {
			var b = this,
				c = b.parent,
				d = c.defaultFilter.split("|");
			b.wrap = b.filters.find(".cbp-l-filters-dropdownWrap").on({
				"mouseover.cbp": function() {
					a(this).addClass("cbp-l-filters-dropdownWrap-open")
				},
				"mouseleave.cbp": function() {
					a(this).removeClass("cbp-l-filters-dropdownWrap-open")
				}
			}), b.filters.each(function(e, f) {
				var g = a(f),
					h = "*",
					i = g.find(".cbp-filter-item"),
					j = {};
				g.hasClass("cbp-l-filters-dropdown") && (j.wrap = g.find(".cbp-l-filters-dropdownWrap"), j.header = g.find(".cbp-l-filters-dropdownHeader"), j.headerText = j.header.text()), c.$obj.cubeportfolio("showCounter", i), a.each(d, function(a, b) {
					return i.filter('[data-filter="' + b + '"]').length ? (h = b, d.splice(a, 1), !1) : void 0
				}), a.data(f, "filterName", h), b.filterData.push(f), b.filtersCallback(j, i.filter('[data-filter="' + h + '"]')), i.on("click.cbp", function() {
					var d = a(this);
					if (!d.hasClass("cbp-filter-item-active") && !c.isAnimating) {
						b.filtersCallback(j, d), a.data(f, "filterName", d.data("filter"));
						var e = a.map(b.filterData, function(b, c) {
							var d = a.data(b, "filterName");
							return "" !== d && "*" !== d ? d : null
						});
						e.length < 1 && (e = ["*"]);
						var g = e.join("|");
						c.defaultFilter !== g && c.$obj.cubeportfolio("filter", g)
					}
				})
			})
		}, e.prototype.filtersCallback = function(b, c) {
			a.isEmptyObject(b) || (b.wrap.trigger("mouseleave.cbp"), b.headerText ? b.headerText = "" : b.header.html(c.html())), c.addClass("cbp-filter-item-active").siblings().removeClass("cbp-filter-item-active")
		}, e.prototype.filterFromUrl = function() {
			var a = /#cbpf=(.*?)([#\?&]|$)/gi.exec(location.href);
			null !== a && (this.parent.defaultFilter = decodeURIComponent(a[1]))
		}, e.prototype.destroy = function() {
			var a = this;
			a.filters.find(".cbp-filter-item").off(".cbp"), a.wrap.off(".cbp")
		}, f.plugins.filters = function(a) {
			return "" === a.options.filters ? null : new e(a)
		}
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";

		function e(b) {
			var c = this;
			c.parent = b, c.options = a.extend({}, g, c.parent.options.plugins.inlineSlider), c.runInit(), b.registerEvent("addItemsToDOM", function() {
				c.runInit()
			})
		}

		function f(a) {
			var b = this;
			a.hasClass("cbp-slider-inline-ready") || (a.addClass("cbp-slider-inline-ready"), b.items = a.find(".cbp-slider-wrapper").children(".cbp-slider-item"), b.active = b.items.filter(".cbp-slider-item--active").index(), b.total = b.items.length - 1, b.updateLeft(), a.find(".cbp-slider-next").on("click.cbp", function(a) {
				a.preventDefault(), b.active < b.total ? (b.active++, b.updateLeft()) : b.active === b.total && (b.active = 0, b.updateLeft())
			}), a.find(".cbp-slider-prev").on("click.cbp", function(a) {
				a.preventDefault(), b.active > 0 ? (b.active--, b.updateLeft()) : 0 === b.active && (b.active = b.total, b.updateLeft())
			}))
		}
		var g = {},
			h = a.fn.cubeportfolio.constructor;
		f.prototype.updateLeft = function() {
			var a = this;
			a.items.removeClass("cbp-slider-item--active"), a.items.eq(a.active).addClass("cbp-slider-item--active"), a.items.each(function(b, c) {
				c.style.left = b - a.active + "00%"
			})
		}, e.prototype.runInit = function() {
			var b = this;
			b.parent.$obj.find(".cbp-slider-inline").not(".cbp-slider-inline-ready").each(function(c, d) {
				var e = a(d),
					g = e.find(".cbp-slider-item--active").find("img")[0];
				g.hasAttribute("data-cbp-src") ? b.parent.$obj.on("lazyLoad.cbp", function(a, b) {
					b.src === g.src && new f(e)
				}) : new f(e)
			})
		}, e.prototype.destroy = function() {
			var b = this;
			b.parent.$obj.find(".cbp-slider-next").off("click.cbp"), b.parent.$obj.find(".cbp-slider-prev").off("click.cbp"), b.parent.$obj.off("lazyLoad.cbp"), b.parent.$obj.find(".cbp-slider-inline").each(function(b, c) {
				var d = a(c);
				d.removeClass("cbp-slider-inline-ready");
				var e = d.find(".cbp-slider-item");
				e.removeClass("cbp-slider-item--active"), e.removeAttr("style"), e.eq(0).addClass("cbp-slider-item--active")
			})
		}, h.plugins.inlineSlider = function(a) {
			return new e(a)
		}
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";

		function e(c) {
			var d = this;
			d.window = a(b), d.parent = c, d.options = a.extend({}, f, d.parent.options.plugins.lazyLoad), c.registerEvent("initEndWrite", function() {
				var a;
				d.triggerImg(), c.registerEvent("resizeMainContainer", function() {
					d.triggerImg()
				}), d.window.on("scroll.cbp", function() {
					clearTimeout(a), a = setTimeout(function() {
						d.triggerImg()
					}, 300)
				})
			}, !0)
		}
		var f = {
				loadingClass: "cbp-lazyload",
				threshold: 0
			},
			g = a.fn.cubeportfolio.constructor;
		e.prototype.triggerImg = function() {
			var b = this,
				c = b.parent.$obj.find("img").filter("[data-cbp-src]");
			0 !== c.length && (b.screenHeight = b.window.height(), c.each(function(c, d) {
				var e = a(d.parentNode);
				if (!b.isElementInScreen(d)) return void e.addClass(b.options.loadingClass);
				var f = d.getAttribute("data-cbp-src");
				null === b.parent.checkSrc(f) ? (b.removeLazy(d, f), e.removeClass(b.options.loadingClass)) : (e.addClass(b.options.loadingClass), a("<img>").on("load.cbp error.cbp", function() {
					b.removeLazy(d, f, e)
				}).attr("src", f))
			}))
		}, e.prototype.removeLazy = function(b, c, d) {
			var e = this;
			b.src = c, b.removeAttribute("data-cbp-src"), e.parent.removeAttrImage(b), e.parent.$obj.trigger("lazyLoad.cbp", b), d && (g["private"].modernBrowser ? a(b).one(g["private"].transitionend, function() {
				d.removeClass(e.options.loadingClass)
			}) : d.removeClass(e.options.loadingClass))
		}, e.prototype.isElementInScreen = function(a) {
			var b = this,
				c = a.getBoundingClientRect(),
				d = c.bottom + b.options.threshold,
				e = b.screenHeight + d - (c.top - b.options.threshold);
			return d >= 0 && e >= d
		}, e.prototype.destroy = function() {
			var a = this;
			a.window.off("scroll.cbp")
		}, g.plugins.lazyLoad = function(a) {
			return new e(a)
		}
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";

		function e(b) {
			var c = this;
			c.parent = b, c.loadMore = a(b.options.loadMore).find(".cbp-l-loadMore-link"), c.loadMore.length && c[b.options.loadMoreAction]()
		}
		var f = a.fn.cubeportfolio.constructor;
		e.prototype.click = function() {
			var b = this,
				c = 0;
			b.loadMore.on("click.cbp", function(d) {
				var e = a(this);
				d.preventDefault(), b.parent.isAnimating || e.hasClass("cbp-l-loadMore-stop") || (e.addClass("cbp-l-loadMore-loading"), c++, a.ajax({
					url: b.loadMore.attr("href") + "?block=" + c,
					type: "GET",
					dataType: "HTML"
				}).done(function(a) {
					var d = a.replace(/(\r\n|\n|\r)/gm, ""),
						f = d.indexOf("cbp-loadMore-block" + c);
					if (-1 === f) return void e.addClass("cbp-l-loadMore-stop");
					var g, h = d.indexOf(">", f) + 1,
						i = d.indexOf("cbp-loadMore-block" + (c + 1));
					g = -1 === i ? d.lastIndexOf("</") : d.lastIndexOf("</", i), b.parent.$obj.cubeportfolio("appendItems", d.substring(h, g), function() {
						e.removeClass("cbp-l-loadMore-loading"), -1 === i && e.addClass("cbp-l-loadMore-stop")
					})
				}).fail(function() {}))
			})
		}, e.prototype.auto = function() {
			var c = this;
			c.parent.$obj.on("initComplete.cbp", function() {
				Object.create({
					init: function() {
						var d = this;
						d.isActive = !1, d.numberOfClicks = 0, c.loadMore.addClass("cbp-l-loadMore-loading"), d.window = a(b), d.addEvents(), d.getNewItems()
					},
					addEvents: function() {
						var a, b = this;
						c.loadMore.on("click.cbp", function(a) {
							a.preventDefault()
						}), b.window.on("scroll.loadMoreObject", function() {
							clearTimeout(a), a = setTimeout(function() {
								c.parent.isAnimating || b.getNewItems()
							}, 80)
						}), c.parent.$obj.on("filterComplete.cbp", function() {
							b.getNewItems()
						})
					},
					getNewItems: function() {
						var b, d, e = this;
						e.isActive || c.loadMore.hasClass("cbp-l-loadMore-stop") || (b = c.loadMore.offset().top - 200, d = e.window.scrollTop() + e.window.height(), b > d || (e.isActive = !0, e.numberOfClicks++, a.ajax({
							url: c.loadMore.attr("href") + "?block=" + e.numberOfClicks,
							type: "GET",
							dataType: "HTML",
							cache: !0
						}).done(function(a) {
							var b = a.replace(/(\r\n|\n|\r)/gm, ""),
								d = b.indexOf("cbp-loadMore-block" + e.numberOfClicks);
							if (-1 === d) return void c.loadMore.addClass("cbp-l-loadMore-stop");
							var f, g = b.indexOf(">", d) + 1,
								h = b.indexOf("cbp-loadMore-block" + (e.numberOfClicks + 1));
							f = -1 === h ? b.lastIndexOf("</") : b.lastIndexOf("</", h), c.parent.$obj.cubeportfolio("appendItems", b.substring(g, f), function() {
								-1 === h ? (c.loadMore.addClass("cbp-l-loadMore-stop"), e.window.off("scroll.loadMoreObject"), c.parent.$obj.off("filterComplete.cbp")) : (e.isActive = !1, e.window.trigger("scroll.loadMoreObject"))
							})
						}).fail(function() {
							e.isActive = !1
						})))
					}
				}).init()
			})
		}, e.prototype.destroy = function() {
			var c = this;
			c.loadMore.off(".cbp"), a(b).off("scroll.loadMoreObject")
		}, f.plugins.loadMore = function(a) {
			return "" === a.options.loadMore ? null : new e(a)
		}
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";

		function e(a) {
			var b = this;
			b.parent = a, a.options.lightboxShowCounter === !1 && (a.options.lightboxCounter = ""), a.options.singlePageShowCounter === !1 && (a.options.singlePageCounter = ""), a.registerEvent("initStartRead", function() {
				b.run()
			}, !0)
		}
		var f = a.fn.cubeportfolio.constructor,
			g = {
				init: function(b, d) {
					var e, f = this;
					if (f.cubeportfolio = b, f.type = d, f.isOpen = !1, f.options = f.cubeportfolio.options, "lightbox" === d && f.cubeportfolio.registerEvent("resizeWindow", function() {
							f.resizeImage()
						}), "singlePageInline" !== d) {
						if (f.createMarkup(), "singlePage" === d && (f.cubeportfolio.registerEvent("resizeWindow", function() {
								if (f.options.singlePageStickyNavigation) {
									var a = f.wrap[0].clientWidth;
									a > 0 && (f.navigationWrap.width(a), f.navigation.width(a))
								}
							}), f.options.singlePageDeeplinking)) {
							f.url = location.href, "#" === f.url.slice(-1) && (f.url = f.url.slice(0, -1));
							var g = f.url.split("#cbp="),
								h = g.shift();
							if (a.each(g, function(b, c) {
									return f.cubeportfolio.blocksOn.each(function(b, d) {
										var g = a(d).find(f.options.singlePageDelegate + '[href="' + c + '"]');
										return g.length ? (e = g, !1) : void 0
									}), e ? !1 : void 0
								}), e) {
								f.url = h;
								var i = e,
									j = i.attr("data-cbp-singlePage"),
									k = [];
								j ? k = i.closest(a(".cbp-item")).find('[data-cbp-singlePage="' + j + '"]') : f.cubeportfolio.blocksOn.each(function(b, c) {
									var d = a(c);
									d.not(".cbp-item-off") && d.find(f.options.singlePageDelegate).each(function(b, c) {
										a(c).attr("data-cbp-singlePage") || k.push(c)
									})
								}), f.openSinglePage(k, e[0])
							} else if (g.length) {
								var l = c.createElement("a");
								l.setAttribute("href", g[0]), f.openSinglePage([l], l)
							}
						}
					} else if (f.height = 0, f.createMarkupSinglePageInline(), f.cubeportfolio.registerEvent("resizeGrid", function() {
							f.isOpen && f.close()
						}), f.options.singlePageInlineDeeplinking) {
						f.url = location.href, "#" === f.url.slice(-1) && (f.url = f.url.slice(0, -1));
						var g = f.url.split("#cbpi="),
							h = g.shift();
						a.each(g, function(b, c) {
							return f.cubeportfolio.blocksOn.each(function(b, d) {
								var g = a(d).find(f.options.singlePageInlineDelegate + '[href="' + c + '"]');
								return g.length ? (e = g, !1) : void 0
							}), e ? !1 : void 0
						}), e && f.cubeportfolio.registerEvent("initFinish", function() {
							f.openSinglePageInline(f.cubeportfolio.blocksOn, e[0])
						}, !0)
					}
				},
				createMarkup: function() {
					var b = this,
						d = "";
					"singlePage" === b.type && "left" !== b.options.singlePageAnimation && (d = " cbp-popup-singlePage-" + b.options.singlePageAnimation), b.wrap = a("<div/>", {
						"class": "cbp-popup-wrap cbp-popup-" + b.type + d,
						"data-action": "lightbox" === b.type ? "close" : ""
					}).on("click.cbp", function(c) {
						if (!b.stopEvents) {
							var d = a(c.target).attr("data-action");
							b[d] && (b[d](), c.preventDefault())
						}
					}), b.content = a("<div/>", {
						"class": "cbp-popup-content"
					}).appendTo(b.wrap), a("<div/>", {
						"class": "cbp-popup-loadingBox"
					}).appendTo(b.wrap), "ie8" === f["private"].browser && (b.bg = a("<div/>", {
						"class": "cbp-popup-ie8bg",
						"data-action": "lightbox" === b.type ? "close" : ""
					}).appendTo(b.wrap)), b.navigationWrap = a("<div/>", {
						"class": "cbp-popup-navigation-wrap"
					}).appendTo(b.wrap), b.navigation = a("<div/>", {
						"class": "cbp-popup-navigation"
					}).appendTo(b.navigationWrap), b.closeButton = a("<div/>", {
						"class": "cbp-popup-close",
						title: "Close (Esc arrow key)",
						"data-action": "close"
					}).appendTo(b.navigation), b.nextButton = a("<div/>", {
						"class": "cbp-popup-next",
						title: "Next (Right arrow key)",
						"data-action": "next"
					}).appendTo(b.navigation), b.prevButton = a("<div/>", {
						"class": "cbp-popup-prev",
						title: "Previous (Left arrow key)",
						"data-action": "prev"
					}).appendTo(b.navigation), "singlePage" === b.type && (b.options.singlePageCounter && (b.counter = a(b.options.singlePageCounter).appendTo(b.navigation), b.counter.text("")), b.content.on("click.cbp", b.options.singlePageDelegate, function(a) {
						a.preventDefault();
						var c, d = b.dataArray.length,
							e = this.getAttribute("href");
						for (c = 0; d > c && b.dataArray[c].url !== e; c++);
						b.singlePageJumpTo(c - b.current)
					}), b.wrap.on("mousewheel.cbp DOMMouseScroll.cbp", function(a) {
						a.stopImmediatePropagation()
					})), a(c).on("keydown.cbp", function(a) {
						b.isOpen && (b.stopEvents || (37 === a.keyCode ? b.prev() : 39 === a.keyCode ? b.next() : 27 === a.keyCode && b.close()))
					})
				},
				createMarkupSinglePageInline: function() {
					var b = this;
					b.wrap = a("<div/>", {
						"class": "cbp-popup-singlePageInline"
					}).on("click.cbp", function(c) {
						if (!b.stopEvents) {
							var d = a(c.target).attr("data-action");
							d && b[d] && (b[d](), c.preventDefault())
						}
					}), b.content = a("<div/>", {
						"class": "cbp-popup-content"
					}).appendTo(b.wrap), b.navigation = a("<div/>", {
						"class": "cbp-popup-navigation"
					}).appendTo(b.wrap), b.closeButton = a("<div/>", {
						"class": "cbp-popup-close",
						title: "Close (Esc arrow key)",
						"data-action": "close"
					}).appendTo(b.navigation)
				},
				destroy: function() {
					var b = this,
						d = a("body");
					a(c).off("keydown.cbp"), d.off("click.cbp", b.options.lightboxDelegate), d.off("click.cbp", b.options.singlePageDelegate), b.content.off("click.cbp", b.options.singlePageDelegate), b.cubeportfolio.$obj.off("click.cbp", b.options.singlePageInlineDelegate), b.cubeportfolio.$obj.off("click.cbp", b.options.lightboxDelegate), b.cubeportfolio.$obj.off("click.cbp", b.options.singlePageDelegate), b.cubeportfolio.$obj.removeClass("cbp-popup-isOpening"), b.cubeportfolio.$obj.find(".cbp-item").removeClass("cbp-singlePageInline-active"), b.wrap.remove()
				},
				openLightbox: function(d, e) {
					var f, g, h = this,
						i = 0,
						j = [];
					if (!h.isOpen) {
						if (h.isOpen = !0, h.stopEvents = !1, h.dataArray = [], h.current = null, f = e.getAttribute("href"), null === f) throw new Error("HEI! Your clicked element doesn't have a href attribute.");
						a.each(d, function(b, c) {
							var d, e = c.getAttribute("href"),
								g = e,
								k = "isImage";
							if (-1 === a.inArray(e, j)) {
								if (f === e) h.current = i;
								else if (!h.options.lightboxGallery) return;
								/youtube/i.test(e) ? (d = e.substring(e.lastIndexOf("v=") + 2), /autoplay=/i.test(d) || (d += "&autoplay=1"), d = d.replace(/\?|&/, "?"), g = "//www.youtube.com/embed/" + d, k = "isYoutube") : /vimeo\.com/i.test(e) ? (d = e.substring(e.lastIndexOf("/") + 1), /autoplay=/i.test(d) || (d += "&autoplay=1"), d = d.replace(/\?|&/, "?"), g = "//player.vimeo.com/video/" + d, k = "isVimeo") : /www\.ted\.com/i.test(e) ? (g = "http://embed.ted.com/talks/" + e.substring(e.lastIndexOf("/") + 1) + ".html", k = "isTed") : /soundcloud\.com/i.test(e) ? (g = e, k = "isSoundCloud") : /(\.mp4)|(\.ogg)|(\.ogv)|(\.webm)/i.test(e) ? (g = -1 !== e.indexOf("|") ? e.split("|") : e.split("%7C"), k = "isSelfHostedVideo") : /\.mp3$/i.test(e) && (g = e, k = "isSelfHostedAudio"), h.dataArray.push({
									src: g,
									title: c.getAttribute(h.options.lightboxTitleSrc),
									type: k
								}), i++
							}
							j.push(e)
						}), h.counterTotal = h.dataArray.length, 1 === h.counterTotal ? (h.nextButton.hide(), h.prevButton.hide(), h.dataActionImg = "") : (h.nextButton.show(), h.prevButton.show(), h.dataActionImg = 'data-action="next"'), h.wrap.appendTo(c.body), h.scrollTop = a(b).scrollTop(), h.originalStyle = a("html").attr("style"), a("html").css({
							overflow: "hidden",
							marginRight: b.innerWidth - a(c).width()
						}), h.wrap.addClass("cbp-popup-transitionend"), h.wrap.show(), g = h.dataArray[h.current], h[g.type](g)
					}
				},
				openSinglePage: function(d, e) {
					var g, h = this,
						i = 0,
						j = [];
					if (!h.isOpen) {
						if (h.cubeportfolio.singlePageInline && h.cubeportfolio.singlePageInline.isOpen && h.cubeportfolio.singlePageInline.close(), h.isOpen = !0, h.stopEvents = !1, h.dataArray = [], h.current = null, g = e.getAttribute("href"), null === g) throw new Error("HEI! Your clicked element doesn't have a href attribute.");
						a.each(d, function(b, c) {
							var d = c.getAttribute("href"); - 1 === a.inArray(d, j) && (g === d && (h.current = i), h.dataArray.push({
								url: d,
								element: c
							}), i++), j.push(d)
						}), h.counterTotal = h.dataArray.length, 1 === h.counterTotal ? (h.nextButton.hide(), h.prevButton.hide()) : (h.nextButton.show(), h.prevButton.show()), h.wrap.appendTo(c.body), h.scrollTop = a(b).scrollTop(), h.wrap.scrollTop(0), h.wrap.show(), h.finishOpen = 2, h.navigationMobile = a(), h.wrap.one(f["private"].transitionend, function() {
							a("html").css({
								overflow: "hidden",
								marginRight: b.innerWidth - a(c).width()
							}), h.wrap.addClass("cbp-popup-transitionend"), h.options.singlePageStickyNavigation && (h.wrap.addClass("cbp-popup-singlePage-sticky"), h.navigationWrap.width(h.wrap[0].clientWidth), ("android" === f["private"].browser || "ios" === f["private"].browser) && (h.navigationMobile = a("<div/>", {
								"class": "cbp-popup-singlePage cbp-popup-singlePage-sticky",
								id: h.wrap.attr("id")
							}).on("click.cbp", function(b) {
								if (!h.stopEvents) {
									var c = a(b.target).attr("data-action");
									h[c] && (h[c](), b.preventDefault())
								}
							}), h.navigationMobile.appendTo(c.body).append(h.navigationWrap))), h.finishOpen--, h.finishOpen <= 0 && h.updateSinglePageIsOpen.call(h)
						}), ("ie8" === f["private"].browser || "ie9" === f["private"].browser) && (h.options.singlePageStickyNavigation && (h.navigationWrap.width(h.wrap[0].clientWidth), setTimeout(function() {
							h.wrap.addClass("cbp-popup-singlePage-sticky")
						}, 1e3)), h.finishOpen--), h.wrap.addClass("cbp-popup-loading"), h.wrap.offset(), h.wrap.addClass("cbp-popup-singlePage-open"), h.options.singlePageDeeplinking && (h.url = h.url.split("#cbp=")[0], location.href = h.url + "#cbp=" + h.dataArray[h.current].url), a.isFunction(h.options.singlePageCallback) && h.options.singlePageCallback.call(h, h.dataArray[h.current].url, h.dataArray[h.current].element)
					}
				},
				openSinglePageInline: function(c, d, e) {
					var f, g, h, i, j = this;
					if (e = e || !1, j.fromOpen = e, j.storeBlocks = c, j.storeCurrentBlock = d, j.isOpen) return g = a(d).closest(".cbp-item").index(), void(j.dataArray[j.current].url !== d.getAttribute("href") || j.current !== g ? j.cubeportfolio.singlePageInline.close("open", {
						blocks: c,
						currentBlock: d,
						fromOpen: !0
					}) : j.close());
					if (j.isOpen = !0, j.stopEvents = !1, j.dataArray = [], j.current = null, f = d.getAttribute("href"), null === f) throw new Error("HEI! Your clicked element doesn't have a href attribute.");
					if (h = a(d).closest(".cbp-item")[0], c.each(function(a, b) {
							h === b && (j.current = a)
						}), j.dataArray[j.current] = {
							url: f,
							element: d
						}, i = a(j.dataArray[j.current].element).parents(".cbp-item").addClass("cbp-singlePageInline-active"), j.counterTotal = c.length, j.wrap.insertBefore(j.cubeportfolio.wrapper), "top" === j.options.singlePageInlinePosition) j.blocksToMove = c, j.top = 0;
					else if ("bottom" === j.options.singlePageInlinePosition) j.blocksToMove = a(), j.top = j.cubeportfolio.height;
					else if ("above" === j.options.singlePageInlinePosition) j.top = a(c[j.current]).data("cbp").top, j.blocksToMove = a(), c.each(function(b, c) {
						var d = a(c).data("cbp");
						d.top + d.height >= j.top && (j.blocksToMove = j.blocksToMove.add(c))
					}), j.top = Math.max(j.top - j.options.gapHorizontal, 0);
					else {
						var k = a(c[j.current]).data("cbp");
						j.top = k.top + k.height, j.blocksToMove = a(), c.each(function(b, c) {
							var d = a(c).data("cbp");
							d.top + d.height > j.top && (j.blocksToMove = j.blocksToMove.add(c))
						})
					}
					if (j.wrap[0].style.height = j.wrap.outerHeight(!0) + "px", j.deferredInline = a.Deferred(), j.options.singlePageInlineInFocus) {
						j.scrollTop = a(b).scrollTop();
						var l = j.cubeportfolio.$obj.offset().top + j.top - 100;
						j.scrollTop !== l ? a("html,body").animate({
							scrollTop: l
						}, 350).promise().then(function() {
							j.resizeSinglePageInline(), j.deferredInline.resolve()
						}) : (j.resizeSinglePageInline(), j.deferredInline.resolve())
					} else j.resizeSinglePageInline(), j.deferredInline.resolve();
					j.cubeportfolio.$obj.addClass("cbp-popup-singlePageInline-open"), j.wrap.css({
						top: j.top
					}), j.options.singlePageInlineDeeplinking && (j.url = j.url.split("#cbpi=")[0], location.href = j.url + "#cbpi=" + j.dataArray[j.current].url), a.isFunction(j.options.singlePageInlineCallback) && j.options.singlePageInlineCallback.call(j, j.dataArray[j.current].url, j.dataArray[j.current].element)
				},
				resizeSinglePageInline: function() {
					var a = this;
					a.height = 0 === a.top || a.top === a.cubeportfolio.height ? a.wrap.outerHeight(!0) : a.wrap.outerHeight(!0) - a.options.gapHorizontal, a.storeBlocks.each(function(a, b) {
						f["private"].modernBrowser ? b.style[f["private"].transform] = "" : b.style.marginTop = ""
					}), a.blocksToMove.each(function(b, c) {
						f["private"].modernBrowser ? c.style[f["private"].transform] = "translate3d(0px, " + a.height + "px, 0)" : c.style.marginTop = a.height + "px"
					}), a.cubeportfolio.obj.style.height = a.cubeportfolio.height + a.height + "px"
				},
				revertResizeSinglePageInline: function() {
					var b = this;
					b.deferredInline = a.Deferred(), b.storeBlocks.each(function(a, b) {
						f["private"].modernBrowser ? b.style[f["private"].transform] = "" : b.style.marginTop = ""
					}), b.cubeportfolio.obj.style.height = b.cubeportfolio.height + "px"
				},
				appendScriptsToWrap: function(a) {
					var b = this,
						d = 0,
						e = function(f) {
							var g = c.createElement("script"),
								h = f.src;
							g.type = "text/javascript", g.readyState ? g.onreadystatechange = function() {
								("loaded" == g.readyState || "complete" == g.readyState) && (g.onreadystatechange = null, d++, a[d] && e(a[d]))
							} : g.onload = function() {
								d++, a[d] && e(a[d])
							}, h ? g.src = h : g.text = f.text, b.content[0].appendChild(g)
						};
					e(a[0])
				},
				updateSinglePage: function(b, c, d) {
					var e, f = this;
					f.content.addClass("cbp-popup-content").removeClass("cbp-popup-content-basic"), d === !1 && f.content.removeClass("cbp-popup-content").addClass("cbp-popup-content-basic"), f.counter && (e = a(f.getCounterMarkup(f.options.singlePageCounter, f.current + 1, f.counterTotal)), f.counter.text(e.text())), f.fromAJAX = {
						html: b,
						scripts: c
					}, f.finishOpen--, f.finishOpen <= 0 && f.updateSinglePageIsOpen.call(f)
				},
				updateSinglePageIsOpen: function() {
					var b, c = this;
					c.wrap.addClass("cbp-popup-ready"), c.wrap.removeClass("cbp-popup-loading"), c.content.html(c.fromAJAX.html), c.fromAJAX.scripts && c.appendScriptsToWrap(c.fromAJAX.scripts), c.fromAJAX = {}, c.cubeportfolio.$obj.trigger("updateSinglePageStart.cbp"), b = c.content.find(".cbp-slider"), b ? (b.find(".cbp-slider-item").addClass("cbp-item"), c.slider = b.cubeportfolio({
						layoutMode: "slider",
						mediaQueries: [{
							width: 1,
							cols: 1
						}],
						gapHorizontal: 0,
						gapVertical: 0,
						caption: "",
						coverRatio: ""
					})) : c.slider = null, c.checkForSocialLinks(c.content), ("android" === f["private"].browser || "ios" === f["private"].browser) && a("html").css({
						position: "fixed"
					}), c.cubeportfolio.$obj.trigger("updateSinglePageComplete.cbp")
				},
				checkForSocialLinks: function(a) {
					var b = this;
					b.createFacebookShare(a.find(".cbp-social-fb")), b.createTwitterShare(a.find(".cbp-social-twitter")), b.createGooglePlusShare(a.find(".cbp-social-googleplus")), b.createPinterestShare(a.find(".cbp-social-pinterest"))
				},
				createFacebookShare: function(a) {
					a.length && !a.attr("onclick") && a.attr("onclick", "window.open('http://www.facebook.com/sharer.php?u=" + encodeURIComponent(b.location.href) + "', '_blank', 'top=100,left=100,toolbar=0,status=0,width=620,height=400'); return false;")
				},
				createTwitterShare: function(a) {
					a.length && !a.attr("onclick") && a.attr("onclick", "window.open('https://twitter.com/intent/tweet?source=" + encodeURIComponent(b.location.href) + "&text=" + encodeURIComponent(c.title) + "', '_blank', 'top=100,left=100,toolbar=0,status=0,width=620,height=300'); return false;")
				},
				createGooglePlusShare: function(a) {
					a.length && !a.attr("onclick") && a.attr("onclick", "window.open('https://plus.google.com/share?url=" + encodeURIComponent(b.location.href) + "', '_blank', 'top=100,left=100,toolbar=0,status=0,width=620,height=450'); return false;")
				},
				createPinterestShare: function(a) {
					if (a.length && !a.attr("onclick")) {
						var c = "",
							d = this.content.find("img")[0];
						d && (c = d.src), a.attr("onclick", "window.open('http://pinterest.com/pin/create/button/?url=" + encodeURIComponent(b.location.href) + "&media=" + c + "', '_blank', 'top=100,left=100,toolbar=0,status=0,width=620,height=400'); return false;")
					}
				},
				updateSinglePageInline: function(a, b) {
					var c = this;
					c.content.html(a), b && c.appendScriptsToWrap(b), c.cubeportfolio.$obj.trigger("updateSinglePageInlineStart.cbp"), c.singlePageInlineIsOpen.call(c)
				},
				singlePageInlineIsOpen: function() {
					function a() {
						b.wrap.addClass("cbp-popup-singlePageInline-ready"), b.wrap[0].style.height = "", b.resizeSinglePageInline(), b.cubeportfolio.$obj.trigger("updateSinglePageInlineComplete.cbp")
					}
					var b = this;
					b.cubeportfolio.loadImages(b.wrap, function() {
						var c = b.content.find(".cbp-slider");
						c.length ? (c.find(".cbp-slider-item").addClass("cbp-item"), c.one("initComplete.cbp", function() {
							b.deferredInline.done(a)
						}), c.on("pluginResize.cbp", function() {
							b.deferredInline.done(a)
						}), b.slider = c.cubeportfolio({
							layoutMode: "slider",
							displayType: "default",
							mediaQueries: [{
								width: 1,
								cols: 1
							}],
							gapHorizontal: 0,
							gapVertical: 0,
							caption: "",
							coverRatio: ""
						})) : (b.slider = null, b.deferredInline.done(a)), b.checkForSocialLinks(b.content)
					})
				},
				isImage: function(b) {
					var c = this;
					new Image;
					c.tooggleLoading(!0), c.cubeportfolio.loadImages(a('<div><img src="' + b.src + '"></div>'), function() {
						c.updateImagesMarkup(b.src, b.title, c.getCounterMarkup(c.options.lightboxCounter, c.current + 1, c.counterTotal)), c.tooggleLoading(!1)
					})
				},
				isVimeo: function(a) {
					var b = this;
					b.updateVideoMarkup(a.src, a.title, b.getCounterMarkup(b.options.lightboxCounter, b.current + 1, b.counterTotal))
				},
				isYoutube: function(a) {
					var b = this;
					b.updateVideoMarkup(a.src, a.title, b.getCounterMarkup(b.options.lightboxCounter, b.current + 1, b.counterTotal))
				},
				isTed: function(a) {
					var b = this;
					b.updateVideoMarkup(a.src, a.title, b.getCounterMarkup(b.options.lightboxCounter, b.current + 1, b.counterTotal))
				},
				isSoundCloud: function(a) {
					var b = this;
					b.updateVideoMarkup(a.src, a.title, b.getCounterMarkup(b.options.lightboxCounter, b.current + 1, b.counterTotal))
				},
				isSelfHostedVideo: function(a) {
					var b = this;
					b.updateSelfHostedVideo(a.src, a.title, b.getCounterMarkup(b.options.lightboxCounter, b.current + 1, b.counterTotal))
				},
				isSelfHostedAudio: function(a) {
					var b = this;
					b.updateSelfHostedAudio(a.src, a.title, b.getCounterMarkup(b.options.lightboxCounter, b.current + 1, b.counterTotal))
				},
				getCounterMarkup: function(a, b, c) {
					if (!a.length) return "";
					var d = {
						current: b,
						total: c
					};
					return a.replace(/\{\{current}}|\{\{total}}/gi, function(a) {
						return d[a.slice(2, -2)]
					})
				},
				updateSelfHostedVideo: function(a, b, c) {
					var d, e = this;
					e.wrap.addClass("cbp-popup-lightbox-isIframe");
					var f = '<div class="cbp-popup-lightbox-iframe"><video controls="controls" height="auto" style="width: 100%">';
					for (d = 0; d < a.length; d++) /(\.mp4)/i.test(a[d]) ? f += '<source src="' + a[d] + '" type="video/mp4">' : /(\.ogg)|(\.ogv)/i.test(a[d]) ? f += '<source src="' + a[d] + '" type="video/ogg">' : /(\.webm)/i.test(a[d]) && (f += '<source src="' + a[d] + '" type="video/webm">');
					f += 'Your browser does not support the video tag.</video><div class="cbp-popup-lightbox-bottom">' + (b ? '<div class="cbp-popup-lightbox-title">' + b + "</div>" : "") + c + "</div></div>", e.content.html(f), e.wrap.addClass("cbp-popup-ready"), e.preloadNearbyImages()
				},
				updateSelfHostedAudio: function(a, b, c) {
					var d = this;
					d.wrap.addClass("cbp-popup-lightbox-isIframe");
					var e = '<div class="cbp-popup-lightbox-iframe"><div class="cbp-misc-video"><audio controls="controls" height="auto" style="width: 75%"><source src="' + a + '" type="audio/mpeg">Your browser does not support the audio tag.</audio></div><div class="cbp-popup-lightbox-bottom">' + (b ? '<div class="cbp-popup-lightbox-title">' + b + "</div>" : "") + c + "</div></div>";
					d.content.html(e), d.wrap.addClass("cbp-popup-ready"), d.preloadNearbyImages()
				},
				updateVideoMarkup: function(a, b, c) {
					var d = this;
					d.wrap.addClass("cbp-popup-lightbox-isIframe");
					var e = '<div class="cbp-popup-lightbox-iframe"><iframe src="' + a + '" frameborder="0" allowfullscreen scrolling="no"></iframe><div class="cbp-popup-lightbox-bottom">' + (b ? '<div class="cbp-popup-lightbox-title">' + b + "</div>" : "") + c + "</div></div>";
					d.content.html(e), d.wrap.addClass("cbp-popup-ready"), d.preloadNearbyImages()
				},
				updateImagesMarkup: function(a, b, c) {
					var d = this;
					d.wrap.removeClass("cbp-popup-lightbox-isIframe");
					var e = '<div class="cbp-popup-lightbox-figure"><img src="' + a + '" class="cbp-popup-lightbox-img" ' + d.dataActionImg + ' /><div class="cbp-popup-lightbox-bottom">' + (b ? '<div class="cbp-popup-lightbox-title">' + b + "</div>" : "") + c + "</div></div>";
					d.content.html(e), d.wrap.addClass("cbp-popup-ready"), d.resizeImage(), d.preloadNearbyImages()
				},
				next: function() {
					var a = this;
					a[a.type + "JumpTo"](1)
				},
				prev: function() {
					var a = this;
					a[a.type + "JumpTo"](-1)
				},
				lightboxJumpTo: function(a) {
					var b, c = this;
					c.current = c.getIndex(c.current + a), b = c.dataArray[c.current], c[b.type](b)
				},
				singlePageJumpTo: function(b) {
					var c = this;
					c.current = c.getIndex(c.current + b), a.isFunction(c.options.singlePageCallback) && (c.resetWrap(), c.wrap.scrollTop(0), c.wrap.addClass("cbp-popup-loading"), c.options.singlePageCallback.call(c, c.dataArray[c.current].url, c.dataArray[c.current].element), c.options.singlePageDeeplinking && (location.href = c.url + "#cbp=" + c.dataArray[c.current].url))
				},
				resetWrap: function() {
					var a = this;
					"singlePage" === a.type && a.options.singlePageDeeplinking && (location.href = a.url + "#"), "singlePageInline" === a.type && a.options.singlePageInlineDeeplinking && (location.href = a.url + "#")
				},
				getIndex: function(a) {
					var b = this;
					return a %= b.counterTotal, 0 > a && (a = b.counterTotal + a), a
				},
				close: function(c, d) {
					function e() {
						h.content.html(""), h.wrap.detach(), h.cubeportfolio.$obj.removeClass("cbp-popup-singlePageInline-open cbp-popup-singlePageInline-close"), "promise" === c && a.isFunction(d.callback) && d.callback.call(h.cubeportfolio), h.resetWrap()
					}

					function g() {
						h.options.singlePageInlineInFocus && "promise" !== c ? a("html,body").animate({
							scrollTop: h.scrollTop
						}, 350).promise().then(function() {
							e()
						}) : e()
					}
					var h = this;
					h.isOpen = !1, "singlePageInline" === h.type ? "open" === c ? (h.wrap.removeClass("cbp-popup-singlePageInline-ready"), a(h.dataArray[h.current].element).closest(".cbp-item").removeClass("cbp-singlePageInline-active"), h.openSinglePageInline(d.blocks, d.currentBlock, d.fromOpen)) : (h.height = 0, h.revertResizeSinglePageInline(), h.wrap.removeClass("cbp-popup-singlePageInline-ready"), h.cubeportfolio.$obj.addClass("cbp-popup-singlePageInline-close"), h.cubeportfolio.$obj.find(".cbp-item").removeClass("cbp-singlePageInline-active"), f["private"].modernBrowser ? h.wrap.one(f["private"].transitionend, function() {
						g()
					}) : g()) : "singlePage" === h.type ? (h.resetWrap(), h.wrap.removeClass("cbp-popup-ready cbp-popup-transitionend"), ("android" === f["private"].browser || "ios" === f["private"].browser) && (a("html").css({
						position: ""
					}), h.navigationWrap.appendTo(h.wrap), h.navigationMobile.remove()), a(b).scrollTop(h.scrollTop), setTimeout(function() {
						h.stopScroll = !0,
							h.navigationWrap.css({
								top: h.wrap.scrollTop()
							}), h.wrap.removeClass("cbp-popup-singlePage-open cbp-popup-singlePage-sticky"), ("ie8" === f["private"].browser || "ie9" === f["private"].browser) && (h.content.html(""), h.wrap.detach(), a("html").css({
								overflow: "",
								marginRight: "",
								position: ""
							}), h.navigationWrap.removeAttr("style"))
					}, 0), a("html").css({
						overflow: "",
						marginRight: "",
						position: ""
					}), h.wrap.one(f["private"].transitionend, function() {
						h.content.html(""), h.wrap.detach(), h.navigationWrap.removeAttr("style")
					})) : (h.originalStyle ? a("html").attr("style", h.originalStyle) : a("html").css({
						overflow: "",
						marginRight: ""
					}), a(b).scrollTop(h.scrollTop), h.content.html(""), h.wrap.detach())
				},
				tooggleLoading: function(a) {
					var b = this;
					b.stopEvents = a, b.wrap[a ? "addClass" : "removeClass"]("cbp-popup-loading")
				},
				resizeImage: function() {
					if (this.isOpen) {
						var c = a(b).height(),
							d = this.content.find("img"),
							e = parseInt(d.css("margin-top"), 10) + parseInt(d.css("margin-bottom"), 10);
						d.css("max-height", c - e + "px")
					}
				},
				preloadNearbyImages: function() {
					var a = [],
						b = this;
					a.push(b.getIndex(b.current + 1)), a.push(b.getIndex(b.current + 2)), a.push(b.getIndex(b.current + 3)), a.push(b.getIndex(b.current - 1)), a.push(b.getIndex(b.current - 2)), a.push(b.getIndex(b.current - 3));
					for (var c = a.length - 1; c >= 0; c--) "isImage" === b.dataArray[a[c]].type && b.cubeportfolio.checkSrc(b.dataArray[a[c]].src)
				}
			},
			h = !1,
			i = !1;
		e.prototype.run = function() {
			var b = this,
				d = b.parent,
				e = a(c.body);
			d.lightbox = null, d.options.lightboxDelegate && !h && (h = !0, d.lightbox = Object.create(g), d.lightbox.init(d, "lightbox"), e.on("click.cbp", d.options.lightboxDelegate, function(c) {
				c.preventDefault();
				var e = a(this),
					f = e.attr("data-cbp-lightbox"),
					g = b.detectScope(e),
					h = g.data("cubeportfolio"),
					i = [];
				h ? h.blocksOn.each(function(b, c) {
					var e = a(c);
					e.not(".cbp-item-off") && e.find(d.options.lightboxDelegate).each(function(b, c) {
						f ? a(c).attr("data-cbp-lightbox") === f && i.push(c) : i.push(c)
					})
				}) : i = f ? g.find(d.options.lightboxDelegate + "[data-cbp-lightbox=" + f + "]") : g.find(d.options.lightboxDelegate), d.lightbox.openLightbox(i, e[0])
			})), d.singlePage = null, d.options.singlePageDelegate && !i && (i = !0, d.singlePage = Object.create(g), d.singlePage.init(d, "singlePage"), e.on("click.cbp", d.options.singlePageDelegate, function(c) {
				c.preventDefault();
				var e = a(this),
					f = e.attr("data-cbp-singlePage"),
					g = b.detectScope(e),
					h = g.data("cubeportfolio"),
					i = [];
				h ? h.blocksOn.each(function(b, c) {
					var e = a(c);
					e.not(".cbp-item-off") && e.find(d.options.singlePageDelegate).each(function(b, c) {
						f ? a(c).attr("data-cbp-singlePage") === f && i.push(c) : i.push(c)
					})
				}) : i = f ? g.find(d.options.singlePageDelegate + "[data-cbp-singlePage=" + f + "]") : g.find(d.options.singlePageDelegate), d.singlePage.openSinglePage(i, e[0])
			})), d.singlePageInline = null, d.options.singlePageInlineDelegate && (d.singlePageInline = Object.create(g), d.singlePageInline.init(d, "singlePageInline"), d.$obj.on("click.cbp", d.options.singlePageInlineDelegate, function(b) {
				b.preventDefault();
				var c = a.data(this, "cbp-locked"),
					e = a.data(this, "cbp-locked", +new Date);
				(!c || e - c > 300) && d.singlePageInline.openSinglePageInline(d.blocksOn, this)
			}))
		}, e.prototype.detectScope = function(b) {
			var d, e, f;
			return d = b.closest(".cbp-popup-singlePageInline"), d.length ? (f = b.closest(".cbp", d[0]), f.length ? f : d) : (e = b.closest(".cbp-popup-singlePage"), e.length ? (f = b.closest(".cbp", e[0]), f.length ? f : e) : (f = b.closest(".cbp"), f.length ? f : a(c.body)))
		}, e.prototype.destroy = function() {
			var b = this.parent;
			a(c.body).off("click.cbp"), h = !1, i = !1, b.lightbox && b.lightbox.destroy(), b.singlePage && b.singlePage.destroy(), b.singlePageInline && b.singlePageInline.destroy()
		}, f.plugins.popUp = function(a) {
			return new e(a)
		}
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";

		function e(b) {
			var c = this;
			c.parent = b, c.searchInput = a(b.options.search), c.searchInput.each(function(b, c) {
				var d = c.getAttribute("data-search");
				d || (d = "*"), a.data(c, "searchData", {
					value: c.value,
					el: d
				})
			});
			var d = null;
			c.searchInput.on("keyup.cbp paste.cbp", function(b) {
				b.preventDefault();
				var e = a(this);
				clearTimeout(d), d = setTimeout(function() {
					c.runEvent.call(c, e)
				}, 300)
			}), c.searchNothing = c.searchInput.siblings(".cbp-search-nothing").detach(), c.searchNothingHeight = null, c.searchNothingHTML = c.searchNothing.html(), c.searchInput.siblings(".cbp-search-icon").on("click.cbp", function(b) {
				b.preventDefault(), c.runEvent.call(c, a(this).prev().val(""))
			})
		}
		var f = a.fn.cubeportfolio.constructor;
		e.prototype.runEvent = function(b) {
			var c = this,
				d = b.val(),
				e = b.data("searchData"),
				f = new RegExp(d, "i");
			e.value === d || c.parent.isAnimating || (e.value = d, d.length > 0 ? b.attr("value", d) : b.removeAttr("value"), c.parent.$obj.cubeportfolio("filter", function(b) {
				var g = b.filter(function(b, c) {
					var d = a(c).find(e.el).text();
					return d.search(f) > -1 ? !0 : void 0
				});
				if (0 === g.length && c.searchNothing.length) {
					var h = c.searchNothingHTML.replace("{{query}}", d);
					c.searchNothing.html(h), c.searchNothing.appendTo(c.parent.$obj), null === c.searchNothingHeight && (c.searchNothingHeight = c.searchNothing.outerHeight(!0)), c.parent.registerEvent("resizeMainContainer", function() {
						c.parent.height = c.parent.height + c.searchNothingHeight, c.parent.obj.style.height = c.parent.height + "px"
					}, !0)
				} else c.searchNothing.detach();
				return g
			}, function() {
				b.trigger("keyup.cbp")
			}))
		}, e.prototype.destroy = function() {
			var b = this;
			b.searchInput.off(".cbp"), b.searchInput.next(".cbp-search-icon").off(".cbp"), b.searchInput.each(function(b, c) {
				a.removeData(c)
			})
		}, f.plugins.search = function(a) {
			return "" === a.options.search ? null : new e(a)
		}
	}(jQuery, window, document),
	function(a, b, c, d) {
		"use strict";

		function e(b) {
			var c = this;
			c.parent = b, c.options = a.extend({}, f, c.parent.options.plugins.slider);
			var d = a(c.options.pagination);
			d.length > 0 && (c.parent.customPagination = d, c.parent.customPaginationItems = d.children(), c.parent.customPaginationClass = c.options.paginationClass, c.parent.customPaginationItems.on("click.cbp", function(b) {
				b.preventDefault(), b.stopImmediatePropagation(), b.stopPropagation(), c.parent.sliderStopEvents || c.parent.jumpToSlider(a(this))
			})), c.parent.registerEvent("gridAdjust", function() {
				c.sliderMarkup.call(c.parent), c.parent.registerEvent("gridAdjust", function() {
					c.updateSlider.call(c.parent)
				})
			}, !0)
		}
		var f = {
				pagination: "",
				paginationClass: "cbp-pagination-active"
			},
			g = a.fn.cubeportfolio.constructor;
		e.prototype.sliderMarkup = function() {
			var b = this;
			b.sliderStopEvents = !1, b.sliderActive = 0, b.$obj.one("initComplete.cbp", function() {
				b.$obj.addClass("cbp-mode-slider")
			}), b.nav = a("<div/>", {
				"class": "cbp-nav"
			}), b.nav.on("click.cbp", "[data-slider-action]", function(c) {
				if (c.preventDefault(), c.stopImmediatePropagation(), c.stopPropagation(), !b.sliderStopEvents) {
					var d = a(this),
						e = d.attr("data-slider-action");
					b[e + "Slider"] && b[e + "Slider"](d)
				}
			}), b.options.showNavigation && (b.controls = a("<div/>", {
				"class": "cbp-nav-controls"
			}), b.navPrev = a("<div/>", {
				"class": "cbp-nav-prev",
				"data-slider-action": "prev"
			}).appendTo(b.controls), b.navNext = a("<div/>", {
				"class": "cbp-nav-next",
				"data-slider-action": "next"
			}).appendTo(b.controls), b.controls.appendTo(b.nav)), b.options.showPagination && (b.navPagination = a("<div/>", {
				"class": "cbp-nav-pagination"
			}).appendTo(b.nav)), (b.controls || b.navPagination) && b.nav.appendTo(b.$obj), b.updateSliderPagination(), b.options.auto && (b.options.autoPauseOnHover && (b.mouseIsEntered = !1, b.$obj.on("mouseenter.cbp", function(a) {
				b.mouseIsEntered = !0, b.stopSliderAuto()
			}).on("mouseleave.cbp", function(a) {
				b.mouseIsEntered = !1, b.startSliderAuto()
			})), b.startSliderAuto()), b.options.drag && g["private"].modernBrowser && b.dragSlider()
		}, e.prototype.updateSlider = function() {
			var a = this;
			a.updateSliderPosition(), a.updateSliderPagination()
		}, e.prototype.destroy = function() {
			var a = this;
			a.parent.customPaginationItems && a.parent.customPaginationItems.off(".cbp"), (a.parent.controls || a.parent.navPagination) && (a.parent.nav.off(".cbp"), a.parent.nav.remove())
		}, g.plugins.slider = function(a) {
			return "slider" !== a.options.layoutMode ? null : new e(a)
		}
	}(jQuery, window, document);
// Parallax
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
// requestAnimationFrame polyfill by Erik MÃ¶ller. fixes from Paul Irish and Tino Zijdel
/*
( function() {
	var lastTime = 0,
		vendors = ['ms', 'moz', 'webkit', 'o'],
		currTime, timeToCall, id, x;
	for( x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
		window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
		window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
	}
	//jshint unused:false
	if (!window.requestAnimationFrame) {
		window.requestAnimationFrame = function(callback, element) {
			currTime = new Date().getTime();
			timeToCall = Math.max(0, 16 - (currTime - lastTime));
			id = window.setTimeout(function() { callback(currTime + timeToCall); },
			timeToCall);
			lastTime = currTime + timeToCall;
			return id;
		};
	}

	if (!window.cancelAnimationFrame) {
		window.cancelAnimationFrame = function(id) {
			clearTimeout(id);
		};
	}
}() );
*/
/*!
jQuery Hardware Acceleration Parallax
Version 1.0.1
*/
;
(function($, window, document, undefined) {
	var pluginName = 'vossenParallax',
		defaults = {
			speedFactor: 6
		};
	/**
	 * The actual plugin constructor
	 */
	function Plugin(element, options) {
		this.element = element;
		this.settings = $.extend({}, defaults, options);
		this._defaults = defaults;
		this._name = pluginName;
		this.init();
	}
	/**
	 * Avoid Plugin.prototype conflicts
	 */
	$.extend(Plugin.prototype, {
		/**
		 * Initialize plugin
		 */
		init: function() {
			var _this = this;
			this.build(this.element, this.settings);
			_this.update($(window).scrollTop());
			_this.imgStretch();
			/**
			 * Resize event
			 */
			$(window).resize(function() {
				_this.update($(window).scrollTop());
				_this.imgStretch();
			}).resize();
			/**
			 * Scroll event
			 */
			$(window).scroll(function() {
				_this.update($(window).scrollTop());
				_this.translate($(window).scrollTop());
			});
			$(window).load(function() {
				_this.setNaturalImgDimensionsData();
				_this.imgStretch();
			});
		},
		/**
		 * Create blocks with image from the element background image URL
		 */
		build: function() {
			if (!$(this.element).css('background-image')) {
				return;
			}
			var scrollTop = $(window).scrollTop(),
				$section = $(this.element),
				index = $section.index(),
				sectionHeight = $section.outerHeight() + 1,
				offsetTop = $section.offset().top - scrollTop,
				bg = $section.css('background-image').replace('url(', '').replace(')', '').replace('"', ''),
				$holder = $('<div style="z-index:0;width:100%;top: 0;position:fixed;overflow:hidden;min-height:75%" class="parallax-bg" data-holder-index="' + index + '"><img style="max-width: none;width:100%;height:auto;position:fixed;top:0;left:0;backface-visibility:hidden;-webkit-backface-visibility:hidden;" id="parallax-bg-img-' + index + '" src="' + bg + '"></div>');
			$($section).prepend($holder);
			$section.attr('data-section-index', index);
			$section.attr('data-top', Math.floor($section.offset().top));
			$section.css({
				'background': 'none'
			});
			$holder.css({
				'height': sectionHeight,
				'transform': 'translate3d(0,' + Math.floor(offsetTop) + 'px,0)',
				'-webkit-transform': 'translate3d(0,' + Math.floor(offsetTop) + 'px,0)'
			});
		},
		/**
		 * Update image holder position while scrolling or resizing
		 */
		update: function(scrollTop) {
			var $section = $(this.element),
				index = $section.data('section-index'),
				$holder = $('.parallax-bg[data-holder-index="' + index + '"]'),
				windowHeight = $(window).height(),
				sectionHeight = $section.height() + 1,
				offsetTop = $section.offset().top - scrollTop;
			//if ( ( scrollTop > $section.offset().top + sectionHeight ) || ( scrollTop + windowHeight < offsetTop ) ) {
			//	return;
			//}
			$holder.css({
				'height': sectionHeight,
				'transform': 'translate3d(0,' + Math.floor(offsetTop) + 'px,0)',
				'-webkit-transform': 'translate3d(0,' + Math.floor(offsetTop) + 'px,0)'
			});
		},
		/**
		 * Simulate background cover behavior for images
		 */
		imgStretch: function() {
			var windowWidth = $(window).width(),
				$section = $(this.element),
				index = $section.data('section-index'),
				$img = $('.parallax-bg[data-holder-index="' + index + '"]').find('img'),
				originImgWidth = $img.data('width'),
				newCss;
			if (originImgWidth < windowWidth) {
				newCss = {
					'margin-left': 0,
					'width': '100%'
				};
			} else {
				newCss = {
					'margin-left': -(originImgWidth - windowWidth) / 2,
					'width': originImgWidth
				};
			}
			$img.css(newCss);
		},
		/**
		 * Parallax effect
		 */
		translate: function(scrollTop) {
			var windowHeight = $(window).height(),
				$section = $(this.element),
				index = $section.data('section-index'),
				sectionHeight = $section.outerHeight(),
				offsetTop = $section.offset().top,
				speedFactor = ($section.data('parallax-speed') || this.settings.speedFactor) / 10,
				$holderImg = $('.parallax-bg[data-holder-index="' + index + '"]').find('img'),
				doPos;
			if ((scrollTop > offsetTop + sectionHeight) || (scrollTop + windowHeight < offsetTop)) {
				return;
			}
			doPos = (scrollTop - offsetTop) * speedFactor;
			$holderImg.css({
				'transform': 'translate3d(0,' + doPos + 'px,0)',
				'-webkit-transform': 'translate3d(0,' + doPos + 'px,0)'
			});
		},
		/**
		 * Set natural images dimensions on page load
		 */
		setNaturalImgDimensionsData: function() {
			var $section = $(this.element),
				index = $section.data('section-index'),
				$holder = $('.parallax-bg[data-holder-index="' + index + '"]'),
				imgId = $holder.find('img').attr('id'),
				image = document.getElementById(imgId),
				width = image.naturalWidth,
				height = image.naturalHeight;
			$holder.find('img').attr('data-width', width);
			$holder.find('img').attr('data-height', height);
		}
	});
	$.fn[pluginName] = function(options) {
		this.each(function() {
			if (!$.data(this, 'parallax_' + pluginName)) {
				$.data(this, 'parallax_' + pluginName, new Plugin(this, options));
			}
		});
		// chain jQuery functions
		return this;
	};
})(jQuery, window, document);
// Smooth Scroll
// SmoothScroll for websites v1.4.0 (Balazs Galambosi)
// Licensed under the terms of the MIT license.
/*
!function(){function e(){H.keyboardSupport&&f("keydown",a)}function t(){if(!B&&document.body){B=!0;var t=document.body,o=document.documentElement;window.innerHeight,t.scrollHeight;L=document.compatMode.indexOf("CSS")>=0?o:t,D=t,e(),top!=self&&(Y=!0),H.fixedBackground||X||(t.style.backgroundAttachment="scroll",o.style.backgroundAttachment="scroll")}}function o(){M&&M.disconnect(),w(I,r),w("mousedown",i),w("keydown",a),w("resize",T),w("load",t)}function n(e,t,o){if(h(t,o),1!=H.accelerationMax){var n=Date.now(),r=n-R;if(r<H.accelerationDelta){var a=(1+50/r)/2;a>1&&(a=Math.min(a,H.accelerationMax),t*=a,o*=a)}R=Date.now()}if(q.push({x:t,y:o,lastX:0>t?.99:-.99,lastY:0>o?.99:-.99,start:Date.now()}),!P){var i=e===document.body,l=function(n){for(var r=Date.now(),a=0,c=0,u=0;u<q.length;u++){var d=q[u],s=r-d.start,m=s>=H.animationTime,f=m?1:s/H.animationTime;H.pulseAlgorithm&&(f=k(f));var w=d.x*f-d.lastX>>0,p=d.y*f-d.lastY>>0;a+=w,c+=p,d.lastX+=w,d.lastY+=p,m&&(q.splice(u,1),u--)}i?window.scrollBy(a,c):(a&&(e.scrollLeft+=a),c&&(e.scrollTop+=c)),t||o||(q=[]),q.length?_(l,e,1e3/H.frameRate+1):P=!1};_(l,e,0),P=!0}}function r(e){B||t();var o=e.target,r=u(o);if(!r||e.defaultPrevented||e.ctrlKey)return!0;if(p(D,"embed")||p(o,"embed")&&/\.pdf/i.test(o.src)||p(D,"object"))return!0;var a=-e.wheelDeltaX||e.deltaX||0,i=-e.wheelDeltaY||e.deltaY||0;return K&&(e.wheelDeltaX&&b(e.wheelDeltaX,120)&&(a=-120*(e.wheelDeltaX/Math.abs(e.wheelDeltaX))),e.wheelDeltaY&&b(e.wheelDeltaY,120)&&(i=-120*(e.wheelDeltaY/Math.abs(e.wheelDeltaY)))),a||i||(i=-e.wheelDelta||0),1===e.deltaMode&&(a*=40,i*=40),!H.touchpadSupport&&v(i)?!0:(Math.abs(a)>1.2&&(a*=H.stepSize/120),Math.abs(i)>1.2&&(i*=H.stepSize/120),n(r,a,i),e.preventDefault(),void l())}function a(e){var t=e.target,o=e.ctrlKey||e.altKey||e.metaKey||e.shiftKey&&e.keyCode!==N.spacebar;document.contains(D)||(D=document.activeElement);var r=/^(textarea|select|embed|object)$/i,a=/^(button|submit|radio|checkbox|file|color|image)$/i;if(r.test(t.nodeName)||p(t,"input")&&!a.test(t.type)||p(D,"video")||g(e)||t.isContentEditable||e.defaultPrevented||o)return!0;if((p(t,"button")||p(t,"input")&&a.test(t.type))&&e.keyCode===N.spacebar)return!0;var i,c=0,d=0,s=u(D),m=s.clientHeight;switch(s==document.body&&(m=window.innerHeight),e.keyCode){case N.up:d=-H.arrowScroll;break;case N.down:d=H.arrowScroll;break;case N.spacebar:i=e.shiftKey?1:-1,d=-i*m*.9;break;case N.pageup:d=.9*-m;break;case N.pagedown:d=.9*m;break;case N.home:d=-s.scrollTop;break;case N.end:var f=s.scrollHeight-s.scrollTop-m;d=f>0?f+10:0;break;case N.left:c=-H.arrowScroll;break;case N.right:c=H.arrowScroll;break;default:return!0}n(s,c,d),e.preventDefault(),l()}function i(e){D=e.target}function l(){clearTimeout(E),E=setInterval(function(){F={}},1e3)}function c(e,t){for(var o=e.length;o--;)F[j(e[o])]=t;return t}function u(e){var t=[],o=document.body,n=L.scrollHeight;do{var r=F[j(e)];if(r)return c(t,r);if(t.push(e),n===e.scrollHeight){var a=s(L)&&s(o),i=a||m(L);if(Y&&d(L)||!Y&&i)return c(t,V())}else if(d(e)&&m(e))return c(t,e)}while(e=e.parentElement)}function d(e){return e.clientHeight+10<e.scrollHeight}function s(e){var t=getComputedStyle(e,"").getPropertyValue("overflow-y");return"hidden"!==t}function m(e){var t=getComputedStyle(e,"").getPropertyValue("overflow-y");return"scroll"===t||"auto"===t}function f(e,t){window.addEventListener(e,t,!1)}function w(e,t){window.removeEventListener(e,t,!1)}function p(e,t){return(e.nodeName||"").toLowerCase()===t.toLowerCase()}function h(e,t){e=e>0?1:-1,t=t>0?1:-1,(A.x!==e||A.y!==t)&&(A.x=e,A.y=t,q=[],R=0)}function v(e){return e?(O.length||(O=[e,e,e]),e=Math.abs(e),O.push(e),O.shift(),clearTimeout(C),C=setTimeout(function(){window.localStorage&&(localStorage.SS_deltaBuffer=O.join(","))},1e3),!y(120)&&!y(100)):void 0}function b(e,t){return Math.floor(e/t)==e/t}function y(e){return b(O[0],e)&&b(O[1],e)&&b(O[2],e)}function g(e){var t=e.target,o=!1;if(-1!=document.URL.indexOf("www.youtube.com/watch"))do if(o=t.classList&&t.classList.contains("html5-video-controls"))break;while(t=t.parentNode);return o}function S(e){var t,o,n;return e*=H.pulseScale,1>e?t=e-(1-Math.exp(-e)):(o=Math.exp(-1),e-=1,n=1-Math.exp(-e),t=o+n*(1-o)),t*H.pulseNormalize}function k(e){return e>=1?1:0>=e?0:(1==H.pulseNormalize&&(H.pulseNormalize/=S(1)),S(e))}function x(e){for(var t in e)z.hasOwnProperty(t)&&(H[t]=e[t])}var D,M,T,E,C,z={frameRate:150,animationTime:300,stepSize:100,pulseAlgorithm:!0,pulseScale:4,pulseNormalize:1,accelerationDelta:50,accelerationMax:3,keyboardSupport:!0,arrowScroll:50,touchpadSupport:!1,fixedBackground:!0,excluded:""},H=z,X=!1,Y=!1,A={x:0,y:0},B=!1,L=document.documentElement,O=[],K=/^Mac/.test(navigator.platform),N={left:37,up:38,right:39,down:40,spacebar:32,pageup:33,pagedown:34,end:35,home:36},q=[],P=!1,R=Date.now(),j=function(){var e=0;return function(t){return t.uniqueID||(t.uniqueID=e++)}}(),F={};window.localStorage&&localStorage.SS_deltaBuffer&&(O=localStorage.SS_deltaBuffer.split(","));var I,_=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||function(e,t,o){window.setTimeout(e,o||1e3/60)}}(),V=(window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver,function(){var e;return function(){if(!e){var t=document.createElement("div");t.style.cssText="height:10000px;width:1px;",document.body.appendChild(t);var o=document.body.scrollTop;document.documentElement.scrollTop;window.scrollBy(0,3),e=document.body.scrollTop!=o?document.body:document.documentElement,window.scrollBy(0,-3),document.body.removeChild(t)}return e}}()),$=window.navigator.userAgent,U=/Edge/.test($),W=/chrome/i.test($)&&!U,G=/safari/i.test($)&&!U,J=/mobile/i.test($),Q=(W||G)&&!J;"onwheel"in document.createElement("div")?I="wheel":"onmousewheel"in document.createElement("div")&&(I="mousewheel"),I&&Q&&(f(I,r),f("mousedown",i),f("load",t)),x.destroy=o,window.SmoothScrollOptions&&x(window.SmoothScrollOptions),"function"==typeof define&&define.amd?define(function(){return x}):"object"==typeof exports?module.exports=x:window.SmoothScroll=x}();
*/
/*!
 * Vossen Hero YT
 * version: 1.2 (30 April, 2016)
 */
if ($('#vossen-youtube').length) {
	var tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	var vosVideoId = $('#vossen-youtube').attr('youtube-video-id');
	var player;

	function onYouTubeIframeAPIReady() {
		player = new YT.Player('vossen-youtube', {
			width: $(window).width() + '0',
			height: $(window).height() + '0',
			videoId: vosVideoId,
			playerVars: {
				playlist: vosVideoId,
				autoplay: 1,
				controls: 0,
				showinfo: 0,
				loop: 1,
			},
			events: {
				'onReady': onPlayerReady,
				'onStateChange': onPlayerStateChange
			}
		});
		$(window).on('load resize', function() {
			var w = $(window).width() + 0;
			var h = $(window).height() + 0;
			if (w / h > 16 / 9) {
				player.setSize(w, w / 16 * 9);
				$('#vossen-youtube').css({
					'left': '0px'
				});
			} else {
				player.setSize(h / 9 * 16, h);
				$('#vossen-youtube').css({
					'left': -($('#vossen-youtube').outerWidth() - w) / 2
				});
			}
		});
	}

	function onPlayerStateChange(event) {}

	function stopVideo() {
		player.stopVideo();
	}

	function onPlayerReady() {
		player.playVideo();
		player.mute();
	}
}
/*!
 * Vossen Google Maps
 * version: 1.1 (10 April, 2016)
 * require: jQuery v1.12+
 */
if ($('#map').length) {
	function initialize() {
		var userAddress, userMarker, userInfo;
		userAddress = $('#map').attr('data-map-coordinates');
		userMarker = $('#map').attr('data-marker-coordinates');
		userInfo = $('#map').attr('data-info');
		// Google Map 1
		$(".map-style-1").gmap3({
			map: {
				address: userAddress,
				options: {
					styles: [{
						stylers: [{
							"saturation": -100
						}, {
							"gamma": 2
						}, {
							"lightness": 14
						}]
					}, {
						"featureType": "water",
						"elementType": "all",
						"stylers": [{
							"color": "#a0dce6"
						}, {
							"visibility": "on"
						}]
					}],
					zoom: 14,
					scrollwheel: false,
					draggable: true
				}
			},
			marker: {
				address: userMarker,
				data: userInfo,
				options: {
					icon: "https://cdn.shopify.com/s/files/1/1200/3934/files/Marker-ISL-color-sm.png?15307446976746799811"
				},
				events: {
					click: function(marker, event, context) {
						var map = $(this).gmap3("get"),
							infowindow = $(this).gmap3({
								get: {
									name: "infowindow"
								}
							});
						if (infowindow) {
							infowindow.open(map, marker);
							infowindow.setContent(context.data);
						} else {
							$(this).gmap3({
								infowindow: {
									anchor: marker,
									options: {
										content: context.data
									}
								}
							});
						}
					}
				}
			}
		});
		// Google Map 2 
		$(".map-style-2").gmap3({
			map: {
				address: userAddress,
				options: {
					styles: [{
						featureType: "all",
						elementType: "labels.text.fill",
						stylers: [{
							saturation: 36
						}, {
							color: "#000000"
						}, {
							lightness: 40
						}]
					}, {
						featureType: "all",
						elementType: "labels.text.stroke",
						stylers: [{
							visibility: "on"
						}, {
							color: "#000000"
						}, {
							lightness: 16
						}]
					}, {
						featureType: "all",
						elementType: "labels.icon",
						stylers: [{
							visibility: "off"
						}]
					}, {
						featureType: "administrative",
						elementType: "geometry.fill",
						stylers: [{
							color: "#000000"
						}, {
							lightness: 20
						}]
					}, {
						featureType: "administrative",
						elementType: "geometry.stroke",
						stylers: [{
							color: "#000000"
						}, {
							lightness: 17
						}, {
							weight: 1.2
						}]
					}, {
						featureType: "landscape",
						elementType: "geometry",
						stylers: [{
							color: "#000000"
						}, {
							lightness: 20
						}]
					}, {
						featureType: "poi",
						elementType: "geometry",
						stylers: [{
							color: "#000000"
						}, {
							lightness: 21
						}]
					}, {
						featureType: "road.highway",
						elementType: "geometry.fill",
						stylers: [{
							color: "#000000"
						}, {
							lightness: 17
						}]
					}, {
						featureType: "road.highway",
						elementType: "geometry.stroke",
						stylers: [{
							color: "#000000"
						}, {
							lightness: 29
						}, {
							weight: 0.2
						}]
					}, {
						featureType: "road.arterial",
						elementType: "geometry",
						stylers: [{
							color: "#000000"
						}, {
							lightness: 18
						}]
					}, {
						featureType: "road.local",
						elementType: "geometry",
						stylers: [{
							color: "#000000"
						}, {
							lightness: 16
						}]
					}, {
						featureType: "transit",
						elementType: "geometry",
						stylers: [{
							color: "#000000"
						}, {
							lightness: 19
						}]
					}, {
						featureType: "water",
						elementType: "geometry",
						stylers: [{
							color: "#000000"
						}, {
							lightness: 17
						}]
					}],
					zoom: 13,
					scrollwheel: false,
					draggable: true
				}
			},
			marker: {
				address: userMarker,
				data: userInfo,
				options: {
					icon: "https://cdn.shopify.com/s/files/1/1200/3934/files/Marker-ISL-color-sm.png?15307446976746799811"
				},
				events: {
					click: function(marker, event, context) {
						var map = $(this).gmap3("get"),
							infowindow = $(this).gmap3({
								get: {
									name: "infowindow"
								}
							});
						if (infowindow) {
							infowindow.open(map, marker);
							infowindow.setContent(context.data);
						} else {
							$(this).gmap3({
								infowindow: {
									anchor: marker,
									options: {
										content: context.data
									}
								}
							});
						}
					}
				}
			}
		});
		// Google Map 3
		$(".map-style-3").gmap3({
			map: {
				address: userAddress,
				options: {
					styles: [{
						stylers: [{
							"saturation": -20
						}, {
							"gamma": 1.2
						}, {
							"lightness": 10
						}]
					}],
					zoom: 11,
					scrollwheel: false,
					draggable: true
				}
			},
			marker: {
				address: userMarker,
				data: userInfo,
				options: {
					icon: "https://cdn.shopify.com/s/files/1/1200/3934/files/Marker-ISL-color-sm.png?15307446976746799811"
				}, 
				events: {
					click: function(marker, event, context) {
						var map = $(this).gmap3("get"),
							infowindow = $(this).gmap3({
								get: {
									name: "infowindow"
								}
							});
						if (infowindow) {
							infowindow.open(map, marker);
							infowindow.setContent(context.data);
						} else {
							$(this).gmap3({
								infowindow: {
									anchor: marker,
									options: {
										content: context.data
									}
								}
							});
						}
					}
				}
			}
		});
	}
	$(function() {
		var s = document.createElement("script");
		s.src = 'https://maps.google.com/maps/api/js?key=AIzaSyAQdGWN3X7wB8VK7W0yuUmMcvwwa5qG9oM&callback=initialize';
		document.body.appendChild(s);
	});
}